import {CdkDrag, CdkDragEnd, CdkDragHandle, CdkDragStart} from '@angular/cdk/drag-drop';
import {CurrencyPipe, DatePipe, DecimalPipe, formatNumber} from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    DEFAULT_CURRENCY_CODE,
    DoCheck,
    ElementRef,
    HostListener,
    Inject,
    LOCALE_ID,
    NgZone,
    OnDestroy,
    OnInit,
    QueryList,
    TemplateRef,
    ViewChild,
    ViewChildren,
} from '@angular/core';
import {
    AsyncValidatorFn,
    FormArray,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
    ɵFormGroupValue,
} from '@angular/forms';
import {MatButtonToggle, MatButtonToggleChange} from '@angular/material/button-toggle';
import {MatLegacyDialog, MatLegacyDialogRef} from '@angular/material/legacy-dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';

import {Actions, ofType} from '@ngrx/effects';
import {Dictionary} from '@ngrx/entity';
import {Store} from '@ngrx/store';
import moment, {Moment} from 'moment';
import {ToastrService} from 'ngx-toastr';
import {
    BehaviorSubject,
    combineLatest,
    defer,
    firstValueFrom,
    from,
    merge,
    mergeAll,
    Observable,
    of, pipe,
    ReplaySubject,
    Subject,
    Subscription,
    timer,
    zip,
} from 'rxjs';
import {
    debounceTime,
    delay,
    distinctUntilChanged,
    filter,
    first,
    map,
    pairwise,
    shareReplay,
    skip,
    skipWhile,
    startWith,
    switchMap,
    take,
    takeUntil,
    tap,
    withLatestFrom,
} from 'rxjs/operators';
import {getEmployeesActiveSortedByNameStartWithMe,} from 'src/app/dave-data-module/State/selectors/employees.selectors';
import {
    AccountsReceivableLedgerEntity,
    AccountsReceivableLedgerTypeEnum,
    ARLTypeEnumNames,
    financialRound,
    isBookingPositionTypeEnum,
} from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import {CommissionEntity} from '../../../dave-data-module/entities/commission.entity';
import {CustomerEntity} from '../../../dave-data-module/entities/customer.entity';
import {
    compareLedgerImportPaymentItems,
    DEFAULT_INVOICE_NK,
    DEFAULT_INVOICE_NK_GEWERKE,
    DocumentStatusEnum,
    getDueDateFromLedgerImportDocumentType,
    LedgerImportAdditionalData, LedgerImportARLCalculationPreChargeByType,
    LedgerImportARLSurchargesByType,
    LedgerImportBreakPageModeEnum,
    LedgerImportDocumentTypeDateLabel,
    LedgerImportDocumentTypeNames,
    LedgerImportDocumentTypeNumberLabel,
    LedgerImportDocumentTypes,
    LedgerImportDocumentTypeShortDateLabel,
    LedgerImportEntity,
    LedgerImportGaebFileTypes,
    LedgerImportPaymentItem,
    LedgerImportPaymentItemToString,
    LedgerImportStatusEnum,
} from '../../../dave-data-module/entities/ledger-import.entity';
import {PartnerTypeEnum} from '../../../dave-data-module/entities/partner.entity';
import {PartnerOfficeEntity} from '../../../dave-data-module/entities/partnerOffice.entity';
import {PersonEntity} from '../../../dave-data-module/entities/person.entity';
import {Person2EntityEntityTypeEnum} from '../../../dave-data-module/entities/person2entity.entity';
import {PublicFileTypeEnum} from '../../../dave-data-module/entities/public-file.entity';
import {QuantityTypeEntity, QuantityTypeNames} from '../../../dave-data-module/entities/quantity-type.entity';
import {SfdtTemplateEntity} from '../../../dave-data-module/entities/sfdt-template.entity';
import {UserEntity} from '../../../dave-data-module/entities/user.entity';
import {
    AccountsReceivableLedgerPostType,
    DaveMutationChangeLedgerImportArgs,
} from '../../../dave-data-module/graphql-types';
import {AccountsReceivableLedgerResolver} from '../../../dave-data-module/guards/accounts-receivable-ledger.resolver';
import {EventResolver} from '../../../dave-data-module/guards/event.resolver';
import {LedgerImportResolver} from '../../../dave-data-module/guards/ledger-import.resolver';
import {ComponentCanDeactivate} from '../../../dave-data-module/guards/pending-changes.guard';
import {Person2EntityResolver} from '../../../dave-data-module/guards/person2Entity.resolver';
import {PublicFileResolver} from '../../../dave-data-module/guards/public-file.resolver';
import {
    FrontendDate,
    gzipCompress,
    Uint8ToString,
    useGzip,
} from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import {getFetched$} from '../../../dave-data-module/helper/helper';
import {AppGatewayService} from '../../../dave-data-module/services/app-gateway.service';
import {ArlDataService} from '../../../dave-data-module/services/arl-data.service';
import {FileDataService} from '../../../dave-data-module/services/file-data.service';
import {HttpService} from '../../../dave-data-module/services/http.service';
import {LedgerImportDataService} from '../../../dave-data-module/services/ledger-import-data.service';
import {State} from '../../../dave-data-module/State';
import {
    AccountsReceivableLedgerActionTypes,
    LedgerImportActionTypes,
} from '../../../dave-data-module/State/actions/accounting.actions';
import {BaseActionTypes} from '../../../dave-data-module/State/actions/base.actions';
import {CommissionActionTypes} from '../../../dave-data-module/State/actions/commission.actions';
import {
    PublicFileActionTypes,
    PublicFileUploadParams,
} from '../../../dave-data-module/State/actions/public-file.actions';
import {
    getQuantityTypeDictionary,
    getQuantityTypes,
    getSfdtTemplates,
} from '../../../dave-data-module/State/selectors/accounting.selector';
import {getToken} from '../../../dave-data-module/State/selectors/base.selectors';
import {
    getCommissionById,
    getCommissionDictionary,
    getCommissions,
    getCommissionSorted,
} from '../../../dave-data-module/State/selectors/commission.selector';
import {getEventById, getEventFetched} from '../../../dave-data-module/State/selectors/events.selectors';
import {
    getDefaultVat,
    getOwnPartnerOffices,
    getPartner,
    getPartnerOffices,
} from '../../../dave-data-module/State/selectors/partners.selectors';
import {getPersons} from '../../../dave-data-module/State/selectors/person.selectors';
import {getPerson2Entities} from '../../../dave-data-module/State/selectors/person2entity.selectors';
import {
    getPublicFilesActive,
    getPublicFilesFetched,
} from '../../../dave-data-module/State/selectors/public-file.selectors';
import {
    getSurchargeRateDictionary,
    surChargeForArlType,
} from '../../../dave-data-module/State/selectors/surcharge-rate.selector';
import {getUsers} from '../../../dave-data-module/State/selectors/users.selectors';
import {
    SetQuantityDialogGaebComponent,
    SetQuantityDialogGaebComponentDialogData,
    SetQuantityDialogGaebComponentDialogReturnData,
} from '../../../dave-dms-module/dave-dms/set-quantity-dialog-gaeb/set-quantity-dialog-gaeb.component';
import {
    EmailEditorComponent,
    EmailEditorComponentDialogConfig,
    EmailEditorComponentDialogData,
} from '../../../dave-email-module/components/email-editor/email-editor.component';
import {
    DetailTasksComponent,
    DetailTasksComponentDialogData,
} from '../../../dave-event-card/components/detail-tasks/detail-tasks.component';
import {
    SelectFolderDialogComponent,
    SelectFolderDialogComponentDialogData,
    SelectFolderDialogComponentDialogReturnData,
} from '../../../dave-file-explorer/components/select-folder-dialog/select-folder-dialog.component';
import {
    DaveSelectFileFromDmsComponent,
    DaveSelectFileFromDmsComponentDialogData,
    DaveSelectFileFromDmsComponentReturnData,
} from '../../../dave-select-file-from-dms/components/dave-select-file-from-dms/dave-select-file-from-dms.component';
import {
    AppConfirmationDialogComponent,
    AppConfirmationDialogData,
    AppConfirmationDialogReturnData,
} from '../../../dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import {AppDialogService} from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import {
    FILTER_TYPE_BOOLEAN,
    FILTER_TYPE_SEARCH_SELECT_BACKEND,
    FilterOption,
    FilterOptionSelectSearch,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
    IDetailListTemplateData,
    IDetailListTemplateDataProperty,
} from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/detail-list-template/detail-list-template.component';
import {
    CustomPropertyType,
} from '../../../dave-utils-module/dave-shared-components-module/components/detail-views/profile-template/profile-template.component';
import {
    BreakpointObserverService,
} from '../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import {PermissionService,} from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import {
    SelectSearchOption,
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import {
    blobToBase64,
    compareArrays,
    compareEqualityAsJsonString,
    currencyValues,
    escapeRegExp,
    getEnumKeys,
    getImageDimensionsFromBase64,
    getValueChangesObservableFromFormGroup,
    isNotNullOrUndefined,
    Require,
    TableColumnConfig,
    uniqArray,
} from '../../../helper/helper';
import * as ibbau from '../../../helper/ibbau.helper';
import {
    AllEventsMeta,
    AllReportsMeta,
    BookingPositionMetaIcon,
    CommissionMeta,
    CustomerAdministrationMeta,
    DMSPageMeta,
    HistoryMeta,
    InvoiceEditorMeta,
    MaterialPageMeta,
    ReportsPageMeta, ResourcePageMeta,
    TaskPageMeta,
} from '../../../helper/page-metadata';
import {Base64Logo, transparentPixelLogo} from '../../../helper/sfdt.helper';
import * as tsb from '../../../helper/tsb.helper';
import {
    NewCommissionDialogComponent,
    NewCommissionDialogComponentDialogData,
    NewCommissionDialogComponentDialogReturnData,
} from '../../../new-commission-dialog/new-commission-dialog.component';
import {CommissionWizardDialogService} from '../../../services/commission-wizard-dialog.service';
import {CustomLabelService} from '../../../services/custom-label/custom-label.service';
import {FilterTypes} from '../../../services/default-filter.service';
import {LoadingService} from '../../../services/loading.service';
import {SfdtTemplateService} from '../../../services/sfdt-template.service';
import {
    _getArlChildren,
    ARL_DEFAULT_VALUES,
    calculateConsolidatedAmount,
    emptyAllowanceChargeForm,
    getBookingPositionTwigVariables,
    getLedgerImportStatusChangeMutationPayload, invoiceEditorAutoScrollSpeed,
    setAllowanceChargesFormSums,
} from '../arl-calculation/arl-calculation.helper';
import {ArlFormDataService, arlTableDataArlForm} from '../arl-calculation/arl-form-data.service';
import {
    ArlPositionDialogComponent,
    ArlPositionDialogComponentDialogData,
    ArlPositionDialogComponentDialogReturnData,
} from '../arl-calculation/arl-position-dialog/arl-position-dialog.component';
import {
    ArlTableComponent,
    arlTableData,
    determineIfIsArlTableDataOrGroupEnd,
} from '../arl-calculation/arl-table/arl-table.component';

import {
    NewBookingOptionComponent,
    NewBookingOptionComponentReturnType,
    NewOptionDialogData,
} from '../new-booking-option/new-booking-option.component';
import {
    NewClosingInvoiceComponent,
    NewClosingInvoiceComponentDialogData,
    NewClosingInvoiceComponentDialogReturnData,
} from '../new-closing-invoice/new-closing-invoice.component';
import {
    NewOrderFromLedgerimportComponent,
    NewOrderFromLedgerimportDialogData,
    NewOrderFromLedgerimportDialogReturnData,
} from '../new-order-from-ledgerimport/new-order-from-ledgerimport.component';
import {
    NewPartialInvoiceComponent,
    NewPartialInvoiceComponentDialogData,
    NewPartialInvoiceComponentDialogReturnData,
} from '../new-partial-invoice/new-partial-invoice.component';
import * as mjsHelper from '../../../helper/math-js-helper';
import {MatDialogState} from '@angular/material/dialog';
import {PageEvent} from '@angular/material/paginator';
import {MatDrawer} from '@angular/material/sidenav';
import {
    EntityType,
    GabeType,
    GaebFileType,
    IsConsolidatedInvoiceIdAvailableRequest,
    LedgerImportToPriceComparisonAddRequest,
    LedgerImportToPriceComparisonEditRequest,
    PriceComparison,
    PriceComparisonAddRequest,
    PriceComparisonDeleteRequest,
    PriceComparisonEditRequest,
} from '@dave/types';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import * as Sentry from '@sentry/angular';
import {getBusinessVolumeTypeNameForInvoices} from '../../../dave-data-module/entities/business-volume.entity';
import {FileEntity} from '../../../dave-data-module/entities/file.entity';
import {FolderTypes} from '../../../dave-data-module/entities/folder.entity';
import {MaterialEntity} from '../../../dave-data-module/entities/material.entity';
import {ResourceEntity} from '../../../dave-data-module/entities/resource-dispo/resource.entity';
import {FolderDataService} from '../../../dave-data-module/services/folder-data.service';
import {InvoicingDataService} from '../../../dave-data-module/services/invoicing-data.service';
import {PaginatedMaterialService} from '../../../dave-data-module/services/paginated-material.service';
import {
    DaveFilePreviewComponent,
    DaveFilePreviewComponentDialogData,
} from '../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import {TableConfigFormComponent} from '../../../table-config-form/table-config-form.component';
import {ArlCalculationDataService} from '../arl-calculation/arl-calculation-data.service';
import {ArlLvCalculationComponent} from '../arl-calculation/arl-lv-calculation/arl-lv-calculation.component';
import {ArlTableService} from '../arl-calculation/arl-table.service';
import {
    calculationArlForm,
    CalculationArlFormDataService,
    calculationArlFormGroup,
} from '../arl-calculation/calculation-arl-form-data.service';
import {
    ChangeTaxDialogComponent,
    ChangeTaxDialogReturnData,
    ChangeTaxOption,
} from '../change-tax-dialog/change-tax-dialog.component';
import {
    PendingLedgerimportDocumentCreationDialogComponent,
    PendingLedgerimportDocumentCreationDialogComponentDialogData,
    PendingLedgerimportDocumentCreationDialogComponentDialogReturnData,
} from '../pending-ledgerimport-document-creation-dialog/pending-ledgerimport-document-creation-dialog.component';
import {
    SelectGaebArlDataComponent,
    SelectGaebArlDataComponentDialogData,
    SelectGaebArlDataComponentDialogReturnData,
} from '../select-gaeb-arl-data/select-gaeb-arl-data.component';
import {
    SelectSupplierDialogComponent,
    SelectSupplierDialogData,
    SelectSupplierDialogReturnData,
} from '../select-supplier-dialog/select-supplier-dialog.component';
import {MatLegacyCheckboxChange} from '@angular/material/legacy-checkbox';
import {
    RequirementTableDialogComponent,
    RequirementTableDialogComponentDialogData,
} from '../requirement-table-dialog/requirement-table-dialog.component';
import {MathJsCustomScopeService} from '../../../services/math-js-custom-scope.service';
import {SelectArlDialogService} from '../select-arl-dialog/select-arl-dialog.service';
import {
    PositionValuePriceComparison,
    PriceComparisonBaseItem,
    PriceComparisonComponent,
    PriceComparisonComponentDialogData,
    PriceComparisonComponentDialogReturnData,
} from '../arl-calculation/price-comparison/price-comparison.component';
import {
    LedgerImportToPriceComparisonDataService,
} from '../../../dave-data-module/services/ledger-import-to-price-comparison.service';
import {PriceComparisonDataService} from '../../../dave-data-module/services/price-comparison.service';
import {getErrorMessage} from '../../../helper/validation.helper';
import {
    getTaxTypeById,
    getTaxTypes,
    getTaxTypesActive,
} from '../../../dave-data-module/State/selectors/tax-type.selectors';
import {TaxTypeEntity} from '../../../dave-data-module/entities/tax-type.entity';
import {QrCodeService} from '../../../services/qr-code.service';
import {
    recalculateItemNumbersFromLvTableItems
} from '../arl-calculation/arl-lv-calculation/arl-lv-calculation-datasource';
import {CustomerDataService, CustomerSearchState} from '../../../dave-data-module/services/customer-data.service';
import {ItemNumberInformation} from '../duplicate-positions-dialog/duplicate-positions-dialog.component';
import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { GermanPaginatorIntl } from '../../../services/german-paginator-intl.service';
import { TextTemplateResolver } from '../../../dave-data-module/guards/text-template.resolver';
import {
    addTemplate,
    TemplateDialogComponent, TemplateDialogComponentData, TemplateDialogComponentDataReturnData,
} from '../../../dave-utils-module/dave-shared-components-module/components/template-dialog/template-dialog.component';
import { TextareaComponent } from '../../../components/templates/textarea/textarea.component';

interface DisplayPartnerOfficeType {
    detailListData: IDetailListTemplateData;
    logoUrl: string | null;
    headline: string;
    emailSignature: string;
}

export interface ExportButton {
    type: LedgerImportGaebFileTypes;
    label: string;
    code: 'x83' | 'x84' | 'ugl' | 'onlv' | 'p83' | 'p84' | 'd83' | 'd84' | 'dta';
    tooltip: string;
}

const statusIsReadOnly = (Status: LedgerImportStatusEnum) => Status === LedgerImportStatusEnum.Storniert || Status === LedgerImportStatusEnum.Verrechnet || Status === LedgerImportStatusEnum.AngebotAkzeptiert;
export type addArlDragButtonType =
    'group'
    | 'text'
    | 'arl'
    | 'resource-arl'
    | 'material-arl'
    | 'fremdleistung-arl'
    | 'salary-arl'
    | 'other-arl';
// ToDo: enum benutzen LedgerImportColumnsNamesInDocumentEnum
export type ArlTableComponentDisplayedColumns =
    'Position'
    | 'BookingText'
    | 'Information'
    | 'Quantity'
    | 'QuantityType'
    | 'BaseCost'
    | 'BaseCostGross'
    | 'CompleteCost'
    | 'CompleteCostGross'
    | 'BaseCost_salary'
    | 'BaseCost_other'
    | 'BaseCost_salary_cost'
    | 'BaseCost_other_cost'
    | 'BaseCost_cost'
    | 'BaseCostGross_cost';
export const ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED: Array<ArlTableComponentDisplayedColumns> = [
    'Position',
    'BookingText',
    'Information',
    'Quantity',
    'QuantityType',
    'BaseCost_salary',
    'BaseCost_salary_cost',
    'BaseCost_other',
    'BaseCost_other_cost',
    'BaseCost_cost',
    'BaseCost',
    'BaseCostGross_cost',
    'BaseCostGross',
    'CompleteCost',
    'CompleteCostGross',
];
export const ARL_TABLE_AUTO_COLUMN_HEADERS: { [key in ArlTableComponentDisplayedColumns]: string } = {
    BookingText: 'Art-Nr.',
    Information: 'Bezeichnung',
    BaseCost: 'Preis (netto)',
    BaseCostGross: 'Preis (brutto)',
    Quantity: 'Menge',
    QuantityType: 'Einheit',
    CompleteCost: 'Summe (netto)',
    CompleteCostGross: 'Summe (brutto)',
    Position: 'Pos.',
    BaseCost_salary: 'Lohn',
    BaseCost_other: 'Sonstiges',
    BaseCost_salary_cost: 'Lohn EK',
    BaseCost_other_cost: 'Sonstiges EK',
    BaseCost_cost: 'Preis (netto) EK',
    BaseCostGross_cost: 'Preis (brutto) EK',
};
const preChargesForLv: Record<AccountsReceivableLedgerTypeEnum, boolean> = {
    [AccountsReceivableLedgerTypeEnum.Arl]: false,
    [AccountsReceivableLedgerTypeEnum.EmployeeArl]: true,
    [AccountsReceivableLedgerTypeEnum.ExternalService]: true,
    [AccountsReceivableLedgerTypeEnum.Group]: false,
    [AccountsReceivableLedgerTypeEnum.Other]: false,
    [AccountsReceivableLedgerTypeEnum.ResourceArl]: true,
    [AccountsReceivableLedgerTypeEnum.MaterialArl]: true,
    [AccountsReceivableLedgerTypeEnum.Text]: false,
}
const preChargeUsedInLv = (type: AccountsReceivableLedgerTypeEnum) => {
    return preChargesForLv[type];
}
const aRLSurChargeByTypeForLv: Record<AccountsReceivableLedgerTypeEnum, boolean> = {
    [AccountsReceivableLedgerTypeEnum.Arl]: false,
    [AccountsReceivableLedgerTypeEnum.EmployeeArl]: true,
    [AccountsReceivableLedgerTypeEnum.ExternalService]: true,
    [AccountsReceivableLedgerTypeEnum.Group]: false,
    [AccountsReceivableLedgerTypeEnum.Other]: true,
    [AccountsReceivableLedgerTypeEnum.ResourceArl]: true,
    [AccountsReceivableLedgerTypeEnum.MaterialArl]: true,
    [AccountsReceivableLedgerTypeEnum.Text]: false,
}
const aRLSurChargeByTypeUsedInLv = (type: AccountsReceivableLedgerTypeEnum) => {
    return aRLSurChargeByTypeForLv[type];
}
const arlTypeEnumKeysForPreChargeByType = getEnumKeys(AccountsReceivableLedgerTypeEnum).filter((v) => isBookingPositionTypeEnum(AccountsReceivableLedgerTypeEnum[v]));
const lvKalkSurchargesByType = [
    AccountsReceivableLedgerTypeEnum.Arl,
    AccountsReceivableLedgerTypeEnum.EmployeeArl,
    AccountsReceivableLedgerTypeEnum.ExternalService,
    AccountsReceivableLedgerTypeEnum.Other,
    AccountsReceivableLedgerTypeEnum.ResourceArl,
    AccountsReceivableLedgerTypeEnum.MaterialArl,
];
@Component({
    selector: 'app-invoice-editor',
    templateUrl: './invoice-editor.component.html',
    styleUrls: ['./invoice-editor.component.scss'],
    providers: [CurrencyPipe, DatePipe, DecimalPipe, ArlFormDataService, CalculationArlFormDataService, ArlCalculationDataService, PaginatedMaterialService, ArlTableService, MathJsCustomScopeService, { provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '[id]': 'id',
    },
})
export class InvoiceEditorComponent implements OnDestroy, ComponentCanDeactivate, AfterViewInit, DoCheck {

    triggerPreview$ = new Subject<void>();
    livePreview$ = new BehaviorSubject(false);
    protected consolidatedInvoiceIdValidatorPending$ = new BehaviorSubject<boolean>(false);

    consolidatedInvoiceIdValidator(
        ledgerImport$: Observable<LedgerImportEntity>,
        docTypeName$: Observable<string>
    ): AsyncValidatorFn {
        return (control: AbstractControl) => {

            this.consolidatedInvoiceIdValidatorPending$.next(true);
            if (!control.value) {
                return of(null);
            }

            return timer(400).pipe(
                switchMap(() => combineLatest([
                    ledgerImport$.pipe(take(1)),
                    docTypeName$.pipe(take(1))
                ])),

                switchMap(([li, docType]) => {

                    const payload: IsConsolidatedInvoiceIdAvailableRequest = {
                        ConsolidatedInvoiceId: control.value,
                        PartnerOfficeId: li.PartnerOfficeId.toString(),
                        CurrentLedgerImportId: li.Id.toString(),
                    };

                    return from(
                        this.ledgerImportDataService.getConsoliadatedInvoiceIdAvailable(
                            payload,
                            docType + 'snummer/ -bezeichnung'
                        ).finally(() => this.consolidatedInvoiceIdValidatorPending$.next(false))
                    );
                }),

                map((available: boolean): ValidationErrors | null => {
                    if (!available) {
                        control.markAsTouched();
                    }
                    return available
                        ? null
                        : {consolidatedInvoiceIdNotAvailable: true};
                })
            );
        };
    }

    static nextId = 0;
    protected id = `app-invoice-editor-${InvoiceEditorComponent.nextId++}`;

    @ViewChild('formWrapper') formWrapper!: ElementRef;

    @ViewChild('arlTableComponent') arlTableComponent: ArlTableComponent;
    @ViewChild('arlLvCalculationComponent') protected arlLvCalculationComponent: ArlLvCalculationComponent;

    @ViewChild('previewIframe') private previewIframe: ElementRef<HTMLIFrameElement>;
    @ViewChildren(CdkDragHandle) handles: QueryList<CdkDragHandle>;
    @ViewChildren(CdkDrag) drags: QueryList<CdkDrag>;

    public LvFilterValues$: BehaviorSubject<{
        [FilterTypes.Gaps]: boolean;
        [FilterTypes.UnfilledGaps]: boolean;
        [FilterTypes.FilledGaps]: boolean;
        [FilterTypes.WithoutPrices]: boolean;
    }> = new BehaviorSubject({
        [FilterTypes.Gaps]: false,
        [FilterTypes.UnfilledGaps]: false,
        [FilterTypes.FilledGaps]: false,
        [FilterTypes.WithoutPrices]: false,
    });

    ngDoCheck$ = new Subject<void>();
    public LiDocTypeOptions = Object.values(LedgerImportDocumentTypes)
        .filter((x) => typeof x === 'string')
        .map((v: LedgerImportDocumentTypes) => ({
            type: v,
            label: LedgerImportDocumentTypeNames.get(v),
        }));
    public DMSPageMeta = DMSPageMeta;
    public CommissionMeta = CommissionMeta;
    public CustomerAdministrationMeta = CustomerAdministrationMeta;
    public IsMobile$: Observable<boolean>;

    public LedgerImportDocumentTypeNames = LedgerImportDocumentTypeNames;
    public LedgerImportDocumentTypes = Object.keys(LedgerImportDocumentTypes).map((key) => LedgerImportDocumentTypes[key]);
    public LedgerImportDocumentTypesEnum = LedgerImportDocumentTypes;
    public LedgerImportGaebFileTypesEnum = LedgerImportGaebFileTypes;
    public NewBookingPositionClick$: Subject<void> = new Subject<void>();
    public BookingPositionMetaIcon = BookingPositionMetaIcon;
    public ReportsPageMeta = ReportsPageMeta;
    public InvoiceEditorMeta = InvoiceEditorMeta;
    public FormData: Observable<IDetailListTemplateData>;
    public AddressFormData: IDetailListTemplateData;
    public DeliveryAddressFormData: IDetailListTemplateData;
    public NotesFormData: IDetailListTemplateData;
    public CustomerData: Observable<IDetailListTemplateData>;
    public AssignedEmployeeData: Observable<IDetailListTemplateData>;
    public PartnerOfficeData$: Observable<IDetailListTemplateData>;
    public recipientPersonData$: Observable<PersonEntity[]>;
    public PartnerDetailData: IDetailListTemplateData;
    public UserDetailData: IDetailListTemplateData;
    public FooterFormData: IDetailListTemplateData;
    public StatusData$: Observable<IDetailListTemplateData>;
    public ShowStatus = false;
    private subscriptions: Subscription[] = [];
    private afterViewInit$ = new BehaviorSubject(false);
    public PushValuesToSyncfusion$ = new Subject<void>();
    protected nothingDirty$: Observable<boolean>;
    protected forceGaebEditing$ = new BehaviorSubject(false);
    protected exportedFromGaeb$: Observable<boolean>;
    protected disableGaebRelevantForms$: Observable<boolean>;
    protected itemNumbersLocked$: Observable<boolean>;
    // public SortedBookingPositionList$ = new BehaviorSubject<Array<AccountsReceivableLedgerEntity | groupInterface>>(null);
    public OpenDeleteDialog$: Subject<void> = new Subject<void>();
    public DownloadPdfWithoutFile$ = new Subject<'xInvoice'>();
    public readonly DisableArlForms$: Observable<boolean>;
    public readonly DisableAllChanges$: Observable<boolean>;
    protected defaultSurcharges$ = this.store.select(getSurchargeRateDictionary);
    protected quantityTypeDictionary$ = this.store.select(getQuantityTypeDictionary);
    protected arlSearchQuery = '';

    downloadTypeToGaebKey: Record<'x83' | 'x83wq' | 'p83' | 'p83wq' | 'd83' | 'd83wq' | 'x84' | 'x84wq' | 'p84' | 'p84wq' | 'd84' | 'd84wq' | 'onlv' | 'onlvwq' | 'ugl' | 'uglwq' | 'dta' | 'dtawq', string> = {
        x83: 'GabeOfferRequest',
        x83wq: 'GabeOfferRequestWQ',
        p83: 'GabeOfferRequestP',
        p83wq: 'GabeOfferRequestWQP',
        d83: 'GabeOfferRequestD',
        d83wq: 'GabeOfferRequestWQD',
        x84: 'GabeOffer',
        x84wq: 'GabeOfferWQ',
        p84: 'GabeOfferP',
        p84wq: 'GabeOfferWQP',
        d84: 'GabeOfferD',
        d84wq: 'GabeOfferWQD',
        ugl: 'Ugl',
        uglwq: 'UglWQ',
        onlv: 'Oenorm',
        onlvwq: 'OenormWQ',
        dta: 'OenormWQDTA',
        dtawq: 'OenormDTA',
    };

    downloadTypeToGaebType: Record<'x83' | 'x83wq' | 'x84' | 'x84wq' | 'ugl' | 'uglwq' | 'p84' | 'p84wq' | 'd84' | 'd84wq' | 'onlv' | 'onlvwq' | 'p83' | 'p83wq' | 'd83' | 'd83wq' | 'dta' | 'dtawq', GabeType> = {
        x83: GabeType.GabeOfferRequest,
        x83wq: GabeType.GabeOfferRequest,
        x84: GabeType.GabeOffer,
        x84wq: GabeType.GabeOffer,
        p83: GabeType.GabeOfferRequest,
        p83wq: GabeType.GabeOfferRequest,
        p84: GabeType.GabeOffer,
        p84wq: GabeType.GabeOffer,
        d83: GabeType.GabeOfferRequest,
        d83wq: GabeType.GabeOfferRequest,
        d84: GabeType.GabeOffer,
        d84wq: GabeType.GabeOffer,
        ugl: GabeType.Ugl,
        uglwq: GabeType.Ugl,
        onlvwq: GabeType.Oenorm,
        onlv: GabeType.Oenorm,
        dta: GabeType.Oenorm,
        dtawq: GabeType.Oenorm,
    };

    downloadFileTypeTypeToGaebType: Record<'x83' | 'x83wq' | 'x84' | 'x84wq' | 'ugl' | 'uglwq' | 'p84' | 'p84wq' | 'd84' | 'd84wq' | 'onlv' | 'onlvwq' | 'p83' | 'p83wq' | 'd83' | 'd83wq' | 'dta' | 'dtawq', GaebFileType> = {
        x83: GaebFileType.GaebXml,
        x83wq: GaebFileType.GaebXml,
        x84: GaebFileType.GaebXml,
        x84wq: GaebFileType.GaebXml,
        p83: GaebFileType.Gaeb2000,
        p83wq: GaebFileType.Gaeb2000,
        p84: GaebFileType.Gaeb2000,
        p84wq: GaebFileType.Gaeb2000,
        d83: GaebFileType.Gaeb90,
        d83wq: GaebFileType.Gaeb90,
        d84: GaebFileType.Gaeb90,
        d84wq: GaebFileType.Gaeb90,
        ugl: GaebFileType.UglFT,
        uglwq: GaebFileType.UglFT,
        onlvwq: GaebFileType.OenormFT,
        onlv: GaebFileType.OenormFT,
        dta: GaebFileType.Oenorm_B2063,
        dtawq: GaebFileType.Oenorm_B2063,
    };

    allExportButtons: ExportButton[] = [
        {
            type: LedgerImportGaebFileTypes.GaebXml,
            label: 'X83 Datei',
            code: 'x83',
            tooltip: 'X83 GAEB Angebotsdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.GaebXml,
            label: 'X84 Datei',
            code: 'x84',
            tooltip: 'X84 GAEB Bieterdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.Gaeb2000,
            label: 'P83 Datei',
            code: 'p83',
            tooltip: 'P83 GAEB Angebotsdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.Gaeb2000,
            label: 'P84 Datei',
            code: 'p84',
            tooltip: 'P84 GAEB Bieterdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.Gaeb90,
            label: 'D83 Datei',
            code: 'd83',
            tooltip: 'D83 GAEB Angebotsdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.Gaeb90,
            label: 'D84 Datei',
            code: 'd84',
            tooltip: 'D84 GAEB Bieterdatei herunterladen'
        },
        {
            type: LedgerImportGaebFileTypes.UglFT,
            label: 'UGL Datei',
            code: 'ugl',
            tooltip: 'UGL Mengendatei herunterladen'
        },
        {type: LedgerImportGaebFileTypes.OenormFT, label: 'Onlv Datei', code: 'onlv', tooltip: 'ÖNorm herunterladen'},
        {
            type: LedgerImportGaebFileTypes.Oenorm_B2063,
            label: 'DTA Datei',
            code: 'dta',
            tooltip: 'DTA Datei herunterladen'
        },
    ];

    protected recipientPersonForm: FormControl<PersonEntity> = new FormControl<PersonEntity>(null);
    protected recipientCustomerForm = new FormControl<CustomerEntity>(null);

    previewCard: null | 'pdf' | 'calculation' = null;
    protected InfoiceFormGroupinitialised$ = new BehaviorSubject<boolean>(false);

    /**
     * InfoiceFormGroupSetValue ist ein fix, beim ersten mal speichern wird scheinbar das FormControl kaputt gemacht oder ausgetauscht,
     * daher muss dieses observable einen neuen wert ausgeben, mit dem aktuellen form control, auf dem auch die subscriptions hören
     */
    protected InfoiceFormGroupSetValue$ = new Subject<void>();
    public InfoiceFormGroup = new FormGroup({
        AutomaticNr: new FormControl<boolean | null>(null),
        CommissionId: new FormControl<SelectSearchOption<CommissionEntity> | null>(null),
        Customer: new FormControl<SelectSearchOption<CustomerEntity> | null>(null),
        AssignedUser: new FormControl<SelectSearchOption<UserEntity> | null>(null),
        PartnerOffice: new FormControl<SelectSearchOption<PartnerOfficeEntity> | null>(null),
        DeliveryDate: new FormControl<Moment | null>(null),
        DueDate: new FormControl<Moment | null>(null),
        InvoiceDate: new FormControl<Moment | null>(null, Validators.required),
        TextTop: new FormControl<string | null>(null),
        TextBottom: new FormControl<string | null>(null),
        // BookingPositions: new FormControl<Array<AccountsReceivableLedgerEntity | groupInterface> | null>(null),
        AccountsReceivableLedgerIds: new FormControl<Array<number>>([]),
        ConsolidatedInvoiceId: new FormControl<string | null>(
            null,
            {
                validators: [Validators.required],
                asyncValidators: [
                    this.consolidatedInvoiceIdValidator(
                        defer(() => this.LedgerImport$),
                        defer(() => this.LedgerImportDocTypeName$),
                    )
                ],
                updateOn: 'change'
            }
        ),
        CustomerName: new FormControl<string | null>(null),
        CustomerStreet: new FormControl<string | null>(null),
        CustomerCity: new FormControl<string | null>(null),
        CustomerPostalCode: new FormControl<string | null>(null),
        CustomerCountry: new FormControl<string | null>(null),
        CustomerEmail: new FormControl<string | null>(null),
        CustomerNumber: new FormControl<string | null>(null),
        CustomerUstId: new FormControl<string | null>(null),
        DeliveryName: new FormControl<string | null>(null),
        DeliveryStreet: new FormControl<string | null>(null),
        DeliveryPostalCode: new FormControl<string | null>(null),
        DeliveryCity: new FormControl<string | null>(null),
        UseDeliveryAddressFromCommission: new FormControl<boolean>(false),
        PartnerCountry: new FormControl<string | null>(null),
        PartnerEmail: new FormControl<string | null>(null),
        PartnerPhoneNumber: new FormControl<string | null>(null),
        PartnerName: new FormControl<string | null>(null),
        PartnerStreet: new FormControl<string | null>(null),
        PartnerCity: new FormControl<string | null>(null),
        PartnerPostalCode: new FormControl<string | null>(null),
        Status: new FormControl<LedgerImportStatusEnum | null>(null, Validators.required),
        Bankname: new FormControl<string | null>(null),
        Bic: new FormControl<string | null>(null),
        Blz: new FormControl<string | null>(null),
        Iban: new FormControl<string | null>(null),
        UstId: new FormControl<string | null>(null),
        UserEmail: new FormControl<string | null>(null),
        UserName: new FormControl<string | null>(null),
        LogoBase64: new FormControl<Base64Logo | null>(null),
        SkontoAvilable: new FormControl<boolean | null>(null),
        SkontoPercentage: new FormControl<number | null>(null, [Validators.required, Validators.min(0), Validators.max(100)]),
        SkontoDays: new FormControl<number | null>(null, [Validators.required, Validators.min(0)]),
        DiscountPercentage: new FormControl<number | null>(null, [Validators.min(0), Validators.max(100)]),
        Notes: new FormControl<string | null>(null),
        OurSign: new FormControl<string | null>(null), //hafer
        // DicountAmount: [null, [Validators.min(0)]],
        CeoName: new FormControl<string | null>(null),
        RegistryCourt: new FormControl<string | null>(null),
        CommercialRegister: new FormControl<string | null>(null),
        CommissionNumber: new FormControl<string | null>(null),
        ShowNettoSum: new FormControl<boolean>(false),
        TaxTypeId: new FormControl<number | null>(null),
        ArlTableDisplayedColumns: new FormControl<Array<ArlTableComponentDisplayedColumns>>(null),
        ShowTaxSum: new FormControl<boolean>(false),
        Title: new FormControl<string>(null),
        UserPhoneNumber: new FormControl<string>(null),
        DeliveryTime: new FormControl<string>(null),
        ServicePeriod: new FormControl<string>(null),
        TextBottomFirst: new FormControl<string>(null),
        ArlTableStartOnNewPage: new FormControl<boolean>(null),
        ShowTextBottomFirst: new FormControl<boolean>(null),
        ConsolidatedDeliveryDate2: new FormControl<Moment>(null),
        AllowanceCharges: new FormArray<
            FormGroup<{
                percentage: FormControl<number | null>;
                amount: FormControl<number | null>;
                customReason: FormControl<string>;
                sum: FormControl<number | null>;
                usePercentage: FormControl<boolean | null>
            }>
        >([]),
        ARLCalculationPreChargeByTypes: new FormArray<FormGroup<{
            percentage: FormControl<number | null>;
            arlType: FormControl<AccountsReceivableLedgerTypeEnum>
        }>>(arlTypeEnumKeysForPreChargeByType.map((arlTypeKey) => new FormGroup({
            percentage: new FormControl<number | null>(null),
            arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(AccountsReceivableLedgerTypeEnum[arlTypeKey]),
        }))),
        ARLCalculationGlobalPreCharge: new FormControl<number | null>(null),
        SkontoIsAllowance: new FormControl<boolean>(null),
        NebenKostenPercent: new FormControl<number>(null),
        EmployeeQuantityTypeId: new FormControl<number | null>(null),
        BreakPageMode: new FormControl<LedgerImportBreakPageModeEnum | null>(null),
        UseListPriceForNewMaterials: new FormControl<boolean | null>(null),
        ReviewPeriodText: new FormControl<string | null>(null),
        SkontoPeriodText: new FormControl<string | null>(null),
        UseQuantityHistory: new FormControl<boolean | null>(null),
        PaymentItems: new FormControl<Array<LedgerImportPaymentItem> | null>(null),
        PartieStd: new FormControl<number | null>(null),
        ARLSurChargeByTypes: new FormArray<FormGroup<{
            percentage: FormControl<number | null>;
            arlType: FormControl<AccountsReceivableLedgerTypeEnum>
        }>>(lvKalkSurchargesByType.map(() => new FormGroup({
            percentage: new FormControl<number | null>(null),
            arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(null),
        }))),
        LVKalkulation: new FormGroup({
            Gewerke: new FormArray<FormControl<string>>([]),
            Nebenkosten: new FormArray<
                FormGroup<{
                    name: FormControl<string>;
                    comment: FormControl<string>;
                    gewerke: FormArray<FormControl<number>>;
                }>
            >([]),
        }),
        IsLvCalculated: new FormControl<boolean | null>(null),
        Arls: new FormArray<arlTableDataArlForm>([]),
        ARLReadOnlyModeSetByUser: new FormControl<boolean | null>(null),
        ShowLongInformation: new FormControl<boolean | null>(null),
        HideLetterHead: new FormControl<boolean | null>(null),
        ArlTableDocumentDisplayedColumns: new FormControl<Array<ArlTableComponentDisplayedColumns>>(null),
        // VariableScope: new FormControl<mjsHelper.CustomScope | null>(null),
        ShowQRCode: new FormControl<boolean | null>(null),
        PartnerAccountHolder: new FormControl<string | null>(null),
        ItemNumbersLocked: new FormControl<boolean>(false),
        InvoiceItemTableStartOnNewPage: new FormControl<boolean>(false),
        HideSumTable: new FormControl<boolean>(false),
        HidePositionsWithoutQuantity: new FormControl<boolean>(false),
    });
    private previous;
    // protected InfoiceFormGroupRawValue$ = this.InfoiceFormGroup.valueChanges.pipe(
    //     // debounceTime(200),
    //     startWith(null),
    //     map(() => {
    //         console.log('### InfoiceFormGroup.getRawValue()')
    //         const v = this.InfoiceFormGroup.getRawValue();
    //         if (this.previous) {
    //             console.log('### InfoiceFormGroup.getRawValue() differences:', Object.keys(v).filter(k => {
    //                 return JSON.stringify(v[k]) !== JSON.stringify(this.previous[k]);
    //             }).map(k => ({key: k, prev: JSON.stringify(this.previous[k]), curr: JSON.stringify(v[k])  })));
    //         }
    //         this.previous = v;
    //         return v;
    //     }),
    //     shareReplay({ refCount: true, bufferSize: 1 }),
    // );
    protected InvoiceFormGroupRawValues$: Observable<{
        CommissionId: SelectSearchOption<CommissionEntity, any>,
        Customer: CustomerEntity,
        AccountsReceivableLedgerIds: number[],
        ARLCalculationPreChargeByTypes: LedgerImportARLCalculationPreChargeByType[],
        ARLCalculationGlobalPreCharge: number,
        NebenKostenPercent: number,
        PartieStd: number,
        AllowanceCharges: {
            percentage: number,
            amount: number,
            customReason: string,
            sum: number,
            usePercentage: boolean,
        }[];
        ARLSurChargeByTypes: {percentage: number, arlType: AccountsReceivableLedgerTypeEnum,}[],
        IsLvCalculated: boolean,
    }> = this.InfoiceFormGroup.valueChanges.pipe(
        startWith(null),
        map(() => {
            return {
                CommissionId: this.InfoiceFormGroup.controls.CommissionId.getRawValue(),
                Customer: this.InfoiceFormGroup.controls.Customer.getRawValue(),
                AccountsReceivableLedgerIds: this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(),
                ARLCalculationPreChargeByTypes: this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue(),
                ARLCalculationGlobalPreCharge: this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue(),
                NebenKostenPercent: this.InfoiceFormGroup.controls.NebenKostenPercent.getRawValue(),
                PartieStd: this.InfoiceFormGroup.controls.PartieStd.getRawValue(),
                AllowanceCharges: this.InfoiceFormGroup.controls.AllowanceCharges.getRawValue(),
                ARLSurChargeByTypes: this.InfoiceFormGroup.controls.ARLSurChargeByTypes.getRawValue(),
                IsLvCalculated: this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue(),
            }
        }),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        // tap(v => {
        //     console.log('### InvoiceFormGroupRawValues$');
        //     if (this.previous) {
        //         console.log('### InvoiceFormGroupRawValues$ differences:', Object.keys(v).filter(k => {
        //             return JSON.stringify(v[k]) !== JSON.stringify(this.previous[k]);
        //         }).map(k => ({key: k, prev: JSON.stringify(this.previous[k]), curr: JSON.stringify(v[k])  })));
        //     }
        //     this.previous = v;
        // }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected ARLSurChargeByTypesFormValue$ = this.InvoiceFormGroupRawValues$.pipe(
        map((v) => v.ARLSurChargeByTypes),
        distinctUntilChanged((a, b) => a.length === b.length && a.every((item, index) => item.arlType === b[index].arlType && item.percentage === b[index].percentage))
    );
    protected BeShouldUpdateARLsFromGaebImport$ = this.InvoiceFormGroupRawValues$.pipe(map((v) => !(v.AccountsReceivableLedgerIds.length > 0 && v.IsLvCalculated)));
    protected isLvCalculated$: Observable<boolean> = getValueChangesObservableFromFormGroup(this.InfoiceFormGroup, 'IsLvCalculated').pipe(
        map((v) => !!v),
        distinctUntilChanged(),
        shareReplay({refCount: true, bufferSize: 1}),
    );

    protected employeeQuantityTypes$ = this.store.select(getQuantityTypes).pipe(map((types) => types.filter((q) => [QuantityTypeNames.Hours, QuantityTypeNames.Hours2, QuantityTypeNames.Hours3, QuantityTypeNames.Hours4, QuantityTypeNames.Minutes].includes(q.Name))));
    protected useArlSeparateSalaryBaseCost$ = this.store.select(getPartner).pipe(
        map((p) => p?.AdditionalData?.useArlSeparateSalaryBaseCost),
        distinctUntilChanged(),
    );
    protected allArlsAlreadyFaveTaxType$ = merge(this.InfoiceFormGroup.controls.TaxTypeId.valueChanges, this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.valueChanges).pipe(
        startWith(''),
        map(() => this.InfoiceFormGroup.controls.TaxTypeId.getRawValue()),
        switchMap(id => id ? this.store.select(getTaxTypeById({id})) : of(null)),
        switchMap((taxType) => {
            const taxValue = taxType?.TaxPercentage;
            console.log({taxType, taxValue});
            if (!taxType) {
                return of(false);
            }
            const arlIds = this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue();
            if (!arlIds.length) {
                return of(true);
            }
            return combineLatest(
                this.InfoiceFormGroup.getRawValue()
                    .AccountsReceivableLedgerIds.map((id) => this.arlFormDataService.getChildIds(id))
                    .flat()
                    .map((id) => this.arlFormDataService.getForm(id))
                    .filter(isNotNullOrUndefined)
                    .map((form) =>
                        merge(form.controls.Tax.valueChanges, form.controls.Type.valueChanges).pipe(
                            startWith(''),
                            map(() => ({
                                Tax: form.controls.Tax.getRawValue(),
                                Type: form.controls.Type.getRawValue(),
                            })),
                        ),
                    ),
            ).pipe(
                map((forms) => {
                    return !forms.some((value) => {
                        return value.Tax !== taxValue && isBookingPositionTypeEnum(value.Type);
                    });
                }),
            );
        }),
    );

    protected totalFromPartialInvoiceForms$: Observable<currencyValues>;
    protected otherZuschlagForLV$: Observable<number>;
    protected nkLvCalculationsurchargeNotSalary$ = new ReplaySubject<number>(1);
    protected arlSumCurrencies$: Observable<{
        withAllowanceCharges: currencyValues;
        withoutAllowanceCharges: currencyValues;
        withAllowanceChargesButScontoIgnored: currencyValues
    }>;
    protected alreadyPayedSum$: Observable<currencyValues>;
    protected alreadyPayedSumDifference$: Observable<currencyValues & { ignoreSkonto: () => currencyValues }>;
    protected showPartialInvoiceList$: Observable<boolean>;
    protected isLuksch$ = this.store.select(getPartner).pipe(
        map((partner) => partner.Id === window['env']['luksch_partner_id'] || partner.Id === window['env']['luksch_partner_id2']),
        distinctUntilChanged(),
        shareReplay({refCount: true, bufferSize: 1}),
    );
    protected useLVCalculation$ = this.store.select(getPartner).pipe(
        map((partner) => partner?.InvoiceEditorUseLVCalculation),
        distinctUntilChanged(),
    );
    protected invoiceEditorUseSalaryQuantityTypeSwitch$ = this.store.select(getPartner).pipe(
        map((partner) => partner?.AdditionalData?.invoiceEditorUseSalaryQuantityTypeSwitch),
        distinctUntilChanged(),
    );
    private changeInprogressWhileLVpending$ = new BehaviorSubject(false);
    private onDestroy$ = new Subject<void>();
    protected disableLVToggle$: Observable<boolean>;
    readonly LedgerImport$: Observable<LedgerImportEntity>;
    private arlDictFromState$: Observable<Dictionary<AccountsReceivableLedgerEntity>>;
    FilterMaterialsByCustomerId$: Observable<number | null>;
    SfdtIsDirty$: Observable<boolean>;
    private variableScopeDirty$ = new BehaviorSubject<boolean>(false);
    arlTableSomeFormDirty$ = new BehaviorSubject<boolean>(false);
    LedgerImportId: number;
    LedgerImportDocTypeName$ = new BehaviorSubject<string>('');
    public AddARLDefaultValues$: Observable<AccountsReceivableLedgerPostType>;
    private isTemplate: boolean = false;
    // public BookingPositions$: Observable<AccountsReceivableLedgerEntity[]>;
    public ShowDeleteButton$ = combineLatest([
        this.PS.Has$(this.PS.Permissions.DeleteAccountsReceivableLedgers),
        this.PS.Has$(this.PS.Permissions.DeleteAccountsReceivableLedgerTemplates),
        this.InfoiceFormGroup.controls.Status.valueChanges.pipe(startWith(null)),
    ]).pipe(
        map(([permission, permission2DeleteTemplate, stateChanged]) => {
            const currState = this.InfoiceFormGroup.controls.Status.value;
            this.LedgerImport$.pipe(take(1)).subscribe((li) => {
                this.isTemplate = li.IsTemplate;
            });
            return (permission && currState !== LedgerImportStatusEnum.Verrechnet && currState !== LedgerImportStatusEnum.Storniert) || (permission2DeleteTemplate && this.isTemplate);
        }),
    );

    public LogoUrl$ = this.InfoiceFormGroup.controls.LogoBase64.valueChanges.pipe(map((value) => value?.base64));
    personFilterSettings$: Observable<FilterOption[]> = this.cls.getSingle$('CustomerSupplier').pipe(
        map((customerLabel) => [
            {
                Name: FilterTypes.Customers,
                Type: FILTER_TYPE_SEARCH_SELECT_BACKEND,
                Label: customerLabel,
                Icon: 'id-card' as IconProp,
                SelectSearch: {
                    options$: this.personCustomerSearch.customerOptions$,
                    loading$: this.personCustomerSearch.loading$,
                    pageIndex$: this.personCustomerSearch.customerPaging.pageIndex$,
                    pageCount$: this.personCustomerSearch.customerPaging.pageCount$,

                    getIdFromValue: (customer: CustomerEntity) => customer.Id,

                    getValueFromId: (id: number) =>
                        this.customerDataService.GetSingleCustomer$(id),

                    serverSearch: (search: string) =>
                        this.personCustomerSearch.SearchCustomers(
                            search,
                            'unbenannter ' + customerLabel,
                        ),

                    pageChange: (event) =>
                        this.personCustomerSearch.customerPageChange(event),

                    compareOptions: (a: CustomerEntity, b: CustomerEntity) =>
                        a?.Id === b?.Id,
                } as FilterOptionSelectSearch<CustomerEntity>,
            },
        ]),
    );

    personFilterValues$ = new BehaviorSubject<{
        [FilterTypes.Customers]: number | null;
    }>({
        [FilterTypes.Customers]: null,
    });
    personFilterCount$ = this.personFilterValues$.pipe(map((filter) => (isNotNullOrUndefined(filter[FilterTypes.Customers]) ? 1 : undefined)));
    private invoiceTemplate: Observable<SfdtTemplateEntity>;
    protected arlTableValuesChanged$ = new Subject<void>();
    protected enableButtonAlleUeberschreiben: boolean;

    protected arlMultiselectActive = false;
    OnFileChange(event) {
        const reader = new FileReader();
        if (event.target.files && event.target.files.length) {
            const [file] = event.target.files;
            reader.readAsDataURL(file);
            reader.onload = () => {
                fetch(reader.result as string)
                    .then((res) => res.blob())
                    .then((file) => {
                        firstValueFrom(
                            this.store.select(getPublicFilesFetched).pipe(
                                filter((v) => !!v),
                                switchMap(() => this.store.select(getPublicFilesActive)),
                                map((files) => files.find((f) => f.EntityId === this.InfoiceFormGroup.value.PartnerOffice?.Id && f.Type === PublicFileTypeEnum.PartnerOfficeProfileImage)?.LastVersion),
                            ),
                        ).then((oldFile) => {
                            if (!this.InfoiceFormGroup.value.PartnerOffice?.Id) {
                                return;
                            }
                            const params: PublicFileUploadParams = new Map([
                                ['entity_id', this.InfoiceFormGroup.value.PartnerOffice.Id + ''],
                                ['type', PublicFileTypeEnum.PartnerOfficeProfileImage],
                            ]);
                            if (oldFile) {
                                params.set('file_id', oldFile.FileId + '');
                            }
                            this.store.dispatch(
                                PublicFileActionTypes.Upload({
                                    Payload: {
                                        file,
                                        params,
                                    },
                                }),
                            );
                        });
                    });
            };
        }
        // const reader = new FileReader();
        // if (event.target.files && event.target.files.length) {
        //     const [file] = event.target.files;
        //     reader.readAsDataURL(file);
        //     reader.onload = () => {
        //         this.newLogo$.next({
        //             file: reader.result as string,
        //             partnerOfficeId: this.InfoiceFormGroup.value.PartnerOffice?.Id,
        //         });
        //     };
        // }
        // this.HandleLogoInput(event.target.files[0]);
    }

    protected previewPdfIsLoading$ = new BehaviorSubject<boolean>(false);

    protected taxOptions$: Observable<TaxTypeEntity[]>;

    partner$ = this.store.select(getPartner);
    protected arlTableDisplayedColumns$: Observable<ArlTableComponentDisplayedColumns[]>;
    protected arlTableDocumentDisplayedColumns$: Observable<ArlTableComponentDisplayedColumns[]>;
    protected arlTableColumnConfig$: Observable<TableColumnConfig<arlTableData, ArlTableComponentDisplayedColumns>[]> = this.useArlSeparateSalaryBaseCost$.pipe(
        map((separateSalaryBaseCost) => {
            const ret: TableColumnConfig<arlTableData, ArlTableComponentDisplayedColumns>[] = [
                {name: 'Position', header: ARL_TABLE_AUTO_COLUMN_HEADERS.Position},
                {name: 'BookingText', header: ARL_TABLE_AUTO_COLUMN_HEADERS.BookingText},
                {name: 'Information', header: ARL_TABLE_AUTO_COLUMN_HEADERS.Information},
                {name: 'Quantity', header: ARL_TABLE_AUTO_COLUMN_HEADERS.Quantity},
                {name: 'QuantityType', header: ARL_TABLE_AUTO_COLUMN_HEADERS.QuantityType},
                separateSalaryBaseCost ? {
                    name: 'BaseCost_salary',
                    header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost_salary
                } : null,
                separateSalaryBaseCost ? {
                    name: 'BaseCost_other',
                    header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost_other
                } : null,
                separateSalaryBaseCost ? {
                    name: 'BaseCost_salary_cost',
                    header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost_salary_cost
                } : null,
                separateSalaryBaseCost ? {
                    name: 'BaseCost_other_cost',
                    header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost_other_cost
                } : null,
                {name: 'BaseCost', header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost},
                {name: 'BaseCostGross', header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCostGross},
                {name: 'BaseCost_cost', header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCost_cost},
                {name: 'BaseCostGross_cost', header: ARL_TABLE_AUTO_COLUMN_HEADERS.BaseCostGross_cost},
                {name: 'CompleteCost', header: ARL_TABLE_AUTO_COLUMN_HEADERS.CompleteCost},
                {name: 'CompleteCostGross', header: ARL_TABLE_AUTO_COLUMN_HEADERS.CompleteCostGross},
            ];
            return ret.filter(isNotNullOrUndefined);
        }),
    );
    protected customerSearch: CustomerSearchState = this.customerDataService.createSearchState();
    protected customerSearchForReciplintData: CustomerSearchState = this.customerDataService.createSearchState();
    protected customerLable$: Observable<string>;
    protected customerLable: string = '';
    protected personCustomerSearch = this.customerDataService.createSearchState();

    constructor(
        private store: Store<State>,
        private route: ActivatedRoute,
        private router: Router,
        private dialog: MatLegacyDialog,
        private commissionWizardDialogService: CommissionWizardDialogService,
        private sfdtTemplateService: SfdtTemplateService,
        private api: HttpService,
        public PS: PermissionService,
        private actions$: Actions,
        public LS: LoadingService,
        private fileDataService: FileDataService,
        protected bs: BreakpointObserverService,
        publicFileResolver: PublicFileResolver,
        private eventResolver: EventResolver,
        protected cls: CustomLabelService,
        private appDialog: AppDialogService,
        private toastrService: ToastrService,
        // private ledgerImportResolver: LedgerImportResolver,
        private arlFormDataService: ArlFormDataService,
        private cdr: ChangeDetectorRef,
        private ledgerImportDataService: LedgerImportDataService,
        private sanitizer: DomSanitizer,
        @Inject(LOCALE_ID) protected locale: string,
        @Inject(DEFAULT_CURRENCY_CODE) protected defaultCurrencyCode: string,
        private arlDataService: ArlDataService,
        private person2EntityResolver: Person2EntityResolver,
        protected ls: LoadingService,
        private gatewayService: AppGatewayService,
        accountsReceviableLedgerResolver: AccountsReceivableLedgerResolver,
        private folderDataService: FolderDataService,
        private arlTableService: ArlTableService,
        private invoicingService: InvoicingDataService,
        private ngZone: NgZone,
        private mathJsCustomScopeService: MathJsCustomScopeService,
        private selectArlDialogService: SelectArlDialogService,
        private ledgerImportToPriceComparisonDataService: LedgerImportToPriceComparisonDataService,
        private priceComparisonDataService: PriceComparisonDataService,
        private qrCodeService: QrCodeService,
        private customerDataService: CustomerDataService,
        private textTemplateResolver: TextTemplateResolver,
    ) {
        firstValueFrom(this.store.select(getPublicFilesFetched)).then((fetched) => {
            if (!fetched) {
                publicFileResolver.resolve();
            }
        });
        this.arlTableDisplayedColumns$ = merge(
            this.InfoiceFormGroup.controls.ArlTableDisplayedColumns.valueChanges,
            this.InfoiceFormGroupinitialised$.pipe(filter((inited) => inited)),
            )
            .pipe(
                map(() => {
                    const value = this.InfoiceFormGroup.controls.ArlTableDisplayedColumns.getRawValue();
                    const sorted = value.slice().sort((a, b) => ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(a) - ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(b));
                    return sorted;
                }),
                distinctUntilChanged(compareArrays),
                shareReplay({ refCount: true, bufferSize: 1 }),
            );
        this.arlTableDocumentDisplayedColumns$ = this.InfoiceFormGroup.controls.ArlTableDocumentDisplayedColumns.valueChanges.pipe(
            startWith(null),
            map(() => {
                const value = this.InfoiceFormGroup.getRawValue().ArlTableDocumentDisplayedColumns;
                const sorted = value.slice().sort((a, b) => ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(a) - ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(b));
                return sorted;
            }),
            distinctUntilChanged(compareArrays),
            shareReplay({refCount: true, bufferSize: 1}),
        );
        // this.PS.Has$(this.PS.Permissions.ChangeLedgerImports)
        //     .pipe(take(1))
        //     .subscribe((has) => {
        //         if (!has) {
        //             this._disableForms$.next(true);
        //         }
        //     });
        this.LedgerImport$ = route.paramMap.pipe(
            map((paramMap) => {
                this.LedgerImportId = +paramMap.get('ledgerImportId');
                return +paramMap.get('ledgerImportId');
            }),
            switchMap((ledgerImportId) => this.ledgerImportDataService.getLedgerImportId$(ledgerImportId, false)),
            filter(isNotNullOrUndefined),
            tap((li) => this.LedgerImportDocTypeName$.next(LedgerImportDocumentTypeNames.get(li.DocumentType))),
            shareReplay({refCount: true, bufferSize: 1}),
        );


        // disable forms
        const isEditedBySomeoneElse: boolean = !!route.snapshot.data.concurrencyCheck?.isEditedBySomeoneElse;
        const isReadonlyStatus$ = this.LedgerImport$.pipe(map(li => statusIsReadOnly(li.Status)));
        const hasEditPermission$ = this.PS.Has$(this.PS.Permissions.ChangeLedgerImports);

        this.DisableArlForms$ = combineLatest([
            isReadonlyStatus$,
            hasEditPermission$,
            // this._isEditedBySomeoneElse$,
        ]).pipe(map(([isReadonlyStatus, hasEditPermission]) => isReadonlyStatus || !hasEditPermission || isEditedBySomeoneElse), distinctUntilChanged(), shareReplay({refCount: true, bufferSize: 1}));
        this.DisableAllChanges$ = hasEditPermission$.pipe(map(hasEditPermission => !hasEditPermission || isEditedBySomeoneElse), distinctUntilChanged(), shareReplay({refCount: true, bufferSize: 1}))

        if (!isEditedBySomeoneElse) {
            const fallbackLedgerImportId = +route.snapshot.paramMap.get('ledgerImportId');
            this.setConcurrency(true, fallbackLedgerImportId);
            this.ngZone.runOutsideAngular(() => {
                this.concurrencyInterval = setInterval(() => {
                    this.setConcurrency(true, fallbackLedgerImportId);
                }, 30*1000)
            });
        }


        this.taxOptions$ = combineLatest([
            this.store.select(getTaxTypesActive),
            this.LedgerImport$.pipe(switchMap(li => li.TaxTypeId ? this.store.select(getTaxTypeById({id: li.TaxTypeId})) : of(null))),
        ]).pipe(map(([taxTypes, selectedTaxType]) => {
            if (selectedTaxType && taxTypes.every(t => t.Id !== selectedTaxType.Id)) {
                return [...taxTypes, selectedTaxType];
            } else {
                return taxTypes;
            }
        }));
        this.arlDictFromState$ = this.arlDataService.selectAllArlsDict(); // todo nur vom ledgerImport
        this.disableLVToggle$ = this.DisableArlForms$.pipe(
            switchMap(disable => disable ? of(true) : this.LedgerImport$.pipe(
                map((li) => li.IsLVCalculated),
                distinctUntilChanged(),
                switchMap((isLVCalculated) =>
                    isLVCalculated
                        ? of(true)
                        : combineLatest([
                            this.InfoiceFormGroup.controls.IsLvCalculated.valueChanges.pipe(
                                startWith(null),
                                map(() => this.InfoiceFormGroup.getRawValue().IsLvCalculated),
                            ),
                            this.changeInprogressWhileLVpending$,
                        ]).pipe(map(([lvActive, change]) => lvActive && change)),
                ),
            ))
        );

        this.exportedFromGaeb$ = this.LedgerImport$.pipe(map((li) => !!(li?.GabeImportedType || li?.GaebfromVersionId || (li?.GaebExportedDocumentIds && Object.keys(li?.GaebExportedDocumentIds).length !== 0))));
        const aRLReadOnlyModeSetByUser$ = this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.valueChanges.pipe(
            startWith(null),
            map(() => this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.getRawValue()),
        );
        this.itemNumbersLocked$ = this.InfoiceFormGroup.controls.ItemNumbersLocked.valueChanges.pipe(
            startWith(null),
            map(() => this.InfoiceFormGroup.controls.ItemNumbersLocked.getRawValue()),
        );
        this.disableGaebRelevantForms$ = combineLatest([this.exportedFromGaeb$, this.forceGaebEditing$, aRLReadOnlyModeSetByUser$]).pipe(
            map(([exportedFromGaeb, forceGaebEditing, aRLReadOnlyModeSetByUser]) => (aRLReadOnlyModeSetByUser || exportedFromGaeb) && !forceGaebEditing),
            distinctUntilChanged(),
            shareReplay({refCount: true, bufferSize: 1}),
        );
        this.showPartialInvoiceList$ = this.LedgerImport$.pipe(map((li) => li.InvoiceItems?.length > 0 || li.DocumentType === LedgerImportDocumentTypes.ClosingInvoice));
        this.totalFromPartialInvoiceForms$ = this.LedgerImport$.pipe(
            map((ledgerImport) => ledgerImport?.InvoiceItems),
            distinctUntilChanged(compareEqualityAsJsonString),
            map((invoiceItems) => {
                const brutto = invoiceItems.reduce((prev, curr) => prev + (curr.amountBrutto || 0), 0);
                const tax = invoiceItems.reduce((prev, curr) => prev + (curr.amountBrutto || 0) - (curr.amountNetto || 0), 0);
                const netto = invoiceItems.reduce((prev, curr) => prev + (curr.amountNetto || 0), 0);

                return {
                    netto: formatNumber(netto, this.locale, '1.2-2'),
                    brutto: formatNumber(brutto, this.locale, '1.2-2'),
                    tax: formatNumber(tax, this.locale, '1.2-2') + ' (' + formatNumber(parseFloat(((tax / netto) * 100).toFixed(4)), this.locale, '1.0-2') + ' %)',
                    netto_number: netto,
                    brutto_number: brutto,
                    tax_number: tax,
                };
            }),
            shareReplay({refCount: true, bufferSize: 1}),
        );
        this.otherZuschlagForLV$ = this.InfoiceFormGroup.valueChanges.pipe(
            startWith(null),
            map(() => this.InfoiceFormGroup.controls.ARLSurChargeByTypes.getRawValue()),
            distinctUntilChanged(compareEqualityAsJsonString),
            map((surcharges) => surcharges.find((s) => s.arlType === AccountsReceivableLedgerTypeEnum.Other)?.percentage || 0),
            distinctUntilChanged(),
        );
        this.arlSumCurrencies$ = this.InfoiceFormGroup.valueChanges.pipe(
            startWith(null),
            map(() => {
                const SkontoAvilable = this.InfoiceFormGroup.controls.SkontoAvilable.getRawValue();
                const SkontoIsAllowance = this.InfoiceFormGroup.controls.SkontoIsAllowance.getRawValue();
                const SkontoPercentage = this.InfoiceFormGroup.controls.SkontoPercentage.getRawValue();
                return {
                    AccountsReceivableLedgerIds: this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(),
                    AllowanceCharges: this.InfoiceFormGroup.controls.AllowanceCharges.getRawValue(),
                    SkontoPercentage: SkontoAvilable && SkontoIsAllowance && SkontoPercentage ? SkontoPercentage : null,
                    ShowNettoSum: this.InfoiceFormGroup.controls.ShowNettoSum.getRawValue(),
                };
            }),
            distinctUntilChanged(compareEqualityAsJsonString),
            switchMap(({AccountsReceivableLedgerIds, AllowanceCharges, SkontoPercentage, ShowNettoSum}) => {
                try {
                    return this.arlFormDataService.getAmountSumForArls2$(AccountsReceivableLedgerIds, AllowanceCharges, ShowNettoSum);
                } catch (e) {
                    console.error('Error calculating amount sum for ARLs:', e);
                    return timer(1000).pipe(switchMap(() => this.arlFormDataService.getAmountSumForArls2$(AccountsReceivableLedgerIds, AllowanceCharges, ShowNettoSum)));
                }
            }),
            filter(isNotNullOrUndefined),
            tap((v) => console.log('Amount sum for ARLs calculated:', v)),
            shareReplay({refCount: true, bufferSize: 1}),
        );

        this.alreadyPayedSum$ = this.InfoiceFormGroup.controls.PaymentItems.valueChanges.pipe(
            startWith(null),
            map((ledgerImport) => this.InfoiceFormGroup.controls.PaymentItems.value),
            distinctUntilChanged(compareEqualityAsJsonString),
            map((paymentItems) => {
                const brutto = paymentItems.reduce((prev, curr) => prev + (curr.payedAmountBrutto || 0), 0);
                const tax = paymentItems.reduce((prev, curr) => prev + (curr.payedAmountBrutto || 0) - (curr.payedAmountNetto || 0), 0);
                const netto = paymentItems.reduce((prev, curr) => prev + (curr.payedAmountNetto || 0), 0);

                return {
                    netto: formatNumber(netto, this.locale, '1.2-2'),
                    brutto: formatNumber(brutto, this.locale, '1.2-2'),
                    tax: formatNumber(tax, this.locale, '1.2-2') + ' (' + formatNumber(parseFloat(((tax / netto) * 100).toFixed(4)), this.locale, '1.0-2') + ' %)',
                    netto_number: netto,
                    brutto_number: brutto,
                    tax_number: tax,
                };
            }),
            shareReplay({refCount: true, bufferSize: 1}),
        );
        this.alreadyPayedSumDifference$ = combineLatest([this.alreadyPayedSum$, this.arlSumCurrencies$]).pipe(
            map(([alreadyPayed, arlSumCurrencies]) => {
                const subTotalFromForms = arlSumCurrencies.withAllowanceCharges;

                const netto_number = subTotalFromForms.netto_number - alreadyPayed.netto_number;
                const brutto_number = subTotalFromForms.brutto_number - alreadyPayed.brutto_number;
                const tax_number = subTotalFromForms.tax_number - alreadyPayed.tax_number;
                return {
                    netto: formatNumber(netto_number, this.locale, '1.2-2'),
                    netto_number,
                    brutto: formatNumber(brutto_number, this.locale, '1.2-2'),
                    brutto_number,
                    tax: formatNumber(tax_number, this.locale, '1.2-2') + ' (' + formatNumber(parseFloat(((tax_number / netto_number) * 100).toFixed(4)), this.locale, '1.0-2') + ' %)',
                    tax_number,
                    /**
                     * in funktion, damit es nur dann ausgerechnet werden muss wenn es gebraucht wird (bei Schluss- und Teil-rechnungen im twig template)
                     */
                    ignoreSkonto: () => {
                        const subTotalFromFormsWithoutSkonto = arlSumCurrencies.withAllowanceChargesButScontoIgnored;

                        const netto_number = subTotalFromFormsWithoutSkonto.netto_number - alreadyPayed.netto_number;
                        const brutto_number = subTotalFromFormsWithoutSkonto.brutto_number - alreadyPayed.brutto_number;
                        const tax_number = subTotalFromFormsWithoutSkonto.tax_number - alreadyPayed.tax_number;
                        return {
                            netto: formatNumber(netto_number, this.locale, '1.2-2'),
                            netto_number,
                            brutto: formatNumber(brutto_number, this.locale, '1.2-2'),
                            brutto_number,
                            tax: formatNumber(tax_number, this.locale, '1.2-2') + ' (' + formatNumber(parseFloat(((tax_number / netto_number) * 100).toFixed(4)), this.locale, '1.0-2') + ' %)',
                            tax_number,
                        };
                    }

                };
            }),
        );
        this.subscriptions.push(
            this.InfoiceFormGroup.controls.TaxTypeId.valueChanges
                .pipe(
                    tap(() => {
                        this.enableButtonAlleUeberschreiben = true;
                    }),
                    takeUntil(this.onDestroy$),
                )
                .subscribe(),
            this.mathJsCustomScopeService.scope$.pipe(switchMap((s) => s.varChange$)).subscribe((variables) => {
                this.variableScopeDirty$.next(true);

                this.arlTableService.recalculateAllQuantitiesByUpdatedVariables(
                    variables,
                    this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue().map((id) => this.arlFormDataService.getForm(id)),
                    AccountsReceivableLedgerEntity.QuantityDecimalPlaces,
                    this.mathJsCustomScopeService.getScope(),
                );
            })
        );
        this.FilterMaterialsByCustomerId$ = of(null); // todo D277-4872
        // todo D277-4872
        // this.FilterMaterialsByCustomerId$ = combineLatest([
        //     this.LedgerImport$,
        //     this.InfoiceFormGroup.controls.Customer.valueChanges.pipe(
        //         startWith(null),
        //         map(() => this.InfoiceFormGroup.controls.Customer.getRawValue()),
        //     ),
        // ]).pipe(map(([li, customer]) => (li.DocumentType === LedgerImportDocumentTypes.Order ? customer?.Id : null)));
        this.AddARLDefaultValues$ = combineLatest([
            this.LedgerImport$,
            this.InfoiceFormGroup.controls.TaxTypeId.valueChanges.pipe(
                startWith(''),
                map(() => this.InfoiceFormGroup.controls.TaxTypeId.getRawValue()),
                switchMap((id) => id ? this.store.select(getTaxTypeById(({id}))) : of(null))
            ),
            this.store.select(getDefaultVat),
        ]).pipe(
            map(([li, taxType, defaultVat]) => ({
                ...ARL_DEFAULT_VALUES,
                ledgerImportId: li.Id,
                quantity: 1,
                tax: taxType ? taxType.TaxPercentage : defaultVat,
                currencyCode: li.ConsolidatedCurrencyCode || 'EUR',
                baseCost: 0,
            })),
            shareReplay({refCount: true, bufferSize: 1}),
        );
        this.SfdtIsDirty$ = this.LedgerImport$.pipe(
            map((li) => li.IsDirty),
            distinctUntilChanged(),
        );
        this.invoiceTemplate = combineLatest([
            this.LedgerImport$,
            this.InfoiceFormGroup.controls.PartnerOffice.valueChanges.pipe(
                startWith(null),
                map(() => this.InfoiceFormGroup.getRawValue().PartnerOffice),
            ),
        ]).pipe(
            filter(isNotNullOrUndefined),
            withLatestFrom(this.store.select(getSfdtTemplates), this.store.select(getOwnPartnerOffices), this.store.select(getPartner)),
            switchMap(([[li, poForm], templates, pos, partner]) => {
                let template: SfdtTemplateEntity;
                if (li.AdditionalData?.twigTemplateId) {
                    template = templates.find((t) => t.Id === li.AdditionalData?.twigTemplateId);
                } else {
                    switch (li.DocumentType) {
                        case LedgerImportDocumentTypes.Invoice:
                        case LedgerImportDocumentTypes.PartialInvoice:
                        case LedgerImportDocumentTypes.ClosingInvoice:
                            template = templates.find((t) => t.Id === pos.find((p) => p.Id === poForm?.Id)?.AdditionalData?.invoiceSfdtTemplateId);
                            break;
                        case LedgerImportDocumentTypes.Offer:
                            template = templates.find((t) => t.Id === pos.find((p) => p.Id === poForm?.Id)?.AdditionalData?.offerSfdtTemplateId);
                            break;
                    }
                    if (!template) {
                        template = templates
                            .slice()
                            .sort((a, b) => a.Id - b.Id)
                            .find((t) => t.PartnerId === partner.Id);
                    }
                    if (!template) {
                        template = templates.find((t) => t.PartnerId === null);
                    }
                }
                console.log({template, templates, l: li.AdditionalData, l2: li.DocumentType});
                if (template.Html /* && template.Options*/) {
                    return of(template);
                } else {
                    this.store.dispatch(LedgerImportActionTypes.GetSFDTTemplate({
                        Payload: {id: template.Id},
                        withData: true
                    }));
                    return this.actions$.pipe(
                        ofType(LedgerImportActionTypes.UpdateSFDTTemplate),
                        take(1),
                        map(({Payload}) => Payload.find((t) => t.Id === template.Id)),
                    );
                }
            }),
        );
        // this.offerTemplate = this.LedgerImport$.pipe(
        //     filter(isNotNullOrUndefined),
        //     withLatestFrom(this.store.select(getSfdtTemplates), this.store.select(getPartner), this.store.select(getOwnPartnerOffices)),
        //     switchMap(([li, templates, partner, pos]) => {
        //         let template: SfdtTemplateEntity;
        //         if (li.AdditionalData?.twigTemplateId) {
        //             template = templates.find(t => t.Id === li.AdditionalData?.twigTemplateId);
        //         } else {
        //             template = templates.find(t => t.Id === pos.find(p => p.Id === li.PartnerOfficeId)?.AdditionalData?.offerSfdtTemplateId);
        //             if (!template) {
        //                 template = templates.find(t => t.PartnerId === null);
        //             }
        //         }
        //         if (template.Data) {
        //             return of(template);
        //         } else {
        //             this.store.dispatch(LedgerImportActionTypes.GetSFDTTemplate({ Payload: { id: template.Id } }));
        //             // return of(template);
        //             return this.actions$.pipe(
        //                 ofType(LedgerImportActionTypes.UpdateSFDTTemplate),
        //                 take(1),
        //                 map(({ Payload }) => Payload.find(t => t.Id === template.Id)),
        //             );
        //         }
        //     }),
        // );
        // this.BookingPositions$ = combineLatest([this.LedgerImport$, this.store.select(getAccountsReceivableLedgers).pipe(filter(isNotNullOrUndefined))]).pipe(
        //     map(([ledgerImport, bookingpositions]) => {
        //         return bookingpositions
        //             .filter(
        //                 b =>
        //                     b.LedgerImportId === ledgerImport.Id ||
        //                     (!b.LedgerImportId && (ledgerImport.DocumentType === b.DocumentType || !b.DocumentType) &&
        //                         ((ledgerImport.CommissionId && ledgerImport.CommissionId === b.CommissionId) ||
        //                             (ledgerImport.CustomerId && ledgerImport.CustomerId === b.CustomerId && !b.CommissionId) ||
        //                             (!b.CommissionId && !b.CustomerId && !ledgerImport.CommissionId && !ledgerImport.CustomerId))),
        //             ).filter(b => !b.ParentId)
        //             .sort((a, b) => b.Id - a.Id);
        //     }),
        // );

        this.FormData = combineLatest([this.LedgerImport$, this.afterViewInit$.pipe(filter(v => v))]).pipe(
            map(([li]) => li.DocumentType),
            distinctUntilChanged(),
            withLatestFrom(this.cls.getSingle$('Commission')),
            map(([documentType, commissionLabel]) => {
                const Properties: IDetailListTemplateDataProperty[] = [
                    {
                        key: 'Kundennummer',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.CustomerNumber,
                    },
                    {
                        key: 'Auftragsnummer',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.CommissionNumber,
                    },
                    {
                        key: this.LedgerImportDocTypeName$.value + 'snummer/ -bezeichnung',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.ConsolidatedInvoiceId,
                        options: {
                            specialInput: {
                                customTemplate: this.invoiceNumberInputTemplate,
                            }
                        }
                    },
                    {
                        key: this.LedgerImportDocTypeName$.value + 'snummer automatisch auswählen',
                        formControl: this.InfoiceFormGroup.controls.AutomaticNr,
                        options: {
                            type: CustomPropertyType.Boolean,
                            specialInput: {boolean: true},
                            showHint: 'Erzeugt automatisch eine fortlaufende ' + this.LedgerImportDocTypeName$.value + 'snummer/ -bezeichnung',
                        },
                    },
                    {
                        key: this.getConsolidatedInvoiceDateLabel(),
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.InvoiceDate,
                        options: {
                            specialInput: {
                                date: true,
                            },
                        },
                    },
                    {
                        key: 'Lieferdatum',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.DeliveryDate,
                        options: {
                            specialInput: {
                                date: true,
                            },
                        },
                    },
                    {
                        key: 'Lieferzeit',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.DeliveryTime,
                    },
                    {
                        key: 'Leistungsdatum',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.ConsolidatedDeliveryDate2,
                        options: {
                            specialInput: {
                                date: true,
                            },
                        },
                    },
                    {
                        key: 'Leistungszeitraum',
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.ServicePeriod,
                    },
                    {
                        key: getDueDateFromLedgerImportDocumentType(documentType),
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.DueDate,
                        options: {
                            specialInput: {
                                date: true,
                            },
                        },
                    },
                    {
                        key: commissionLabel,
                        value: '',
                        formControl: this.InfoiceFormGroup.controls.CommissionId,
                        options: {
                            specialInput: {
                                singleSelectSearch: {
                                    options$: combineLatest([
                                        this.InfoiceFormGroup.controls.Customer.valueChanges.pipe(
                                            startWith(''),
                                            map(() => this.InfoiceFormGroup.controls.Customer.getRawValue()),
                                            distinctUntilChanged(),
                                        ),
                                        this.LedgerImport$.pipe(
                                            map((l) => l),
                                            distinctUntilChanged(),
                                        ),
                                    ]).pipe(
                                        switchMap(([customer, ledgerImport]) =>
                                            store.select(getCommissionSorted).pipe(
                                                map((commissions) => commissions.filter((c) => !c.Deleted)),
                                                switchMap((commissions) =>
                                                    !ledgerImport?.CommissionId || commissions.some((c) => c.Id === ledgerImport?.CommissionId)
                                                        ? of(commissions)
                                                        : store.select(getCommissionById({id: ledgerImport?.CommissionId})).pipe(map((c) => [c, ...commissions])),
                                                ),
                                                tap(commissions => console.log('commissions:', commissions)),
                                                map((commissions) =>
                                                    !customer ||
                                                    (customer?.IsSupplier &&
                                                        (ledgerImport.DocumentType === LedgerImportDocumentTypes.Order ||
                                                            ledgerImport.DocumentType === LedgerImportDocumentTypes.OrderConfirmation ||
                                                            ledgerImport.DocumentType === LedgerImportDocumentTypes.DeliveryNote ||
                                                            ledgerImport.DocumentType === LedgerImportDocumentTypes.ReturnDeliveryNote))
                                                        ? commissions.filter(isNotNullOrUndefined)
                                                        : commissions.filter((c) => c?.CustomerId === customer?.Id),
                                                ),
                                            ),
                                        ),
                                    ),
                                    compareOptions: (a, b) => a?.Id === b?.Id,
                                    searchFunction: (search: string, option: CommissionEntity) => option?.optionSearch?.some((v) => v.includes(search?.trim().toLowerCase())),
                                },
                            },
                        },
                    },
                ];
                return {Properties};
            }),
        );
        firstValueFrom(this.PS.Has$(this.PS.Permissions.ChangeBusinessVolumeLedgerImportStatus)).then((isAdmin) => {
            this.StatusData$ = this.LedgerImport$.pipe(
                map((ledgerImport) => {
                    return {
                        Properties: [
                            {
                                key: 'Status',
                                value: '',
                                formControl: this.InfoiceFormGroup.controls.Status,
                                options: {
                                    specialInput: {
                                        select: ledgerImport.AvailableStates(isAdmin),
                                    },
                                },
                            },
                        ],
                    };
                }),
            );
        });
        this.IsMobile$ = this.bs.MobileQuery;
        this.PartnerDetailData = {
            Properties: [
                {
                    key: 'Name',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerName,
                },
                {
                    key: 'Straße, Hausnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerStreet,
                },
                {
                    key: 'Postleitzahl',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerPostalCode,
                },
                {
                    key: 'Stadt',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerCity,
                },
                {
                    key: 'Land',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerCountry,
                },
                {
                    key: 'Telefonnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerPhoneNumber,
                },
                {
                    key: 'E-Mail',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerEmail,
                },
            ],
        };
        this.UserDetailData = {
            Properties: [
                {
                    key: 'Name',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.UserName,
                },
                {
                    key: 'Telefonnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.UserPhoneNumber,
                },
                {
                    key: 'E-Mail',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.UserEmail,
                },
            ],
        };
        this.FooterFormData = {
            Properties: [
                {
                    key: 'QR-Code',
                    value: null,
                    formControl: this.InfoiceFormGroup.controls.ShowQRCode,
                    options: {
                        showHint: 'Benötigt IBAN, BIC und Kontoinhaber',
                        specialInput: {
                            boolean: true,
                        }
                    }
                },
                {
                    key: 'IBAN',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.Iban,
                },
                {
                    key: 'BIC',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.Bic,
                },
                {
                    key: 'Kontoinhaber',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.PartnerAccountHolder,
                },
                // {
                //     key: 'Blz',
                //     value: '',
                //     formControl: this.InfoiceFormGroup.controls.Blz,
                // },
                {
                    key: 'Bankname',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.Bankname,
                },
                {
                    key: 'Umsatzsteueridentifikationsnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.UstId,
                },
                {
                    key: 'Geschäftsführer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CeoName,
                },
                {
                    key: 'Registergericht',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.RegistryCourt,
                },
                {
                    key: 'Handelsregister',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CommercialRegister,
                },
            ],
        };
        this.PartnerOfficeData$ = combineLatest([store.select(getOwnPartnerOffices).pipe(filter(isNotNullOrUndefined))]).pipe(
            map(([partnerOffices]) => {
                // this.InfoiceFormGroup.controls.PartnerOffice.setValue(partnerOffices.find(c => c.Id === this.InfoiceFormGroup.value.PartnerOffice?.Id));
                return {
                    Properties: [
                        {
                            key: 'Unternehmen',
                            value: this.InfoiceFormGroup.controls.PartnerOffice.value?.Name,
                            formControl: this.InfoiceFormGroup.controls.PartnerOffice,
                            options: {
                                specialInput: {
                                    singleSelectSearch: {
                                        options: partnerOffices || [],
                                        compareOptions: (a, b) => a?.Id === b?.Id,
                                    },
                                },
                            },
                        } as IDetailListTemplateDataProperty<PartnerOfficeEntity>,
                    ],
                };
            }),
        );
        this.CustomerData = combineLatest([this.LedgerImport$, this.cls.getSingle$('CustomerSupplier')]).pipe(
            switchMap(([ledgerImport, customerLabel]) =>
                (ledgerImport?.CustomerId ? this.customerDataService.GetSingleCustomer$(ledgerImport.CustomerId).pipe(take(1), startWith(null)) : of(null)).pipe(
                    map((customer) => ({
                        Properties: [
                            {
                                key: customerLabel,
                                value: customer?.DisplayInformation || '',
                                formControl: this.InfoiceFormGroup.controls.Customer,
                                options: {
                                    specialInput: {
                                        singleSelectSearch: {
                                            options$: this.customerSearch.customerOptions$,
                                            loading$: this.customerSearch.loading$,
                                            pageIndex$: this.customerSearch.customerPaging.pageIndex$,
                                            pageCount$: this.customerSearch.customerPaging.pageCount$,
                                            serverSearch: (search) => this.customerSearch.SearchCustomers(search, 'unbenannter' + this.customerLable),
                                            pageChange: (event) => this.customerSearch.customerPageChange(event),
                                            compareOptions: (a, b) => a?.Id === b?.Id,
                                        },
                                    },
                                },
                            } as IDetailListTemplateDataProperty<CustomerEntity>,
                        ],
                    })),
                ),
            ),
        );
        this.AssignedEmployeeData = combineLatest([
            this.LedgerImport$,
            this.store.select(getUsers).pipe(filter(isNotNullOrUndefined)),
            this.store.select(getEmployeesActiveSortedByNameStartWithMe).pipe(map((employees) => employees.filter((e) => e.UserId))),
            this.store.select(getPartner),
        ]).pipe(
            map(([ledgerImport, users, employeeUsers, partner]) => {
                const activeUsers = users.filter((u) => employeeUsers.some((e) => e.UserId == u.Id));
                const myEmployees = activeUsers.filter((e) => e.PartnerId === partner.Id);
                const Properties: IDetailListTemplateDataProperty<UserEntity>[] = [
                    {
                        key: 'Bearbeiter',
                        value: ledgerImport?.AdditionalData?.assignedUserId ? activeUsers.find((e) => e.Id === ledgerImport?.AdditionalData?.assignedUserId)?.DisplayName : activeUsers.find((e) => e.Id === ledgerImport?.UserId)?.DisplayName, //'Kein Bearbeiter ausgewählt.',
                        formControl: this.InfoiceFormGroup.controls.AssignedUser,
                        options: {
                            specialInput: {
                                singleSelectSearch: {
                                    options:
                                        myEmployees || [],
                                    compareOptions: (a, b) => a?.Id === b?.Id,
                                },
                            },
                        },
                    },
                ];
                if (partner.Id === 117 || partner.Id === 40 || partner.Id === 1) {
                    // hafer id
                    Properties.push({
                        key: 'Unser Zeichen',
                        value: ledgerImport?.AdditionalData?.ourSign,
                        formControl: this.InfoiceFormGroup.controls.OurSign,
                    });
                }
                return {
                    Properties,
                };
            }),
        );
        this.person2EntityResolver.resolve();
        this.recipientPersonData$ = combineLatest([
            this.LedgerImport$,
            store.select(getPerson2Entities).pipe(filter(isNotNullOrUndefined)),
            store.select(getPersons).pipe(filter(isNotNullOrUndefined)),
            this.InfoiceFormGroup.controls.CommissionId.valueChanges.pipe(
                startWith(null),
                map(() => this.InfoiceFormGroup.controls.CommissionId.getRawValue()),
                distinctUntilChanged((a, b) => a?.Id === b?.Id),
            ),
            this.InfoiceFormGroup.controls.Customer.valueChanges.pipe(
                startWith(null),
                map(() => this.InfoiceFormGroup.controls.Customer.getRawValue()),
            ),
            this.store.select(getPartner),
        ]).pipe(
            switchMap(([ledgerImport, p2e, persons, commissionId, customer, partner]) => {
                // const pId = p2e?.find((p) => p.EntityType === Person2EntityEntityTypeEnum.Commission && p.EntityId === commissionId?.Id)?.PersonId;
                let personArray = persons.filter((p) => p.DisplayName);
                // Kunde ausgewählt für Beteiligte Person
                if (customer?.Id || commissionId?.Id) {
                    const p2eByCustomerCommission = p2e.filter(
                        (pe) => (pe.EntityId === customer?.Id && pe.EntityType === Person2EntityEntityTypeEnum.Customer) || (pe.EntityType === Person2EntityEntityTypeEnum.Commission && pe.EntityId === commissionId?.Id),
                    );
                    personArray = personArray.filter((p) => p2eByCustomerCommission.some((pe) => pe.PersonId === p.Id));
                    return of(personArray);
                }
                // console.log('log', persons ,  personArray ,personArray?.map(c => Object.assign(c.Clone(), {
                //     optionLabel: c.DisplayName
                // })))
                return this.personFilterValues$.pipe(
                    map((filterValues) => {
                        const filterCustomerId = filterValues[FilterTypes.Customers];
                        if (isNotNullOrUndefined(filterCustomerId)) {
                            const p2eByCustomers = p2e.filter((pe) => pe.EntityType === Person2EntityEntityTypeEnum.Customer && pe.EntityId === +filterCustomerId);
                            return personArray.filter((p) => p2eByCustomers.some((pe) => pe.PersonId === p.Id));
                        }
                        return personArray;
                    }),
                );
            }),
        );
        this.DeliveryAddressFormData = {
            Properties: [
                {
                    key: 'Name',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.DeliveryName,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Straße, Hausnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.DeliveryStreet,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Postleitzahl',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.DeliveryPostalCode,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Stadt',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.DeliveryCity,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
            ],
        };
        this.AddressFormData = {
            Properties: [
                {
                    key: 'Name',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CustomerName,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Straße, Hausnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CustomerStreet,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Postleitzahl',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CustomerPostalCode,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Stadt',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CustomerCity,
                    options: {
                        specialInput: {
                            textArea: {
                                Fill: false,
                            },
                        },
                    },
                },
                {
                    key: 'Umsatzsteueridentifikationsnummer',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.CustomerUstId,
                },
            ],
        };
        this.NotesFormData = {
            Properties: [
                {
                    key: 'Notiz',
                    value: '',
                    formControl: this.InfoiceFormGroup.controls.Notes,
                    options: {
                        specialInput: {
                            textArea: {Fill: true},
                        },
                    },
                },
            ],
        };
        // this.DownloadLink$ = this.LedgerImport$.pipe(
        //     switchMap((li) =>
        //         li?.DocumentId && !li.IsDirty && li.DocumentCanBeDownloaded
        //             ? this.fileDataService.GetFileById$(li.DocumentId, true).pipe(
        //                   filter(isNotNullOrUndefined),
        //                   withLatestFrom(this.store.select(getToken)),
        //                   map(([file, token]) => this.api.GetUrl(file.GetLastVersion().GetDownloadLink(token), 'file')),
        //               )
        //             : of(null),
        //     ),
        //     shareReplay({ refCount: true, bufferSize: 1 }),
        // );

        this.subscriptions.push(
            merge(
                this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.valueChanges.pipe(distinctUntilChanged()),
                this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.valueChanges.pipe(
                    switchMap(() => merge(...this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.controls.map((c) => c.controls.percentage.valueChanges.pipe(distinctUntilChanged())))),
                ),
                this.InfoiceFormGroupinitialised$.pipe(filter((inited) => inited)),
            )
                .pipe(
                    // startWith(null),
                    map(() => {
                        return {
                            ledgerImport: this.InfoiceFormGroup.getRawValue(),
                            preChargeByType: this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue(),
                            globalPreCharge: this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue(),
                        };
                    }),
                    pairwise(),
                    withLatestFrom(this.isLvCalculated$),
                )
                .subscribe(([[prev, curr], isLvCalculated]) => {
                    if (!isLvCalculated) {
                        setTimeout(
                            () => {
                                if (curr.globalPreCharge === prev.globalPreCharge) {
                                    this.arlTableService.recalculateCostAndBaseCostOnPreChargeChange(
                                        curr.ledgerImport.AccountsReceivableLedgerIds.map((id) => this.arlFormDataService.getForm(id)),
                                        curr.preChargeByType,
                                        prev.preChargeByType,
                                        curr.globalPreCharge,
                                        prev.globalPreCharge,
                                    )
                                } else {
                                    this.arlTableService.recalculateAllBaseCost(
                                        curr.ledgerImport.AccountsReceivableLedgerIds.map((id) => this.arlFormDataService.getForm(id)),
                                        // curr.preChargeByType,
                                        // prev.preChargeByType,
                                        curr.globalPreCharge,
                                        prev.globalPreCharge,
                                        true,
                                        true,
                                    )
                                }
                            },
                            1
                        ); // wait for form value propergate to inputs from arl table
                    }
                }),
            this.InfoiceFormGroup.controls.Status.valueChanges.pipe(distinctUntilChanged(), withLatestFrom(this.LedgerImport$)).subscribe(([value, li]) => {
                if (value !== li.Status && !!value) {
                    this.InfoiceFormGroup.controls.Status.markAsDirty();
                    this.InfoiceFormGroup.markAsDirty();
                    this.ShowStatus = false;
                    this.SaveClick();
                }
            }),
            this.PartnerOfficeData$.subscribe(),

            this.InfoiceFormGroup.controls.PartnerOffice.valueChanges
                .pipe(
                    filter(isNotNullOrUndefined),
                    map((p) => p.Id),
                    distinctUntilChanged(),
                    switchMap((id) =>
                        this.store.select(getPublicFilesFetched).pipe(
                            filter((v) => !!v),
                            switchMap(() => this.store.select(getPublicFilesActive)),
                            map((files) => files.find((f) => f.EntityId === id && f.Type === PublicFileTypeEnum.PartnerOfficeProfileImage)?.LastVersion),
                        ),
                    ),
                    withLatestFrom(this.store.select(getToken)),
                )
                .subscribe(([file, token]) => {
                    if (file) {
                        this.api
                            .download(file, {token})
                            .pipe(take(1))
                            .subscribe((val) => this.HandleLogoInput(val));
                    } else {
                        this.InfoiceFormGroup.controls.LogoBase64.setValue(null);
                    }
                }),
            this.recipientCustomerForm.valueChanges.subscribe(customer => {
                if (customer) {
                    this.setReciplientCustomer(customer);
                }
            }),
            combineLatest([
                this.recipientPersonForm.valueChanges.pipe(filter(isNotNullOrUndefined)),
                this.store.select(getPerson2Entities).pipe(
                    filter(isNotNullOrUndefined),
                    map((pes) => pes.filter((pe) => pe.EntityType === Person2EntityEntityTypeEnum.Customer)),
                ),
            ]).pipe(
                switchMap(([p, personEntities]) => {
                    const cIds = uniqArray(personEntities.filter((pe) => pe.PersonId === p.Id).map((pe) => pe.EntityId));

                    const ret: {person: PersonEntity, companyName?: string} = {person: p, companyName: p.CompanyName};
                    if (p.CompanyName || !cIds.length) {
                        return of(ret);
                    }
                    return this.customerDataService.GetCustomers$(cIds).pipe(
                        first(),
                        map((c) => ({...ret, companyName: c.find((cu) => !cu.Deleted)?.DisplayName})),
                    );
                }),
            ).subscribe(({person, companyName}) => {
                const p = person;
                const officeName = companyName;

                this.InfoiceFormGroup.controls.CustomerName.setValue((officeName ? officeName + '\n' : '') + (p.Title ? p.Title + '\n' : '') + p.Firstname + ' ' + p.Lastname);
                if (p.Street || p.PostalCode || p.City) {
                    this.InfoiceFormGroup.controls.CustomerStreet.setValue(p.Street ? p.Street : '');
                    this.InfoiceFormGroup.controls.CustomerPostalCode.setValue(p.PostalCode ? p.PostalCode : '');
                    this.InfoiceFormGroup.controls.CustomerCity.setValue(p.City ? p.City : '');
                }
                this.InfoiceFormGroup.controls.CustomerUstId.setValue('');
            }),
            this.InfoiceFormGroup.controls.AssignedUser.valueChanges
                .pipe(
                    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)), //ValueChange triggered after Save
                    filter(isNotNullOrUndefined),
                )
                .subscribe((u) => {
                    this.store
                        .select(getUsers)
                        .pipe(
                            map((users) => users.find((user) => user.Id === u.Id)),
                            take(1),
                        )
                        .subscribe((val) => {
                            this.InfoiceFormGroup.controls.UserName.setValue(val.DisplayName);
                            this.InfoiceFormGroup.controls.UserEmail.setValue(val.Email);
                        });
                }),
            combineLatest([
                // this.EditorCreated$,
                merge(this.InfoiceFormGroup.valueChanges /*.pipe(tap((v) => console.log('valueChanged ', v)))*/, this.arlTableValuesChanged$),
                this.arlDictFromState$,
            ])
                .pipe(debounceTime(900))
                .subscribe(() => {
                    this.PushValuesToSyncfusion$.next();
                }),

            combineLatest([
                combineLatest([this.LedgerImport$, this.arlDictFromState$]).pipe(
                    map(([li, arls]) => {
                        let ret = li;
                        (li.AccountsReceivableLedgerIds || []).forEach((id) => {
                            if (!arls[id]) {
                                console.error('ARL mit Id ' + id + ' von LedgerImport ' + li.Id + ' konnte nicht gefunden werden');
                                // ret = undefined;
                            }
                        });
                        return ret;
                    }),
                    filter(isNotNullOrUndefined),
                ),
                store.select(getPartner).pipe(filter(isNotNullOrUndefined)),
                store.select(getOwnPartnerOffices).pipe(filter(isNotNullOrUndefined)),
                store.select(getCommissionDictionary),
            ])
                .pipe(
                    distinctUntilChanged(([a1], [b1]) => a1?.Id === b1?.Id && a1.Status === b1.Status && a1.ConsolidatedInvoiceId === b1.ConsolidatedInvoiceId),
                    switchMap(([ledgerImport, partner, partnerOffices, commissions]) =>
                        (ledgerImport.CustomerId
                                ? this.customerDataService.GetSingleCustomer$(
                                    ledgerImport.CustomerId,
                                ).pipe(take(1)) // ohne take(1) emittiert der Cache bei jeder Kundensuche erneut und das Formular wird auf die LedgerImport-Werte zurückgesetzt
                                : of(null)
                        ).pipe(
                            map((customer) => ({
                                ledgerImport,
                                partner,
                                customer,
                                partnerOffices,
                                commissions,
                            })),
                        ),
                    ),
                    withLatestFrom(this.store.select(getUsers), this.arlDictFromState$, this.defaultSurcharges$),
                    tap(
                        ([{ ledgerImport, partner, customer, partnerOffices, commissions }, users, bookingPositions, defaultSurcharges,]) => {
                        if (ledgerImport) {
                            const commission = ledgerImport.CommissionId && commissions[ledgerImport.CommissionId];
                            const partnerOffice = ledgerImport.PartnerOfficeId && partnerOffices.find((p) => p.Id === ledgerImport.PartnerOfficeId);
                            const assignedUser = ledgerImport.AdditionalData?.assignedUserId ? users.find((u) => u.Id === ledgerImport?.AdditionalData?.assignedUserId) : users.find((u) => u.Id === ledgerImport?.UserId);
                            const allowanceCharges = ledgerImport.AllowanceCharges;

                            if (this.InfoiceFormGroup.controls.AllowanceCharges.length !== allowanceCharges.length) {
                                const wasDisabled = this.InfoiceFormGroup.controls.AllowanceCharges.disabled;
                                this.InfoiceFormGroup.controls.AllowanceCharges.clear();
                                allowanceCharges.forEach((ac) => {
                                    this.InfoiceFormGroup.controls.AllowanceCharges.push(emptyAllowanceChargeForm());
                                });
                                if (wasDisabled) {
                                    this.InfoiceFormGroup.controls.AllowanceCharges.disable();
                                }
                            }
                            // this.InfoiceFormGroup.setControl('AllowanceCharges', new FormArray<typeof this.InfoiceFormGroup.controls.AllowanceCharges.controls[0]>(allowanceCharges.map(() => emptyAllowanceChargeForm())));
                            this.setArlForms(ledgerImport.AccountsReceivableLedgerIds.map((id) => this.arlFormDataService.getFormByEntity(id, bookingPositions)));

                            // const wasdisabled = this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.disabled;
                            // this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.clear();
                            // // const arlTypeEnumKeysForPreChargeByType = getEnumKeys(AccountsReceivableLedgerTypeEnum).filter((v) => isBookingPositionTypeEnum(AccountsReceivableLedgerTypeEnum[v]));
                            // arlTypeEnumKeysForPreChargeByType.forEach((arlTypeKey) => {
                            //     this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.push(
                            //         new FormGroup({
                            //             arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(AccountsReceivableLedgerTypeEnum[arlTypeKey]),
                            //             percentage: new FormControl<number>(null),
                            //         }),
                            //     );
                            // });
                            // if (wasdisabled) {
                            //     this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.disable();
                            // }
                            // this.InfoiceFormGroup.setControl('ARLCalculationPreChargeByTypes', new FormArray<typeof this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.controls[0]>(arlTypeEnumKeysForPreChargeByType.map((arlTypeKey) => new FormGroup({
                            //     arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(AccountsReceivableLedgerTypeEnum[arlTypeKey]),
                            //     percentage: new FormControl<number>(null),
                            // }))));

                            // this.InfoiceFormGroup.controls.ARLSurChargeByTypes.clear();
                            // lvKalkSurchargesByType.forEach((arlTypeKey) => {
                            //     this.InfoiceFormGroup.controls.ARLSurChargeByTypes.push(
                            //         new FormGroup({
                            //             arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(AccountsReceivableLedgerTypeEnum[arlTypeKey]),
                            //             percentage: new FormControl<number>(null),
                            //         }),
                            //     );
                            // });
                            // this.InfoiceFormGroup.setControl('ARLSurChargeByTypes', new FormArray<typeof this.InfoiceFormGroup.controls.ARLSurChargeByTypes.controls[0]>(this.lvKalkSurchargesByType.map((arlTypeKey) => new FormGroup({
                            //     arlType: new FormControl<AccountsReceivableLedgerTypeEnum>(AccountsReceivableLedgerTypeEnum[arlTypeKey]),
                            //     percentage: new FormControl<number>(null),
                            // }),)));

                            let nk: LedgerImportEntity['LVKalkulationNebenkosten'];
                            let gew: LedgerImportEntity['LVKalkulationNebenkostenGewerke'];
                            if (!ledgerImport.LVKalkulationNebenkosten || !ledgerImport.LVKalkulationNebenkostenGewerke) {
                                nk = DEFAULT_INVOICE_NK;
                                gew = DEFAULT_INVOICE_NK_GEWERKE;
                            } else {
                                nk = ledgerImport.LVKalkulationNebenkosten;
                                gew = ledgerImport.LVKalkulationNebenkostenGewerke;
                            }

                            if (this.InfoiceFormGroup.controls.LVKalkulation.controls.Gewerke.length !== gew.length) {
                                const wasDisabled = this.InfoiceFormGroup.controls.LVKalkulation.controls.Gewerke.disabled;
                                this.InfoiceFormGroup.controls.LVKalkulation.controls.Gewerke.clear();
                                gew.forEach((gewerk) => {
                                    this.InfoiceFormGroup.controls.LVKalkulation.controls.Gewerke.push(new FormControl<string>(gewerk));
                                });
                                if (wasDisabled) {
                                    this.InfoiceFormGroup.controls.LVKalkulation.controls.Gewerke.disable();
                                }
                            }
                            if (this.InfoiceFormGroup.controls.LVKalkulation.controls.Nebenkosten.length !== nk.length) {
                                const wasDisabled = this.InfoiceFormGroup.controls.LVKalkulation.controls.Nebenkosten.disabled;
                                this.InfoiceFormGroup.controls.LVKalkulation.controls.Nebenkosten.clear();
                                nk.forEach((nk) => {
                                    this.InfoiceFormGroup.controls.LVKalkulation.controls.Nebenkosten.push(
                                        new FormGroup({
                                            name: new FormControl<string>(nk.name),
                                            comment: new FormControl<string>(nk.comment),
                                            gewerke: new FormArray((gew || []).map((v, i) => new FormControl<number>(nk.gewerke[i] || 0))),
                                        }),
                                    );
                                });
                                if (wasDisabled) {
                                    this.InfoiceFormGroup.controls.LVKalkulation.controls.Nebenkosten.disable();
                                }
                            }

                                const ArlTableDisplayedColumns: ArlTableComponentDisplayedColumns[] = [
                                    ledgerImport.ShowPosition ? 'Position' : null,
                                    ledgerImport.ShowBookingText ? 'BookingText' : null,
                                    ledgerImport.ShowInformation ? 'Information' : null,
                                    ledgerImport.ShowQuantity ? 'Quantity' : null,
                                    ledgerImport.ShowQuantityType ? 'QuantityType' : null,
                                    ledgerImport.ShowBaseCost ? 'BaseCost' : null,
                                    ledgerImport.ShowBaseCostGross ? 'BaseCostGross' : null,
                                    ledgerImport.ShowBaseCost_cost ? 'BaseCost_cost' : null,
                                    ledgerImport.ShowBaseCostGross_cost ? 'BaseCostGross_cost' : null,
                                    ledgerImport.ShowAmount ? 'CompleteCost' : null,
                                    ledgerImport.ShowAmountGross ? 'CompleteCostGross' : null,
                                    ledgerImport.ShowSalaryBaseCost && partner.AdditionalData?.useArlSeparateSalaryBaseCost ? 'BaseCost_salary' : null,
                                    ledgerImport.ShowOtherBaseCost && partner.AdditionalData?.useArlSeparateSalaryBaseCost ? 'BaseCost_other' : null,
                                    ledgerImport.ShowSalaryBaseCost_cost && partner.AdditionalData?.useArlSeparateSalaryBaseCost ? 'BaseCost_salary_cost' : null,
                                    ledgerImport.ShowOtherBaseCost_cost && partner.AdditionalData?.useArlSeparateSalaryBaseCost ? 'BaseCost_other_cost' : null,
                                ];

                                const ArlTableDocumentDisplayedColumns: ArlTableComponentDisplayedColumns[] = ledgerImport.ColumnsNamesInDocument?.filter((col) => !!col) as ArlTableComponentDisplayedColumns[];
                                const initARLSurChargeByTypes = !ledgerImport.LvARLSurchargesByType || ledgerImport.LvARLSurchargesByType.every(v => !isNotNullOrUndefined(v.percentage));
                                console.log('##123 ', initARLSurChargeByTypes, ledgerImport.LvARLSurchargesByType)

                                const ARLSurChargeByTypes = lvKalkSurchargesByType.map((enumKey) => {
                                    const enumValue = AccountsReceivableLedgerTypeEnum[enumKey];
                                    if (initARLSurChargeByTypes) {
                                        const chargeFromEntity = surChargeForArlType(enumValue, defaultSurcharges);
                                        console.log('##123 defaultSurcharges found', chargeFromEntity);
                                        return {
                                            arlType: enumValue,
                                            percentage: chargeFromEntity ? chargeFromEntity.PercentageValue : null,
                                        };
                                    } else {
                                        const chargeFromEntity = ledgerImport.LvARLSurchargesByType?.find((charge) => charge.arlType === enumValue);
                                        return {
                                            arlType: enumValue,
                                            percentage: chargeFromEntity ? chargeFromEntity.percentage : null,
                                        };
                                    }

                                });


                                this.InfoiceFormGroup.setValue(
                                    {
                                        AutomaticNr: ledgerImport.AutomaticInvoiceId || (!ledgerImport.ConsolidatedInvoiceId && ledgerImport.UpdatedAt <= ledgerImport.CreatedAt),
                                        CommissionId: commission ? commission : null,
                                        Customer: customer ? customer : null,
                                        AssignedUser: assignedUser ? assignedUser : null,
                                        PartnerOffice: partnerOffice ? partnerOffice : null,
                                        DeliveryDate: ledgerImport.ConsolidatedDeliveryDate && moment(ledgerImport.ConsolidatedDeliveryDate),
                                        DueDate: ledgerImport.DueDate && moment(ledgerImport.DueDate),
                                        InvoiceDate: ledgerImport.ConsolidatedDate && moment(ledgerImport.ConsolidatedDate),
                                        TextTop: ledgerImport.TextTop,
                                        TextBottom: ledgerImport.TextBottom,
                                        // BookingPositions: ledgerImport.AccountsReceivableLedgerIds?.map(id => bookingPositions.find(bp => bp.Id === id)).filter(isNotNullOrUndefined) || [],
                                        ConsolidatedInvoiceId: ledgerImport.ConsolidatedInvoiceId,
                                        CustomerName: ledgerImport.CustomerName,
                                        CustomerStreet: ledgerImport.CustomerStreet,
                                        CustomerPostalCode: ledgerImport.CustomerPostalCode,
                                        CustomerCity: ledgerImport.CustomerCity,
                                        CustomerCountry: ledgerImport.CustomerCountry,
                                        CustomerEmail: ledgerImport.CustomerEmail,
                                        DeliveryPostalCode: ledgerImport.DeliveryPostalCode,
                                        DeliveryCity: ledgerImport.DeliveryCity,
                                        DeliveryStreet: ledgerImport.DeliveryStreet,
                                        UseDeliveryAddressFromCommission: ledgerImport.UseDeliveryAddressFromCommission,
                                        DeliveryName: ledgerImport.DeliveryName,
                                        CustomerNumber: ledgerImport.AdditionalData?.customerNumber || '',
                                        PartnerCountry: ledgerImport.PartnerCountry,
                                        PartnerEmail: ledgerImport.PartnerEmail,
                                        PartnerPhoneNumber: ledgerImport.PartnerPhoneNumber,
                                        PartnerName: ledgerImport.PartnerName,
                                        PartnerStreet: ledgerImport.PartnerStreet,
                                        PartnerCity: ledgerImport.PartnerCity,
                                        PartnerPostalCode: ledgerImport.PartnerPostalCode,
                                        Status: ledgerImport.Status,
                                        Bankname: ledgerImport.Bankname,
                                        Bic: ledgerImport.Bic,
                                        Blz: ledgerImport.Blz,
                                        Iban: ledgerImport.Iban,
                                        UstId: ledgerImport.UstId,
                                        UserEmail: ledgerImport.UserEmail,
                                        UserName: ledgerImport.UserName,
                                        LogoBase64: this.InfoiceFormGroup.value.LogoBase64 || null,
                                        SkontoAvilable: !!ledgerImport.DiscountPercentage,
                                        SkontoPercentage: ledgerImport.DiscountPercentage || 0,
                                        SkontoDays: Math.round(((ledgerImport.DiscountPaymentDate && ledgerImport.ConsolidatedDate && moment(ledgerImport.DiscountPaymentDate).diff(moment(ledgerImport.ConsolidatedDate), 'hours')) || 0) / 24),
                                        DiscountPercentage: ledgerImport.GuaranteedDiscountPercentage,
                                        Notes: ledgerImport.AdditionalData?.notes ? ledgerImport.AdditionalData?.notes : '',
                                        OurSign: ledgerImport.AdditionalData?.ourSign ? ledgerImport.AdditionalData?.ourSign : '',
                                        // DicountAmount: ledgerImport.DicountAmount
                                        CeoName: ledgerImport.CeoName || '',
                                        RegistryCourt: ledgerImport.RegistryCourt || '',
                                        CommercialRegister: ledgerImport.CommercialRegister || '',
                                        CommissionNumber: ledgerImport.CommissionNumber || '',
                                        AccountsReceivableLedgerIds: ledgerImport.AccountsReceivableLedgerIds || [],
                                        ShowNettoSum: !ledgerImport.HideNetto,
                                        TaxTypeId: ledgerImport.TaxTypeId,
                                        ArlTableDisplayedColumns: ArlTableDisplayedColumns.filter(isNotNullOrUndefined),
                                        ShowTaxSum: ledgerImport.ShowTaxSum,
                                        Title: ledgerImport.Title,
                                        UserPhoneNumber: ledgerImport.UserPhoneNumber,
                                        DeliveryTime: ledgerImport.DeliveryTime,
                                        ServicePeriod: ledgerImport.ServicePeriod,
                                        TextBottomFirst: ledgerImport.TextBottomFirst,
                                        ArlTableStartOnNewPage: ledgerImport.ArlTableStartOnNewPage,
                                        ShowTextBottomFirst: ledgerImport.ShowTextBottomFirst,
                                        ConsolidatedDeliveryDate2: ledgerImport.ConsolidatedDeliveryDate2 && moment(ledgerImport.ConsolidatedDeliveryDate2),
                                        AllowanceCharges: ledgerImport.AllowanceCharges.map((a, i) => ({
                                            percentage: isNotNullOrUndefined(a.percentage) ? a.percentage : null,
                                            amount: isNotNullOrUndefined(a.amount) ? a.amount : null,
                                            customReason: a.customReason || '',
                                            sum: 0,// wird im nachhinein überschrieben
                                            usePercentage: a.usePercentage,
                                        })),

                                        ARLCalculationPreChargeByTypes: arlTypeEnumKeysForPreChargeByType.map((enumKey) => {
                                            const enumValue = AccountsReceivableLedgerTypeEnum[enumKey];
                                            const chargeFromEntity = ledgerImport.ARLCalculationPreChargeByType?.find((charge) => charge.arlType === enumValue);
                                            return {
                                                arlType: enumValue,
                                                percentage: chargeFromEntity ? chargeFromEntity.percentage : null,
                                            };
                                        }),
                                        ARLSurChargeByTypes: ARLSurChargeByTypes,
                                        ARLCalculationGlobalPreCharge: ledgerImport.ARLCalculationGlobalPreCharge,
                                        SkontoIsAllowance: ledgerImport.SkontoIsAllowance,
                                        NebenKostenPercent: ledgerImport.NebenKostenPercent,
                                        EmployeeQuantityTypeId: ledgerImport.EmployeeArlQuantityTypeId,
                                        BreakPageMode: ledgerImport.BreakPageMode,
                                        UseListPriceForNewMaterials: ledgerImport.UseListPriceForNewMaterials,
                                        ReviewPeriodText: ledgerImport.ReviewPeriodText,
                                        SkontoPeriodText: ledgerImport.SkontoPeriodText,
                                        UseQuantityHistory: ledgerImport.UseQuantityHistory,
                                        PaymentItems: ledgerImport.PaymentItems,
                                        PartieStd: ledgerImport.PartieStd,
                                        LVKalkulation: this.InfoiceFormGroup.controls.LVKalkulation.getRawValue(),
                                        //     {
                                        //     Gewerke: ledgerImport.AdditionalData?.lvKalkulationNebenkostenGewerke || [],
                                        //     Nebenkosten: ledgerImport.AdditionalData?.lvKalkulationNebenkosten || [],
                                        // }
                                        IsLvCalculated: ledgerImport.IsLVCalculated,
                                        Arls: this.InfoiceFormGroup.controls.Arls.getRawValue(),
                                        ARLReadOnlyModeSetByUser: ledgerImport.ARLReadOnlyModeSetByUser,
                                        ShowLongInformation: !!ledgerImport.ShowLongInformation,
                                        HideLetterHead: !!ledgerImport.HideLetterHead,
                                        ArlTableDocumentDisplayedColumns: ArlTableDocumentDisplayedColumns.filter(isNotNullOrUndefined),
                                        // VariableScope: ledgerImport.VariableScope ? mjsHelper.CustomScope.deserialize(ledgerImport.VariableScope) : new mjsHelper.CustomScope(),
                                        ShowQRCode: !!ledgerImport.ShowQRCode,
                                        PartnerAccountHolder: ledgerImport.PartnerAccountHolder,
                                        ItemNumbersLocked: !!ledgerImport.ItemNumbersLocked,
                                        InvoiceItemTableStartOnNewPage: !!ledgerImport.InvoiceItemTableStartOnNewPage,
                                        HideSumTable: !!ledgerImport.HideSumTable,
                                        HidePositionsWithoutQuantity: !!ledgerImport.HidePositionsWithoutQuantity,
                                        CustomerUstId: ledgerImport.CustomerUstId,
                                    },
                                    {emitEvent: false}, // todo warum?
                                );

                                setAllowanceChargesFormSums(this.InfoiceFormGroup.controls.AllowanceCharges.value.reduce((sum, a) => sum - (a.amount || 0), (ledgerImport.ConsolidatedNettoAmount || 0) / 100), this.InfoiceFormGroup.controls.AllowanceCharges);
                                if (ledgerImport.AdditionalData?.quantityFormulaVariableScope) {
                                    this.mathJsCustomScopeService.setScope(mjsHelper.CustomScope.deserialize(ledgerImport.AdditionalData.quantityFormulaVariableScope));
                                }

                                // todo fix dafür das ddas set value kein event emmitted
                                this.InfoiceFormGroup.controls.ItemNumbersLocked.setValue(this.InfoiceFormGroup.controls.ItemNumbersLocked.getRawValue())
                                this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.setValue(this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.getRawValue());
                                this.InfoiceFormGroup.controls.IsLvCalculated.setValue(this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue());
                                if (!this.InfoiceFormGroupinitialised$.value) {
                                    this.InfoiceFormGroupinitialised$.next(true);
                                }
                                this.InfoiceFormGroupSetValue$.next();

                                if (this.InfoiceFormGroup.controls.Customer.value) {
                                    this.InfoiceFormGroup.controls.PartnerOffice.disable();
                                }
                                // if (statusIsReadOnly(ledgerImport.Status)) {
                                //     this._disableForms$.next(true);
                                // }
                            } else {
                                this.InfoiceFormGroup.reset();
                            }
                            this.PushValuesToSyncfusion$.next();
                        }),
                )
                .subscribe(),

            // this.EditorCreated$.subscribe(() => this.PushValuesToSyncfusion$.next()),
            this.NewBookingPositionClick$.pipe(
                withLatestFrom(this.LedgerImport$, this.store.select(getCommissions), this.arlDictFromState$, this.FilterMaterialsByCustomerId$, this.isLvCalculated$, this.itemNumbersLocked$),
                tap(([, ledgerImport, commissions, arlDict, filterMaterial, isLvCalculated, itemNumbersLocked]) => {
                    console.warn('triggercounter NewBookingPositionClick$', ledgerImport, commissions, arlDict, filterMaterial);
                    const getItemNumberInformation = (
                        control: arlTableDataArlForm
                    ): ItemNumberInformation[] => {
                        return [
                            [
                                control.controls.ItemNumber.value,
                                control.controls.Information.value
                            ],
                            ...control.controls.childArls.controls.flatMap(child =>
                                getItemNumberInformation(child)
                            ),
                        ];
                    };
                    this.dialog
                        .open<NewBookingOptionComponent, NewOptionDialogData, NewBookingOptionComponentReturnType>(NewBookingOptionComponent, {
                            ...NewBookingOptionComponent.DefaultConfig,
                            data: ledgerImport
                                ? {
                                    newOptionDefaultValues: {
                                        LedgerImportId: ledgerImport.Id,
                                        LedgerImportDocumentType: ledgerImport.DocumentType,
                                        forceItemNumbersDefaultOn: isLvCalculated,
                                        forceItemNumberOninLi: this.InfoiceFormGroup.controls.ItemNumbersLocked.value,
                                    },
                                    accountsReceivableLedgerTemplateFilter: {
                                        CommissionTypeId: commissions.find((c) => c.Id === ledgerImport.CommissionId)?.CommissionTypeId,
                                    },
                                    ListView: false,
                                    addedTemplateIds: (this.InfoiceFormGroup.value.AccountsReceivableLedgerIds || [])
                                        .map((bpId) => _getArlChildren(bpId, arlDict))
                                        .flat()
                                        .map((b) => {
                                            return b.CustomProperties?.rootTemplateId;
                                        })
                                        .filter(isNotNullOrUndefined),
                                    addToLedgerImport: true,
                                    filterMaterialsByCustomerId: filterMaterial,
                                    isOrder: ledgerImport.DocumentType === this.LedgerImportDocumentTypesEnum.Order,
                                    isOffer: ledgerImport.DocumentType === this.LedgerImportDocumentTypesEnum.Offer,
                                    selectLedgerImportDefaultFilter: this.InfoiceFormGroup.controls.CommissionId.getRawValue()?.Id
                                        ? {
                                            [FilterTypes.AssignedCommission]: [{
                                                label: this.InfoiceFormGroup.controls.CommissionId.getRawValue().chipLabel,
                                                id: this.InfoiceFormGroup.controls.CommissionId.getRawValue().Id
                                            }]
                                        }
                                        : undefined,
                                    ledgerImportCurrentItemNumber: this.InfoiceFormGroup.controls.Arls.controls
                                        .flatMap(control => getItemNumberInformation(control)),
                                }
                                : {ListView: false, addedTemplateIds: []},
                        })
                        .afterClosed()
                        .pipe(take(1)) // fix für https://github.com/angular/components/issues/11398
                        .subscribe(async (result: NewBookingOptionComponentReturnType) => {
                            console.log('closed', result);
                            if (!result) {
                                console.warn('triggercounter NewBookingOptionComponentafterClosed', result);
                                return;
                            }

                            const NewArls: AccountsReceivableLedgerEntity[] = (result as {arls: AccountsReceivableLedgerEntity[], openSortDialog: boolean}).arls || (result as AccountsReceivableLedgerEntity[]);

                            console.warn('triggercounter NewBookingOptionComponentafterClosed', result);

                            if (NewArls?.length) {
                                if (this.arlTableComponent) {
                                    firstValueFrom(this.arlTableComponent.tableData$).then(async (array) => {
                                        if ((result as {arls: AccountsReceivableLedgerEntity[], openSortDialog: boolean}).openSortDialog || Array.isArray(result)) {
                                            console.warn('triggercounter this.arlTableComponent.tableData$', array);
                                            this.dialog
                                                .open<ArlPositionDialogComponent, ArlPositionDialogComponentDialogData, ArlPositionDialogComponentDialogReturnData>(ArlPositionDialogComponent, {
                                                    width: '40vw',
                                                    data: {
                                                        Array: array,
                                                        AllowOnlyLastPositionInGroup: false, //Dialog shows only Options at the end of Groups no longe needed for default arl-table
                                                        initialSelectedIndex: (result as {openSortDialogDefaultItemNumber: string | null}).openSortDialogDefaultItemNumber ? array.findIndex(d => determineIfIsArlTableDataOrGroupEnd(d) && d.form.controls.ItemNumber.getRawValue() === (result as {openSortDialogDefaultItemNumber: string | null}).openSortDialogDefaultItemNumber) : undefined,
                                                    },
                                                })
                                                .afterClosed()
                                                .pipe(take(1)) // fix für https://github.com/angular/components/issues/11398
                                                .subscribe(async (index) => {
                                                    console.warn('triggercounter ArlPositionDialogComponentafterClosed', index);

                                                    if (index != null) {
                                                        if (itemNumbersLocked || NewArls.find(arl => arl.ItemNumber !== null && arl.ItemNumber !== ' ')) {
                                                            this.InfoiceFormGroup.controls.ItemNumbersLocked.setValue(true);
                                                            this.arlTableComponent.allreadyCalculated = false;
                                                        }
                                                        await this.arlTableComponent.addArlsToTable(NewArls, index);
                                                    }
                                                });
                                        } else {


                                            for (const arl of NewArls) {
                                                console.log('### add arls 2', {itemNumbersLocked, NewArls, NewArlsCopy: JSON.parse(JSON.stringify(NewArls))});
                                                if (itemNumbersLocked || NewArls.find(arl => arl.ItemNumber !== null && arl.ItemNumber !== AccountsReceivableLedgerEntity.autogenerateItemNumber)) {
                                                    this.InfoiceFormGroup.controls.ItemNumbersLocked.setValue(true);
                                                    this.arlTableComponent.allreadyCalculated = false;
                                                }
                                                const currentArray = await firstValueFrom(this.arlTableComponent.tableData$);
                                                const index = this.arlTableComponent.findInsertionIndex(currentArray, this.arlTableComponent.parseItemNumberSegments(arl.ItemNumber));
                                                await this.arlTableComponent.addArlsToTable([arl], index);
                                            }
                                        }
                                    });
                                } else if (NewArls.find(arl => arl.ItemNumber !== null && arl.ItemNumber !== ' ')) {
                                    this.InfoiceFormGroup.controls.ItemNumbersLocked.setValue(true);
                                }
                                this.InfoiceFormGroup.markAsDirty();
                                // this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.setValue([...this.InfoiceFormGroup.value.AccountsReceivableLedgerIds, ...NewArls.map(a => a.Id),])
                                // sort new Arls below the last clicked Arl
                                // const list = this.SortedBookingPositionList$.value;
                                // const invertedLastSelected  = list.reverse().findIndex(arl => this.IsSelected(arl))
                                // list.reverse();
                                // let lastSelected = -1
                                // if (invertedLastSelected > -1) {
                                //        lastSelected = list.length - invertedLastSelected
                                //     }
                                // this.SortedBookingPositionList$.next([
                                //     ...list.filter((arl, i) => i < lastSelected),
                                //     ...NewArls,
                                //     ...list.filter((arl, i) => i >= lastSelected),
                                // ])

                                // sort all clicked Arls to the top of the list with the newest at last
                                // this.SortedBookingPositionList$.next([
                                //     ...this.SortedBookingPositionList$.value.filter(x => this.IsSelected(x)/* && !NewArls.some(a => a.Id === x.Id)*/),
                                //     // ...this.SortedBookingPositionList$.value.filter(x => this.IsSelected(x) && NewArls.some(a => a.Id === x.Id)),
                                //     ...NewArls,
                                //     ...this.SortedBookingPositionList$.value.filter(x => !this.IsSelected(x))
                                // ]);

                                NewArls.forEach((x) => {
                                    if (!this.arlValidCheck(x)) {
                                        return;
                                    }
                                    // todo fix new booking position
                                    // this.CilickItem(x)
                                });
                                this.PushValuesToSyncfusion$.next();
                                this.cdr.detectChanges();
                            }
                        });
                    // })
                }),
            ).subscribe(),
            combineLatest([this.DisableArlForms$, this.disableGaebRelevantForms$])
                .pipe(distinctUntilChanged((a, b) => compareArrays(a, b)))
                .subscribe(([disableAll, disableGaebRelevant]) => {


                    function disableArl(form: arlTableDataArlForm | calculationArlFormGroup, disable: boolean) {
                        // Alle hier disabledtedn Forms müssen in der speichern methode mit getRawValue ausgelesen werden
                        if (form.controls.Quantity.disabled !== disable) {
                            if (disable) {
                                form.controls.Quantity.disable({emitEvent: false});
                            } else {
                                form.controls.Quantity.enable({emitEvent: false});
                            }
                        }
                        if (form.controls.Information.disabled !== disable) {
                            if (disable) {
                                form.controls.Information.disable({emitEvent: false});
                            } else {
                                form.controls.Information.enable({emitEvent: false});
                            }
                        }
                    }
                    function disableArlRecursiv(form: arlTableDataArlForm, disable: boolean) {
                        disableArl(form, disable);
                        if (form.controls.childArls) {
                            form.controls.childArls.controls.forEach((child) => {
                                disableArlRecursiv(child, disable);
                            });
                        }
                        if (form.controls.childArlsCalculation) {
                            form.controls.childArlsCalculation.controls.forEach((child) => {
                                disableArl(child, disable);
                            });
                        }
                    }
                    this.arlFormDataService.createNewFormsDisabled = !!disableAll;
                    if (disableAll) {
                        this.InfoiceFormGroup.disable({emitEvent: false});
                        this.recipientPersonForm.disable({emitEvent: false});
                        this.recipientCustomerForm.disable({emitEvent: false});
                        this.InfoiceFormGroup.controls.Status.enable({emitEvent: false});
                        this.InfoiceFormGroup.controls.CommissionId.enable({emitEvent: false});
                    } else {
                        this.InfoiceFormGroup.enable({emitEvent: false});
                        this.recipientPersonForm.enable({emitEvent: false});
                        this.recipientCustomerForm.enable({emitEvent: false});
                        this.InfoiceFormGroup.controls.Arls.controls.forEach((arl) => disableArlRecursiv(arl, disableGaebRelevant));
                    }
                }),
            this.InfoiceFormGroup.controls.SkontoAvilable.valueChanges
                .pipe(
                    startWith(''),
                    map(() => this.InfoiceFormGroup.controls.SkontoAvilable.value),
                    withLatestFrom(this.DisableArlForms$),
                )
                .subscribe(([skonto, disabled]) => {
                    if (skonto) {
                        if (!disabled) {
                            this.InfoiceFormGroup.controls.SkontoDays.enable();
                            this.InfoiceFormGroup.controls.SkontoPercentage.enable();
                            this.InfoiceFormGroup.controls.SkontoIsAllowance.enable();
                        }
                    } else {
                        this.InfoiceFormGroup.controls.SkontoDays.disable();
                        this.InfoiceFormGroup.controls.SkontoPercentage.disable();
                        this.InfoiceFormGroup.controls.SkontoIsAllowance.disable();
                    }
                }),
            this.InfoiceFormGroup.controls.CommissionId.valueChanges
                .pipe(
                    pairwise(),
                    withLatestFrom(this.store.select(getPartner), this.LedgerImport$),
                )
                .subscribe(async ([[previousCid, cid], partner, li]) => {

                    if (previousCid?.Id === cid?.Id) {
                        return
                    }

                    if (partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData) {
                        const skontoFromCommission = cid?.getSkontoForLedgerImports(li.DocumentType);

                        if (skontoFromCommission) {
                            this.InfoiceFormGroup.controls.SkontoAvilable.setValue(true);
                            this.InfoiceFormGroup.controls.SkontoPercentage.setValue(skontoFromCommission);
                        }
                        const scontoPeriodFromCommission = cid?.getSkontoPeriodForLedgerImports(li.DocumentType);
                        if (scontoPeriodFromCommission) {
                            this.InfoiceFormGroup.controls.SkontoDays.setValue(scontoPeriodFromCommission);
                        }
                    }
                    if (li.DocumentType !== LedgerImportDocumentTypes.Order &&
                        li.DocumentType !== LedgerImportDocumentTypes.OrderConfirmation &&
                        li.DocumentType !== LedgerImportDocumentTypes.ReturnDeliveryNote &&
                        li.DocumentType !== LedgerImportDocumentTypes.DeliveryNote
                    ) {
                        if (this.InfoiceFormGroup.controls.CommissionId.value?.CustomerId) {
                            const customer = await firstValueFrom(this.customerDataService.GetSingleCustomer$(this.InfoiceFormGroup.controls.CommissionId.value.CustomerId))
                            this.InfoiceFormGroup.controls.Customer.setValue(customer)
                        } else {
                            this.InfoiceFormGroup.controls.Customer.setValue(null)
                        }
                    }
                    if (this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.value) {
                        if (this.InfoiceFormGroup.controls.CommissionId.value === null) {
                            this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.setValue(false)
                            this.updateDeliveryAddress(false, true)
                        } else {
                            this.preventUseDeliveryAddressFromCommissionSubscription = true;
                            this.updateDeliveryAddress(true)
                        }
                    }

                    if (partner?.AdditionalData?.invoiceEditorUseCommissionTitle) {
                        if (cid?.Description) {
                            this.InfoiceFormGroup.controls.Title.setValue(cid.Description)
                        } else {
                            this.InfoiceFormGroup.controls.Title.setValue('')
                        }
                    }
                    const isTsb = partner.PartnerTypeId === PartnerTypeEnum.TSB;
                    if (cid) {
                        if (!isTsb && cid.Auftragsnummer !== this.InfoiceFormGroup.value.CommissionNumber) {
                            this.InfoiceFormGroup.controls.CommissionNumber.setValue(cid.Auftragsnummer);
                        } else if (isTsb && cid.InterneNummer !== this.InfoiceFormGroup.value.CommissionNumber) {
                            this.InfoiceFormGroup.controls.CommissionNumber.setValue(cid.InterneNummer);
                        }
                    }
                    if (isTsb) {
                        this.InfoiceFormGroup.controls.Title.setValue(tsb.getLedgerImportTitle(this.InfoiceFormGroup.value.Title ?? '', cid));
                    }
                }),
            this.store
                .select(getPartner)
                .pipe(
                    filter((p) => p.PartnerTypeId === PartnerTypeEnum.TSB || p.Id === window['env']['ibbau_partner_id']),
                    switchMap((p) => this.InfoiceFormGroup.controls.InvoiceDate.valueChanges.pipe(map((invoiceDate) => ({
                        partner: p,
                        invoiceDate
                    })))),
                    debounceTime(300),
                    withLatestFrom(this.LedgerImport$),
                )
                .subscribe(([{partner, invoiceDate}, ledgerImport]) => {
                    if (partner.PartnerTypeId === PartnerTypeEnum.TSB) {
                        const newDate = tsb.calcLedgerImportDueDate(ledgerImport.DocumentType, invoiceDate, this.InfoiceFormGroup.controls.Customer.value?.PaymentTargetInDays);
                        if (newDate && !partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData) {
                            this.InfoiceFormGroup.controls.DueDate.setValue(newDate);
                        }
                    } else if (partner.Id === window['env']['ibbau_partner_id']) {
                        const newDate = ibbau.calcLedgerImportDueDate(invoiceDate, this.InfoiceFormGroup.controls.Customer.value?.PaymentTargetInDays);
                        if (newDate) {
                            this.InfoiceFormGroup.controls.DueDate.setValue(newDate);
                        }
                    }
                }),
            // temp fix für D277-4954 wird mit D277-4723 anders wieder eingebaut
            // this.InfoiceFormGroup.controls.CommissionId.valueChanges
            //     .pipe(
            //         skip(1), // dirty fix for D277-3741 must be deleted when D277-3753
            //         distinctUntilChanged((a, b) => a?.Id === b?.Id || (!a?.Id && !b?.Id))
            //
            //     )
            //     .subscribe(commission => {
            //         if(commission){
            //          this.InfoiceFormGroup.controls.DeliveryCity.setValue(commission.City);
            //             this.InfoiceFormGroup.controls.DeliveryStreet.setValue(commission.Street);
            //             this.InfoiceFormGroup.controls.DeliveryName.setValue(commission.CustomerName);
            //             this.InfoiceFormGroup.controls.DeliveryPostalCode.setValue(commission.PostalCode);
            //         }
            //     }),
            this.InfoiceFormGroupinitialised$.pipe(
                filter(v => v),
                switchMap(() => this.InfoiceFormGroup.controls.Customer.valueChanges.pipe(
                    map(() => this.InfoiceFormGroup.controls.Customer.getRawValue()),
                    withLatestFrom(this.store.select(getPartnerOffices), this.LedgerImport$, this.store.select(getPartner), this.store.select(getCommissionDictionary)),
                    switchMap(([customerForm, partnerOffices, ledgerImport, partner, commissions]) =>
                        (customerForm?.Id ? this.customerDataService.GetSingleCustomer$(customerForm.Id).pipe(take(1)) : of(null)).pipe(
                            map((customer) => ({partnerOffices, ledgerImport, partner, commissions, customer})),
                        ),
                    ),
                    tap(({partnerOffices, ledgerImport, partner, commissions, customer}) => {
                        const isTsb = partner.PartnerTypeId === PartnerTypeEnum.TSB;

                        if (customer) {
                            this.setReciplientCustomer(customer);

                            if (
                                this.InfoiceFormGroup.controls.CommissionId.getRawValue() &&
                                this.InfoiceFormGroup.controls.CommissionId.getRawValue().CustomerId !== customer.Id &&
                                (!customer.IsSupplier ||
                                    (ledgerImport.DocumentType !== LedgerImportDocumentTypes.Order &&
                                        ledgerImport.DocumentType !== LedgerImportDocumentTypes.OrderConfirmation &&
                                        ledgerImport.DocumentType !== LedgerImportDocumentTypes.DeliveryNote &&
                                        ledgerImport.DocumentType !== LedgerImportDocumentTypes.ReturnDeliveryNote))
                            ) {
                                this.InfoiceFormGroup.controls.CommissionId.setValue(null, {emitEvent: false});
                                if (partner?.AdditionalData?.invoiceEditorUseCommissionTitle) {
                                    this.InfoiceFormGroup.controls.Title.setValue('')
                                }
                                this.InfoiceFormGroup.controls.CommissionId.markAsDirty();
                            }

                            const selectedCommission = commissions[this.InfoiceFormGroup.controls.CommissionId.getRawValue()?.Id];
                            const skontoFromCommission = selectedCommission?.getSkontoForLedgerImports(ledgerImport.DocumentType);

                            if (!(partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData && isNotNullOrUndefined(skontoFromCommission))) {
                                if (customer.PaymentDiscount) {
                                    this.InfoiceFormGroup.controls.SkontoAvilable.setValue(true);
                                    this.InfoiceFormGroup.controls.SkontoPercentage.setValue(customer.PaymentDiscount);

                                    const scontoPeriodFromCommission = selectedCommission?.getSkontoPeriodForLedgerImports(ledgerImport.DocumentType);
                                    if (customer.PaymentDiscountTargetInDays && !(partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData && isNotNullOrUndefined(scontoPeriodFromCommission))) {
                                        this.InfoiceFormGroup.controls.SkontoDays.setValue(customer.PaymentDiscountTargetInDays);
                                    }
                                } else {
                                    this.InfoiceFormGroup.controls.SkontoAvilable.setValue(false);
                                    this.InfoiceFormGroup.controls.SkontoPercentage.setValue(0);
                                }
                            }

                            if (customer.PaymentTargetInDays && !partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData && this.InfoiceFormGroup.controls.InvoiceDate?.value && (customer.PartnerId !== window['env']['ibbau_partner_id'] || !isTsb)) {
                                this.InfoiceFormGroup.controls.DueDate.setValue(this.InfoiceFormGroup.controls.InvoiceDate?.value.clone().add(customer.PaymentTargetInDays * 24, 'hours'));
                            } else if (!partner?.AdditionalData?.invoiceEditorUseCommissionInvoiceData) {
                                this.InfoiceFormGroup.controls.DueDate.setValue(null);
                            }

                            if (customer.PartnerOfficeId) {
                                const partnerOffice = partnerOffices.find((po) => po.Id === customer.PartnerOfficeId);
                                this.InfoiceFormGroup.controls.PartnerOffice.setValue(partnerOffice ? partnerOffice : null);
                            }

                            this.InfoiceFormGroup.controls.PartnerOffice.disable();
                            this.InfoiceFormGroup.controls.PartnerOffice.markAsPristine();

                            if (isNotNullOrUndefined(customer.TaxTypeId)) {
                                this.InfoiceFormGroup.controls.TaxTypeId.setValue(customer.TaxTypeId);
                                this.setAllTax(customer.TaxTypeId);
                            }
                        } else if (this.InfoiceFormGroup.controls.PartnerOffice.disabled) {
                            this.InfoiceFormGroup.controls.PartnerOffice.enable();
                        }
                    }),
                ))
            )
                .subscribe(),
            this.InfoiceFormGroup.controls.PartnerOffice.valueChanges
                .pipe(
                    pairwise(), // this.InfoiceFormGroup.controls.PartnerOffice.updateValueAndValidity({ onlySelf: false, emitEvent: true }); at the End of the constructor to show logo inital
                    tap(([prev, curr]) => {
                        if (curr?.Id && curr.Id !== prev?.Id) {
                            this.InfoiceFormGroup.patchValue({
                                Iban: curr.IBAN,
                                Bic: curr.Bic,
                                Bankname: curr.BankName,
                                UstId: curr.UstID,

                                PartnerName: curr.Name,
                                PartnerStreet: curr.Street,
                                PartnerPostalCode: curr.PostalCode,
                                PartnerCity: curr.City,
                                PartnerPhoneNumber: curr.PhoneNumber,
                                PartnerEmail: curr.Email,
                                PartnerAccountHolder: curr.AccountHolder,
                            });
                        }
                    }),
                )
                .subscribe(),
            this.InfoiceFormGroup.controls.ShowQRCode.valueChanges.subscribe(v => {
                this.setQRCodeText();
            }),


            this.OpenDeleteDialog$.pipe(withLatestFrom(this.LedgerImport$, this.cls.getSingle$('Commission'))).subscribe(([, ledgerImport, commissionLabel]) => {
                this.dialog
                    .open<AppConfirmationDialogComponent, AppConfirmationDialogData>(AppConfirmationDialogComponent, {
                        data: {
                            paragraph: ledgerImport.IsTemplate ? 'Vorlage wirklich löschen?' : this.LedgerImportDocumentTypeNames.get(ledgerImport.DocumentType) + ' wirklich löschen?',
                            warning: ledgerImport.DocumentType === LedgerImportDocumentTypes.DeliveryNote ? 'Beim Löschen eines Lieferscheins werden die Materialverbräuche im ' + commissionLabel + ' angepasst.' : null,
                            styleDelete: true,
                        },
                    })
                    .afterClosed()
                    .pipe(
                        filter(([response]) => !!response),
                        withLatestFrom(this.LedgerImport$),
                        tap(([, ledgerImport]) => {
                            this.store.dispatch(LedgerImportActionTypes.DeleteLedgerImport({Payload: {id: ledgerImport.Id}}));
                        }),
                        tap(() => this.router.navigate(['../'], {relativeTo: this.route})),
                    )
                    .subscribe();
            }),
            this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.valueChanges.pipe(
                startWith(false),
                pairwise(),
                debounceTime(1),
                switchMap(([p, c]) => merge(
                        this.InfoiceFormGroup.controls.DeliveryName.valueChanges,
                        this.InfoiceFormGroup.controls.DeliveryStreet.valueChanges,
                        this.InfoiceFormGroup.controls.DeliveryPostalCode.valueChanges,
                        this.InfoiceFormGroup.controls.DeliveryCity.valueChanges,
                    ).pipe(
                        debounceTime(1),

                        filter(() => !p && c)
                    )
                )
            ).subscribe(() => {

                if (this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.value) {
                    if (!this.preventUseDeliveryAddressFromCommissionSubscription) {
                        this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.setValue(false);
                    }
                    this.preventUseDeliveryAddressFromCommissionSubscription = false;
                }
            }),
        );

        this.customerLable$ = this.LedgerImport$
            .pipe(
                map((li) => li.DocumentType),
                distinctUntilChanged(),
                switchMap((documentType) =>
                    this.cls.getSingle$(
                        documentType !== LedgerImportDocumentTypes.Order && documentType !== LedgerImportDocumentTypes.OrderConfirmation
                            ? 'CustomerSupplier'
                            : 'Supplier',
                    ),
                ),
            );
        this.customerLable$.pipe(takeUntil(this.onDestroy$)).subscribe((cl) => {this.customerLable = cl});
        // initial search
        Promise.all([firstValueFrom(this.customerLable$), firstValueFrom(this.LedgerImport$)]).then(([label, li]) => {
            this.customerSearch.currentUnnamedLabel = 'unbenannter ' + label;
            if ([
                LedgerImportDocumentTypes.Order,
                LedgerImportDocumentTypes.OrderConfirmation,
                LedgerImportDocumentTypes.DeliveryNote,
                LedgerImportDocumentTypes.ReturnDeliveryNote,
            ].includes(li.DocumentType)) {
                this.customerSearch.setFilter({...this.customerSearch.currentFilter, [FilterTypes.Supplier]: true})
            }
            this.customerSearch.fetchFirstPage();
        });
        // Logo bei Vorschau laden
        this.InfoiceFormGroup.controls.PartnerOffice.updateValueAndValidity({onlySelf: false, emitEvent: true});
    }

    // detect scrolling in editBillScreen

    onLvPageEvent(e: PageEvent) {
        if (e.previousPageIndex !== e.pageIndex) {
            scrollTo('#scrollAnker');
        }
    }

    protected updateArlIds(ids: number[]) {
        this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.setValue(ids);
        this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.markAsDirty();
        console.log(
            'updateArlIds',
            ids,
            ids.map((id) => this.arlFormDataService.getForm(id)),
        );
        this.setArlForms(ids.map((id) => this.arlFormDataService.getForm(id)));
    }

    private setArlForms(arlForms: arlTableDataArlForm[]) {
        // this.InfoiceFormGroup.controls.Arls.clear();
        console.log('setArlForms', arlForms, this.InfoiceFormGroup.controls.Arls, this.InfoiceFormGroup);
        const newFormArray =  new FormArray<arlTableDataArlForm>(arlForms);
        this.InfoiceFormGroup.setControl('Arls', newFormArray);
        // arlForms.forEach((arlForm) => {
        //     console.log(arlForm);
        //     this.InfoiceFormGroup.controls.Arls.push(arlForm);
        // });
    }

    async donwloadLiDocumentId(documentId: number, li: LedgerImportEntity) {
        const documentUrl = await firstValueFrom(
            this.fileDataService.GetFileById$(documentId, true).pipe(
                filter(isNotNullOrUndefined),
                withLatestFrom(this.store.select(getToken)),
                map(([file, token]) => {
                    return this.api.GetUrl(file.GetLastVersion().GetDownloadLink(token), 'file')
                }),
            ),
        );

        const btn = document.createElement('a');
        btn.download = this.GetFilename(li.ConsolidatedInvoiceId);
        btn.href = documentUrl;
        document.body.appendChild(btn);
        btn.click();
        document.body.removeChild(btn);
    }

    onExportGaebClick(type: 'x83' | 'x84' | 'ugl' | 'onlv' | 'p83' | 'p84' | 'd83' | 'd84' | 'dta') {
        this.dialog
            .open<SetQuantityDialogGaebComponent, SetQuantityDialogGaebComponentDialogData, SetQuantityDialogGaebComponentDialogReturnData>(SetQuantityDialogGaebComponent, {})
            .afterClosed()
            .subscribe(async (selectedOption) => {
                this.ls.startLoading('gaebExport-start');
                const downloadType = selectedOption ? (`${type}wq` as 'x83wq' | 'x84wq' | 'uglwq' | 'p83wq' | 'p84wq' | 'd83wq' | 'd84wq' | 'onlv' | 'onlvwq' | 'dtawq') : type;
                const isNothingDirty = await firstValueFrom(this.nothingDirty$);
                if (!isNothingDirty) {
                    await this.SaveClick();
                }
                const gaebKey = this.downloadTypeToGaebKey[downloadType];

                const li = await firstValueFrom(this.LedgerImport$);
                if (li.GaebExportedDocumentIds?.hasOwnProperty(gaebKey)) {
                    try {
                        switch (downloadType) {
                            case 'x83':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequest, li);
                                break;
                            case 'x83wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequestWQ, li);
                                break;
                            case 'p83':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequestP, li);
                                break;
                            case 'p83wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequestWQP, li);
                                break;
                            case 'd83':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequestD, li);
                                break;
                            case 'd83wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferRequestWQD, li);
                                break;
                            case 'x84':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOffer, li);
                                break;
                            case 'x84wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferWQ, li);
                                break;
                            case 'p84':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferP, li);
                                break;
                            case 'p84wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferWQP, li);
                                break;
                            case 'd84':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferD, li);
                                break;
                            case 'd84wq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.GabeOfferWQD, li);
                                break;
                            case 'ugl':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.Ugl, li);
                                break;
                            case 'uglwq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.UglWQ, li);
                                break;
                            case 'onlv':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.Oenorm, li);
                                break;
                            case 'onlvwq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.OenormWQ, li);
                                break;
                            case 'dta':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.OenormDTA, li);
                                break;
                            case 'dtawq':
                                await this.donwloadLiDocumentId(li?.GaebExportedDocumentIds?.OenormWQDTA, li);
                                break;
                        }
                    } catch (e) {
                        const documentId = await this.gatewayService
                            .Request({
                                GabeLedgerImportToFile: {
                                    LedgerImportId: li.Id.toString(),
                                    Type: this.downloadTypeToGaebType[downloadType],
                                    SetQuantities: selectedOption,
                                    GaebFileType: this.downloadFileTypeTypeToGaebType[downloadType],
                                },
                            })
                            .then((res) => {
                                this.ledgerImportDataService.getLedgerImportId$(this.LedgerImportId, true).pipe(take(1)).subscribe();
                                return +res.GabeLedgerImportToFile.DocumentId
                            })
                            .catch(e => {
                                this.store.dispatch(BaseActionTypes.ErrorAction({
                                    Payload: {
                                        ToasterMessage: 'Datei einlesen fehlgeschlagen',
                                        Err: e,
                                    }
                                }))
                            });
                        if (documentId) {
                            await this.donwloadLiDocumentId(documentId, li);
                        }
                    }
                } else {
                    const documentId = await this.gatewayService
                        .Request({
                            GabeLedgerImportToFile: {
                                LedgerImportId: li.Id.toString(),
                                Type: this.downloadTypeToGaebType[downloadType],
                                SetQuantities: selectedOption,
                                GaebFileType: this.downloadFileTypeTypeToGaebType[downloadType],
                            },
                        })
                        .then((res) => +res.GabeLedgerImportToFile.DocumentId)
                        .catch(e => {
                            this.store.dispatch(BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: 'Datei einlesen fehlgeschlagen',
                                    Err: e,
                                }
                            }))
                        });

                    if (documentId) {
                        await this.donwloadLiDocumentId(documentId, li);
                    }
                }
                this.ls.endLoading('gaebExport-start');
            });
    }

    ngAfterViewInit() {
        // Drag & Drop Knöpfe zum Header hinzufügen
        // const arlTableHeader = document.querySelector(`#${this.id} #arlTableHeader`);
        // const arlTableDrag = document.querySelector(`#${this.id} #arlTableDrag`);
        // arlTableHeader.append(arlTableDrag);

        this.afterViewInit$.next(true);

        // Scrollt an den Anfang des Contents innerhalb der mat-card, die als Content-Wrapper dient
        this.formWrapper.nativeElement.scrollTop = 0;

        this.subscriptions.push(
            // fix for finding dragHandle in mat-table https://github.com/angular/components/issues/13770
            this.bs.TouchQuery.pipe(
                filter((touch) => touch),
                switchMap(() =>
                    combineLatest([this.drags.changes, this.handles.changes]).pipe(
                        startWith([]),
                        map(() => zip(this.drags.toArray(), this.handles.toArray())),
                        delay(100), // waits for cdk to finish his work
                        mergeAll(),
                    ),
                ),
            ).subscribe(([drag, handle]) => {
                drag._dragRef.withHandles([handle.element]);
            }),
            merge(this.InfoiceFormGroup.controls.AutomaticNr.valueChanges, this.InfoiceFormGroupSetValue$)
                .pipe(
                    startWith(null),
                    map(() => this.InfoiceFormGroup.controls.AutomaticNr.getRawValue()),
                )
                .subscribe((v) => {
                    if (v && this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.enabled) {
                        this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.disable();
                        // this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.setValue(null);
                    } else if (!v && this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.disabled) {
                        this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.enable();
                        // this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.setValue(null);
                    }
                }),
            this.InfoiceFormGroup.controls.ShowTextBottomFirst.valueChanges
                .pipe(
                    startWith(null),
                    map(() => this.InfoiceFormGroup.controls.ShowTextBottomFirst.getRawValue()),
                )
                .subscribe((v) => {
                    if (!v && this.InfoiceFormGroup.controls.TextBottomFirst.enabled) {
                        this.InfoiceFormGroup.controls.TextBottomFirst.disable();
                    } else if (v && this.InfoiceFormGroup.controls.TextBottomFirst.disabled) {
                        this.InfoiceFormGroup.controls.TextBottomFirst.enable();
                    }
                }),
        );


        this.nothingDirty$ = combineLatest([
            this.ngDoCheck$.pipe(
                startWith(null),
                map(() => this.InfoiceFormGroup.dirty),
            ),
            this.InfoiceFormGroup.valueChanges.pipe(
                startWith(null),
                map(() => this.InfoiceFormGroup.dirty),
            ),
            this.SfdtIsDirty$,
            this.arlTableSomeFormDirty$,
            this.variableScopeDirty$,
        ]).pipe(
            map((dirties) => {
                // console.log('dirties', dirties, this.InfoiceFormGroup);
                // Object.keys(this.InfoiceFormGroup.controls).forEach((key) => {
                //     if (this.InfoiceFormGroup.controls[key].dirty) {
                //         console.log('dirty key', key);
                //
                //     }
                // });
                // const logDirtyArls = (i: arlTableDataArlForm) => {
                //     if (i.dirty) {
                //         Object.keys(i.controls).forEach((key) => {
                //             if (i.controls[key].dirty) {
                //                 console.log('dirty arl key', key);
                //             }
                //         });
                //         if (i.controls.childArls.dirty) {
                //             i.controls.childArls.controls.forEach(k => logDirtyArls(k))
                //         }
                //     }
                // }
                // this.InfoiceFormGroup.controls.Arls.controls.forEach(i => {
                //     logDirtyArls(i);
                // })
                return dirties.every((d) => !d)
            }),
            distinctUntilChanged(),
            // shareReplay({refCount: true, bufferSize: 1}), ont share so you can check synchron with firstValueFrom
        );
        this.ngZone.runOutsideAngular(() => {
            const scrollContainer = document.getElementById('editBillScreen');
            if (!scrollContainer) {
                throw 'scrollContainer wit id:editBillScreen not found after viewinit';
            } else {
                scrollContainer.addEventListener('scroll', (event) => onScroll(scrollContainer, event));
            }
        });
    }

    setConcurrency(active: boolean, fallbackLedgerImportId?: number){
        this.gatewayService.Request({
            ConcurrencyConcurrencySet: {
                EntityId: (this.LedgerImportId || fallbackLedgerImportId).toString(),
                Active: active,
                EntityType: EntityType.LedgerImport,
            }
        }).then(res => {

        }).catch(err => {
            console.error(err);
        })
    }

    protected concurrencyInterval: NodeJS.Timer;


    ngOnDestroy(): void {
        if(this.concurrencyInterval) {
            clearInterval(this.concurrencyInterval);
        }
        this.subscriptions.forEach((s) => s.unsubscribe());
        this.onDestroy$.next();
        setTimeout(() => {
            this.setConcurrency(false);
        }, 50)
    }

    ngDoCheck(): void {
        this.ngDoCheck$.next();
        // console.log( "ngDoCheck() :", Date.now() );
    }

    compareById = (a: {Id?: number}, b: {Id?: number}) => a?.Id === b?.Id;

    private async calcVariables() {
        const [li, quantityTypes, arls, calculationFormMap, defaultValuesForAddedArls, arlSumCurrencies, totalFromPartialInvoiceForms, alreadyPayedSum, alreadyPayedSumDifference, partner] = await firstValueFrom(
            combineLatest([
                this.LedgerImport$,
                this.store.select(getQuantityTypes).pipe(filter(isNotNullOrUndefined)),
                this.arlDictFromState$,
                this.afterViewInit$.pipe(
                    filter((init) => init),
                    switchMap(() =>
                        this.isLvCalculated$.pipe(
                            switchMap((isLvCalculated) => {
                                return isLvCalculated ? of(new Map<number, Array<ɵFormGroupValue<calculationArlForm> & {
                                    getBaseCost: () => number
                                }>>()) : this.arlTableComponent.getArlCalculationForms();
                            }),
                        ),
                    ),
                ),
                this.AddARLDefaultValues$,
                this.arlSumCurrencies$,
                this.totalFromPartialInvoiceForms$,
                this.alreadyPayedSum$,
                this.alreadyPayedSumDifference$,
                this.store.select(getPartner),
            ]),
        );

        const defaultForNewArls = {
            Tax: defaultValuesForAddedArls.tax,
            IsVisible: defaultValuesForAddedArls.isVisible,
            CurrencyCode: defaultValuesForAddedArls.currencyCode,
        };
        return await this.getTwigVariables(
            !!partner.AdditionalData?.useArlSeparateSalaryBaseCost,
            li,
            quantityTypes,
            arls,
            arlSumCurrencies.withAllowanceCharges,
            arlSumCurrencies.withAllowanceChargesButScontoIgnored,
            totalFromPartialInvoiceForms,
            alreadyPayedSum,
            alreadyPayedSumDifference,
            alreadyPayedSumDifference.ignoreSkonto,
            true,
            calculationFormMap,
            defaultForNewArls,
        );
    }

    private generateSfdt = () =>
        firstValueFrom(combineLatest([this.invoiceTemplate.pipe(filter(isNotNullOrUndefined)), this.calcVariables()])).then(([template, variables]) => {
            console.log({...variables});
            const body = this.sfdtTemplateService.FillTemplateByTwig(template.Html, variables);
            return {body};
        });
    public pdfPreview$: Observable<any> = this.livePreview$.pipe(
        distinctUntilChanged(),
        switchMap((live) =>
            live
                ? this.PushValuesToSyncfusion$.pipe(startWith(null))
                : this.triggerPreview$
        ),
        startWith(null),
        switchMap(() => this.generateSfdt()),
        distinctUntilChanged((a, b) => a.body === b.body /*&& a.footer === b.footer && a.header === b.header*/),
        tap(() => this.previewPdfIsLoading$.next(true)),
        switchMap((templates) => {
            // let compressedBodyTemplate: Promise<string>;

            let compress = false;

            if (useGzip()) {
                console.log('Gzip compression enabled');
                compress = true;
            }

            async function compressedBodyTemplate(): Promise<string> {
                try {
                    const blob = await gzipCompress(templates.body);
                    return btoa(Uint8ToString(blob));
                } catch (e) {
                    console.log('Gzip compression failed', e);
                    return null;
                }
            }

            return (compress ? defer(() => compressedBodyTemplate()) : of(null)).pipe(switchMap((compressedBody) => {
                return this.ledgerImportDataService.getPdfFromHtml$({
                    Html: compressedBody || templates.body,
                    IsGzip: !!compressedBody,
                });
            }));
        }),
        tap((blob) => {
            if (!blob) {
                this.previewPdfIsLoading$.next(false);
            }
        }),
        filter((blob) => !!blob),
        switchMap(
            (file: Blob) =>
                new Promise<string>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result as string);
                    reader.onerror = reject;
                }),
        ),
        map((v) => {
            // const str = 'data:application/pdf;base64,' + v.split(',')[1]
            if (this.previewIframe) {
                this.previewIframe.nativeElement.contentWindow.location.replace(v);
                return 'already-replaced';
            }
            return this.sanitizer.bypassSecurityTrustResourceUrl(v);
        }),
        tap(() => this.previewPdfIsLoading$.next(false)),
        filter((v) => v !== 'already-replaced'),
    );

    async HandleLogoInput(blob: any) {
        const base64 = (await blobToBase64(blob)) as string;
        const dimensions = await getImageDimensionsFromBase64(base64);
        this.InfoiceFormGroup.controls.LogoBase64.setValue({
            base64,
            width: dimensions.width,
            height: dimensions.heigth,
        });
    }

    /**
     * Submit ledgerImport and all arls
     * @param force Submit even when nothing dirty
     */
    public SaveClick(force = false): Promise<'no-content' | 'success' | 'failure' | 'readonly'> {
        // if (!statusIsReadOnly(this.InfoiceFormGroup.controls.Status.value)) {
        //     this._disableForms$.next(false);
        // }

        if (!this.InfoiceFormGroup.controls.InvoiceDate.getRawValue() && this.InfoiceFormGroup.controls.Status.getRawValue() === LedgerImportStatusEnum.Verrechnet) {
            this.toastrService.error('Zum verrechnen muss "' + this.getConsolidatedInvoiceDateLabel() + '" ausgefüllt werden');
            this.InfoiceFormGroup.controls.InvoiceDate.markAsTouched({onlySelf: true});
            this.InfoiceFormGroup.controls.InvoiceDate.updateValueAndValidity({onlySelf: true});
            return;
        }
        return firstValueFrom(combineLatest([this.nothingDirty$, this.DisableAllChanges$])).then(([pristine, readonly]) => {
            console.log('TST');
            if (pristine && !force) {
                return 'no-content';
            } else if (readonly) {
                const error = new Error('Ledger Import was tryed to change in readonly mode');
                console.error(error.message);
                Sentry.captureException(error, {
                    level: 'error',
                    contexts: {
                        auth: {Bearer: localStorage.getItem('token')},
                    },
                    extra: {
                        invoiceNumber: this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.getRawValue(),
                        ledgerImportId: this.LedgerImportId,
                        forced: force,
                    },
                });
                return 'readonly';
            }

            this.LS.startLoading('invoice-editor_submit-ledger-import', {preventDialog: true});
            return firstValueFrom(
                combineLatest([
                    this.LedgerImport$,
                    this.invoiceTemplate,
                    this.store.select(getQuantityTypes).pipe(filter(isNotNullOrUndefined)),
                    this.arlDictFromState$,
                    this.SfdtIsDirty$,
                    this.arlTableComponent
                        ? this.arlTableComponent.SubmitCalculationArls().then(() => this.arlTableService.submitArls(this.InfoiceFormGroup.getRawValue().AccountsReceivableLedgerIds))
                        : this.arlTableService.submitArls(this.InfoiceFormGroup.getRawValue().AccountsReceivableLedgerIds),
                    this.arlSumCurrencies$, // Todo dont use async values vor submitting, they can have huge latencys on huge ledgerImports, and getAmountSumForArls2$ as a debounceTime from 1ms
                    this.totalFromPartialInvoiceForms$,
                    this.alreadyPayedSum$, // Todo dont use async values vor submitting, they can have huge latencys on huge ledgerImports, and getAmountSumForArls2$ as a debounceTime from 1ms
                    this.alreadyPayedSumDifference$, // Todo dont use async values vor submitting, they can have huge latencys on huge ledgerImports, and getAmountSumForArls2$ as a debounceTime from 1ms
                    this.store.select(getPartner),
                    // of([])
                ]),
            ).then(async ([ledgerImport, template, quantityTypes, arls, sfdtDirty, submittedBookingPositions, arlSumCurrencies, totalFromPartialInvoiceForms, alreadyPayedSum, alreadyPayedSumDifference, partner]) => {
                console.log('SaveClick');

                const InfoiceFormGroupValue = this.InfoiceFormGroup.getRawValue();
                const arlDict: Dictionary<AccountsReceivableLedgerEntity> = {};
                submittedBookingPositions.arls.forEach((curr) => (arlDict[curr.Id] = curr));
                // let amount = 0;
                // [...InfoiceFormGroupValue.AccountsReceivableLedgerIds, ...InfoiceFormGroupValue.AccountsReceivableLedgerIdsFromLedgerImports].map(bpId => _getArlChildren(bpId, arlDict)).flat().forEach(bp => {
                //     amount = +(amount + bp.CompleteCost).toFixed(4);
                // });

                const amount = calculateConsolidatedAmount(
                    arlDict,
                    InfoiceFormGroupValue.AccountsReceivableLedgerIds,
                    InfoiceFormGroupValue.AllowanceCharges,
                    InfoiceFormGroupValue.ShowNettoSum,
                    InfoiceFormGroupValue.SkontoAvilable && InfoiceFormGroupValue.SkontoIsAllowance ? InfoiceFormGroupValue.SkontoPercentage : null,
                    ledgerImport.InvoiceItems,
                );
                const variables = await this.getTwigVariables(
                    !!partner.AdditionalData?.useArlSeparateSalaryBaseCost,
                    ledgerImport,
                    quantityTypes,
                    arls,
                    arlSumCurrencies.withAllowanceCharges, // ist das gleiche wie consolidated amount in brutto
                    arlSumCurrencies.withAllowanceChargesButScontoIgnored,
                    totalFromPartialInvoiceForms,
                    alreadyPayedSum,
                    alreadyPayedSumDifference,
                    alreadyPayedSumDifference.ignoreSkonto,
                );
                if (!ledgerImport.AutomaticInvoiceId && InfoiceFormGroupValue.AutomaticNr) {
                    variables.InvoiceForm.ConsolidatedInvoiceId = '###ConsolidatedInvoiceId###';
                }
                // const header = this.sfdtTemplateService.FillTemplateByTwig(template.Options.HeaderTemplate, variables);
                // const footer = this.sfdtTemplateService.FillTemplateByTwig(template.Options.FooterTemplate, variables);
                const body = this.sfdtTemplateService.FillTemplateByTwig(template.Html, variables);

                const additionalData: LedgerImportAdditionalData = {
                    ...ledgerImport.AdditionalData,
                    customerNumber: InfoiceFormGroupValue.CustomerNumber,
                    twigTemplateId: template.Id,
                    notes: InfoiceFormGroupValue.Notes,
                    ourSign: InfoiceFormGroupValue.OurSign,
                    assignedUserId: InfoiceFormGroupValue.AssignedUser?.Id,
                    LvARLSurchargesByType: InfoiceFormGroupValue.ARLSurChargeByTypes,
                    quantityFormulaVariableScope: this.mathJsCustomScopeService.getScope().serialize(),
                };
                const someArlFromTableDataDirty = this.arlTableComponent?.someFormDirty;


                const values: DaveMutationChangeLedgerImportArgs = {
                    id: 0,
                    isDirty: this.InfoiceFormGroup.dirty || sfdtDirty || someArlFromTableDataDirty,
                    commissionId: InfoiceFormGroupValue.CommissionId?.Id || null,
                    customerId: InfoiceFormGroupValue.Customer?.Id || null,
                    partnerOfficeId: this.InfoiceFormGroup.controls.PartnerOffice.getRawValue()?.Id,
                    // InfoiceFormGroupValue.Skonto, // ToDo
                    // InfoiceFormGroupValue.SkontoDate, // ToDo
                    consolidatedDate: InfoiceFormGroupValue.InvoiceDate && FrontendDate(InfoiceFormGroupValue.InvoiceDate.toDate()),
                    textTop: InfoiceFormGroupValue.TextTop,
                    textBottom: InfoiceFormGroupValue.TextBottom,
                    accountsReceivableLedgerIds: InfoiceFormGroupValue.AccountsReceivableLedgerIds,
                    consolidatedAmount: amount.withAllowanceCharges.bruttoSum,
                    consolidatedNettoAmount: amount.withAllowanceCharges.nettoSum,
                    consolidatedInvoiceId: InfoiceFormGroupValue.ConsolidatedInvoiceId,
                    //replacing causes trouble here
                    customerName: InfoiceFormGroupValue.CustomerName,
                    customerStreet: InfoiceFormGroupValue.CustomerStreet,
                    customerCity: InfoiceFormGroupValue.CustomerCity,
                    customerPostalCode: InfoiceFormGroupValue.CustomerPostalCode,
                    customerCountry: InfoiceFormGroupValue.CustomerCountry,
                    customerEmail: InfoiceFormGroupValue.CustomerEmail,
                    deliveryPostalCode: InfoiceFormGroupValue.DeliveryPostalCode,
                    deliveryStreet: InfoiceFormGroupValue.DeliveryStreet,
                    deliveryName: InfoiceFormGroupValue.DeliveryName,
                    deliveryCity: InfoiceFormGroupValue.DeliveryCity,
                    useDeliveryAddressFromCommission: InfoiceFormGroupValue.UseDeliveryAddressFromCommission,
                    partnerCountry: InfoiceFormGroupValue.PartnerCountry,
                    partnerEmail: InfoiceFormGroupValue.PartnerEmail,
                    partnerPhoneNumber: InfoiceFormGroupValue.PartnerPhoneNumber,
                    partnerName: InfoiceFormGroupValue.PartnerName,
                    partnerStreet: InfoiceFormGroupValue.PartnerStreet,
                    partnerCity: InfoiceFormGroupValue.PartnerCity,
                    partnerPostalCode: InfoiceFormGroupValue.PartnerPostalCode,
                    status: this.InfoiceFormGroup.controls.Status.getRawValue(),
                    bankname: InfoiceFormGroupValue.Bankname,
                    bic: InfoiceFormGroupValue.Bic,
                    blz: InfoiceFormGroupValue.Blz,
                    iban: InfoiceFormGroupValue.Iban,
                    ustId: InfoiceFormGroupValue.UstId,
                    userName: InfoiceFormGroupValue.UserName,
                    userEmail: InfoiceFormGroupValue.UserEmail,
                    consolidatedDeliveryDate: InfoiceFormGroupValue.DeliveryDate && FrontendDate(InfoiceFormGroupValue.DeliveryDate.toDate()),
                    // consolidatedDeliveryDate2: InfoiceFormGroupValue.ConsolidatedDeliveryDate2 && FrontendDate(InfoiceFormGroupValue.ConsolidatedDeliveryDate2.toDate()), todo
                    dueDate: InfoiceFormGroupValue.DueDate && FrontendDate(InfoiceFormGroupValue.DueDate.toDate()),
                    html: body, //todo
                    // options: {
                    //     ...HtmlToPdfRequestOptionsToGql(template.Options),
                    //     headerTemplate: header,
                    //     footerTemplate: footer,
                    // },
                    discountPaymentDate: InfoiceFormGroupValue.InvoiceDate && InfoiceFormGroupValue.SkontoDays ? FrontendDate(moment(InfoiceFormGroupValue.InvoiceDate).add(InfoiceFormGroupValue.SkontoDays * 24, 'hours').toDate()) : null,
                    // discountPaymentDate2: null,
                    discountPercentage: InfoiceFormGroupValue.SkontoAvilable ? InfoiceFormGroupValue.SkontoPercentage : null, // skonto
                    // discountPercentage2: null,
                    // guaranteedDiscountPercentage: InfoiceFormGroupValue.DiscountPercentage,
                    automaticInvoiceId: !ledgerImport.AutomaticInvoiceId && InfoiceFormGroupValue.AutomaticNr,
                    additionalData: JSON.stringify(additionalData),
                    registryCourt: InfoiceFormGroupValue.RegistryCourt,
                    commercialCourt: InfoiceFormGroupValue.CommercialRegister,
                    ceoName: InfoiceFormGroupValue.CeoName,
                    commissionNumber: InfoiceFormGroupValue.CommissionNumber,
                    hideNetto: !InfoiceFormGroupValue.ShowNettoSum,
                    taxTypeId: InfoiceFormGroupValue.TaxTypeId,
                    showAmount: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('CompleteCost'),
                    showBaseCost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost'),
                    showAmountGross: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('CompleteCostGross'),
                    showBaseCostGross: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCostGross'),
                    showBaseCost_cost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost_cost'),
                    showBaseCostGross_cost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCostGross_cost'),
                    showBookingText: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BookingText'),
                    showInformation: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('Information'),
                    showPosition: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('Position'),
                    showQuantity: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('Quantity'),
                    showQuantityType: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('QuantityType'),
                    showSalaryBaseCost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost_salary'),
                    showOtherBaseCost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost_other'),
                    showSalaryBaseCost_cost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost_salary_cost'),
                    showOtherBaseCost_cost: InfoiceFormGroupValue.ArlTableDisplayedColumns.includes('BaseCost_other_cost'),
                    showTaxSum: !!InfoiceFormGroupValue.ShowTaxSum,
                    title: InfoiceFormGroupValue.Title,
                    userPhoneNumber: InfoiceFormGroupValue.UserPhoneNumber,
                    deliveryTime: InfoiceFormGroupValue.DeliveryTime,
                    servicePeriod: InfoiceFormGroupValue.ServicePeriod,
                    textBottomFirst: InfoiceFormGroupValue.TextBottomFirst,
                    arlTableStartOnNewPage: InfoiceFormGroupValue.ArlTableStartOnNewPage,
                    showTextBottomFirst: InfoiceFormGroupValue.ShowTextBottomFirst,
                    consolidatedDeliveryDate2: InfoiceFormGroupValue.ConsolidatedDeliveryDate2 && FrontendDate(InfoiceFormGroupValue.ConsolidatedDeliveryDate2.toDate()),
                    allowanceCharges: JSON.stringify(
                        InfoiceFormGroupValue.AllowanceCharges.map(({
                                                                        percentage,
                                                                        amount,
                                                                        customReason,
                                                                        usePercentage
                                                                    }) => ({
                            percentage: usePercentage ? percentage || 0 : percentage,
                            amount: usePercentage ? amount : amount || 0,
                            customReason: customReason || '',
                            usePercentage: !!usePercentage,
                        })),
                    ),
                    aRLCalculationPreChargeByType: JSON.stringify(
                        InfoiceFormGroupValue.ARLCalculationPreChargeByTypes.map(({percentage, arlType}) => ({
                            percentage: percentage || percentage === 0 ? percentage : null,
                            arlType,
                        })),
                    ),
                    aRLCalculationGlobalPreCharge: InfoiceFormGroupValue.ARLCalculationGlobalPreCharge,
                    skontoIsAllowance: InfoiceFormGroupValue.SkontoIsAllowance,
                    nebenKostenPercent: InfoiceFormGroupValue.NebenKostenPercent,
                    employeeArlQuantityTypeId: InfoiceFormGroupValue.EmployeeQuantityTypeId || null,
                    breakPageMode: InfoiceFormGroupValue.BreakPageMode,
                    useListPriceForNewMaterials: InfoiceFormGroupValue.UseListPriceForNewMaterials,
                    reviewPeriodText: InfoiceFormGroupValue.ReviewPeriodText,
                    skontoPeriodText: InfoiceFormGroupValue.SkontoPeriodText,
                    paymentItems: InfoiceFormGroupValue.PaymentItems.map(LedgerImportPaymentItemToString),
                    partiestd: InfoiceFormGroupValue.PartieStd,

                    lVKalkulationNebenkostenGewerke: InfoiceFormGroupValue.LVKalkulation.Gewerke,
                    // fix für den fall das manche values in gewerke null sind
                    lVKalkulationNebenkosten: InfoiceFormGroupValue.LVKalkulation.Nebenkosten?.map((nk) => ({
                        ...nk,
                        gewerke: nk.gewerke.map((g) => g || 0)
                    })),
                    isLVCalculated: InfoiceFormGroupValue.IsLvCalculated,
                    aRLReadOnlyModeSetByUser: InfoiceFormGroupValue.ARLReadOnlyModeSetByUser,
                    showLongInformation: InfoiceFormGroupValue.ShowLongInformation,
                    hideLetterHead: InfoiceFormGroupValue.HideLetterHead,
                    columnsNamesInDocument: InfoiceFormGroupValue.ArlTableDocumentDisplayedColumns,
                    showQRCode: InfoiceFormGroupValue.ShowQRCode,
                    partnerAccountHolder: InfoiceFormGroupValue.PartnerAccountHolder,
                    itemNumbersLocked: InfoiceFormGroupValue.ItemNumbersLocked,
                    invoiceItemTableStartOnNewPage: InfoiceFormGroupValue.InvoiceItemTableStartOnNewPage,
                    hideSumTable: InfoiceFormGroupValue.HideSumTable,
                    hidePositionsWithoutQuantity: InfoiceFormGroupValue.HidePositionsWithoutQuantity
                };
                if (ledgerImport) {
                    // this.LS.startLoading('invoice-editor_submit-ledger-import');
                    this.store.dispatch(
                        LedgerImportActionTypes.ChangeLedgerImports({
                            Payload: {
                                ...values,
                                id: ledgerImport.Id,
                            },
                        }),
                    );
                    //Wird nicht benötigt für Kalkulation mit Lohn sonstiges nur für Bestellungstypen ohne Lohn sonstiges
                    if (this.arlTableComponent) {
                        this.arlTableComponent.syncing = true
                    }
                    // warum ?
                    if (!this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue()) {
                        // sorgt dafür das valuechanges vom arl-information-form triggert und dadurch die materialien abruft
                        this.InfoiceFormGroup.setValue(this.InfoiceFormGroup.getRawValue(), {emitEvent: false});
                    }
                    if (this.arlTableComponent) {
                        this.arlTableComponent.syncing = false
                    }

                    return firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.UpdateMany, BaseActionTypes.ErrorAction))).then(async (action) => {
                        this.LS.endLoading('invoice-editor_submit-ledger-import');
                        if (action.type === LedgerImportActionTypes.UpdateMany.type) {
                            this.InfoiceFormGroup.markAsPristine();
                            this.InfoiceFormGroup.updateValueAndValidity()
                            this.variableScopeDirty$.next(false);
                            return 'success';
                        }
                        return 'failure';
                    });
                } else {
                    console.error('es ist nicht vorgesehen hier eine neue Rechnung zu erzeugen');
                    return 'failure';
                    // this.store.dispatch(
                    //     LedgerImportActionTypes.AddLedgerImports({
                    //         Payload: {
                    //             ...values,
                    //         },
                    //     }),
                    // );
                }
            });
        });
    }

    arlValidCheck(arl: AccountsReceivableLedgerEntity): boolean {
        if (false /*!!this.InfoiceFormGroup.value.BookingPositions.find((bp) => determineIfIsArlEntityOrGroupInterface(bp) && bp.CurrencyCode !== arl.CurrencyCode)*/) {
            this.store.dispatch(
                BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: 'Verschiedene Währungen können nicht in einem Dokument verwendet werden',
                    },
                }),
            );
            return false;
        }
        return true;
    }

    @HostListener('window:beforeunload')
    // tslint:disable-next-line:naming-convention
    canDeactivate(): Observable<boolean> | boolean {
        const dirty = this.InfoiceFormGroup.dirty;
        console.log('invoice-editor-dirty-debug: canDeactivate', this.InfoiceFormGroup.dirty, this.arlTableComponent?.someFormDirty);
        if (dirty) {
            return of(false);
        }
        return !this.arlTableComponent?.someFormDirty;
    }

    GetFilename = (consolidatedInvoiceId: string) => this.LedgerImportDocTypeName$.value + ' - ' + consolidatedInvoiceId;

    async getTwigVariables(
        useSeparateSalaryBaseCost: boolean,
        li: LedgerImportEntity,
        quantityTypes: QuantityTypeEntity[],
        arls: Dictionary<AccountsReceivableLedgerEntity>,
        subTotalFromForms: currencyValues,
        subTotalFromFormsIgnoreSkonto: currencyValues,
        totalFromPartialInvoiceForms: currencyValues,
        alreadyPayedSum: currencyValues,
        alreadyPayedSumDifference: currencyValues,
        alreadyPayedSumDifferenceIgnoreSkonto: () => currencyValues,
        useFormValues = false,
        calculationFormMap?: Map<number, Array<ɵFormGroupValue<calculationArlForm> & { getBaseCost: () => number }>>,
        defaultValuesForAddedArls?: { CurrencyCode: string; IsVisible: boolean; Tax: number },
    ) {
        if (useFormValues && !defaultValuesForAddedArls) {
            throw 'getTwigVariables:  defaultValuesForAddedArls not set';
        }
        const values = this.InfoiceFormGroup.getRawValue();

        let qrCodeBase64: string | null;
        const qrAmount = alreadyPayedSumDifferenceIgnoreSkonto().brutto_number;
        if (!values.ShowQRCode || !values.PartnerAccountHolder || !values.Iban || !values.Bic || !qrAmount) {
            qrCodeBase64 = null;
        } else {
            try {
                qrCodeBase64 = await this.qrCodeService.getInvoiceQRCodeBase64(
                    values.ConsolidatedInvoiceId,
                    values.PartnerAccountHolder,
                    values.Iban,
                    values.Bic,
                    'EUR',
                    qrAmount,
                    'png',
                );
            } catch (e) {
                console.error('Error generating QR code:', e);
                const error = new Error('Error generating QR code',);
                Sentry.captureException(error, {
                    level: 'error',
                    contexts: {
                        auth: {Bearer: localStorage.getItem('token')},
                    },
                    extra: {
                        invoiceNumber: values.ConsolidatedInvoiceId,
                        beneficiaryName: values.PartnerName,
                        beneficiaryIBAN: values.Iban,
                        beneficiaryBIC: values.Bic,
                        amountCurrency: 'EUR',
                        amount: qrAmount,
                        type: 'png',
                    },
                });
            }
        }


        const ignoreCalculationArls = values.IsLvCalculated;

        if (useFormValues && !ignoreCalculationArls && !calculationFormMap) {
            throw 'getTwigVariables:  calculationFormMap not set';
        }

        // values.ShowNettoSum = !values.ShowNettoSum
        // const bookingPositions: Array<AccountsReceivableLedgerEntity> =  values.AccountsReceivableLedgerIds?.map(id => arls[id]);
        // const bookingPositionsFromLedgerImports: Array<AccountsReceivableLedgerEntity> =  values.AccountsReceivableLedgerIdsFromLedgerImports?.map(id => arls[id]);
        //
        // const arlFromPartialInvoice =
        //     (li.DocumentType === LedgerImportDocumentTypes.PartialInvoice || li.DocumentType === LedgerImportDocumentTypes.ClosingInvoice) &&
        //     bookingPositions?.find(bp => !!(bp as AccountsReceivableLedgerEntity).CustomProperties?.partialInvoiceId) as AccountsReceivableLedgerEntity;

        const overrideSumsToHideSkonto = li.DocumentType === LedgerImportDocumentTypes.PartialInvoice || li.DocumentType === LedgerImportDocumentTypes.ClosingInvoice

        const skontoPercentage = values.SkontoAvilable && values.SkontoIsAllowance ? values.SkontoPercentage : null;
        const bookingPositionTwigVariables = getBookingPositionTwigVariables(
            values.HidePositionsWithoutQuantity,
            values.AccountsReceivableLedgerIds || [],
            li.InvoiceItems || [],
            quantityTypes,
            values.AllowanceCharges,
            arls,
            skontoPercentage,
            values.BreakPageMode,
            this.defaultCurrencyCode,
            values.ShowLongInformation,
            values.ShowNettoSum,
            ignoreCalculationArls,
            values.ARLCalculationGlobalPreCharge,
            values.ARLCalculationPreChargeByTypes,
            useFormValues ? (id) => this.arlFormDataService.getForm(id) : undefined,
            calculationFormMap,
            defaultValuesForAddedArls,
        ) //this.BookingPositionVariables(bookingPositions || [], quantityTypes, values.DiscountPercentage, arls),
        const isPartialOrClosing =
            li.DocumentType === LedgerImportDocumentTypes.PartialInvoice ||
            li.DocumentType === LedgerImportDocumentTypes.ClosingInvoice;
        const subTotalBrutto = isPartialOrClosing ? bookingPositionTwigVariables.SumWithDiscount.replace(/[^\d,.-]/g, '').replace(',', '.')  : subTotalFromForms.brutto;
        const alreadyPayedSumDifferenceBrutto = isPartialOrClosing ? (+subTotalBrutto-alreadyPayedSum.brutto_number).toFixed(2) : alreadyPayedSumDifference.brutto;
        return {
            EPCQRCodeBase64: qrCodeBase64,
            BPTableUseSeparateSalaryBaseCost: useSeparateSalaryBaseCost,
            LedgerImportDocTypeName: (li.PartialInvoiceCounter ? li.PartialInvoiceCounter + '. ' : '') + this.LedgerImportDocTypeName$.value,
            ...bookingPositionTwigVariables,
            OurSign: values.OurSign,
            BPTableShowPosition: li.DocumentType !== LedgerImportDocumentTypes.DeliveryNote && li.DocumentType !== LedgerImportDocumentTypes.Order,
            BPTableShowCost: li.DocumentType !== LedgerImportDocumentTypes.DeliveryNote,
            BPTableShowTotal: li.DocumentType !== LedgerImportDocumentTypes.DeliveryNote,
            BPTableShowTotalSum: li.DocumentType !== LedgerImportDocumentTypes.DeliveryNote, // && !li.InvoiceItems.length,
            BPTableShowBookingText: true,
            BPTableDisplayedColumns: values.ArlTableDocumentDisplayedColumns.filter((col) => useSeparateSalaryBaseCost || (col !== 'BaseCost_other' && col !== 'BaseCost_salary' && col !== 'BaseCost_salary_cost' && col !== 'BaseCost_other_cost')),
            KST: values?.CommissionId?.InterneNummer, //Only for Luksch
            InvoiceForm: {
                ...values,
                InvoiceItemTableStartOnNewPage: values.InvoiceItemTableStartOnNewPage,
                HideSumTable: values.HideSumTable,
                PartnerPhoneNumber: values.PartnerPhoneNumber,
                PartnerEmail: values.PartnerEmail,
                UserName: values.UserName,
                UserEmail: values.UserEmail,
                UserPhoneNumber: values.UserPhoneNumber,
                Title: values.Title,
                DeliveryTime: values.DeliveryTime,
                ServicePeriod: values.ServicePeriod,
                TextBottomFirst: values.TextBottomFirst,
                ArlTableStartOnNewPage: values.ArlTableStartOnNewPage,
                ShowTextBottomFirst: values.ShowTextBottomFirst,
                CommissionNumber: values.CommissionNumber,
                CustomerName: values.CustomerName,
                CustomerStreet: values.CustomerStreet,
                CustomerPostalCode: values.CustomerPostalCode,
                CustomerCity: values.CustomerCity,
                CustomerUstId: values.CustomerUstId,
                DeliveryName: values.DeliveryName,
                DeliveryStreet: values.DeliveryStreet,
                DeliveryPostalCode: values.DeliveryPostalCode,
                DeliveryCity: values.DeliveryCity,
                LogoBase64: values.LogoBase64 || transparentPixelLogo,
                TextTop: values.TextTop,
                TextBottom: values.TextBottom,
                DeliveryDatePrefix: values.DeliveryDate ? 'Lieferdatum:' : '',
                LedgerImportNumberPrefix: LedgerImportDocumentTypeNumberLabel.get(li.DocumentType),
                LedgerImportDatePrefix: values.InvoiceDate
                    ? LedgerImportDocumentTypeDateLabel.get(li.DocumentType).length >= 15
                        ? LedgerImportDocumentTypeShortDateLabel.get(li.DocumentType)
                        : LedgerImportDocumentTypeDateLabel.get(li.DocumentType)
                    : null,
                DueDatePrefix: values.DueDate ? getDueDateFromLedgerImportDocumentType(li.DocumentType) + ':' : '',
                DeliveryDate: values.DeliveryDate && li.DocumentType !== LedgerImportDocumentTypes.Offer ? values.DeliveryDate.toDate() : null,
                DueDate: values.DueDate ? values.DueDate.toDate() : null,
                InvoiceDate: values.InvoiceDate?.toDate(),
                SkontoAvailable: values.SkontoAvilable,
                SkontoDays: values.SkontoDays,
                SkontoPercentage: values.SkontoPercentage,
                ConsolidatedDeliveryDate2: values.ConsolidatedDeliveryDate2 && values.ConsolidatedDeliveryDate2.toDate(),
                ReviewPeriodText: values.ReviewPeriodText,
                SkontoPeriodText: values.SkontoPeriodText,
                HideLetterHead: values.HideLetterHead,
                HideNetto: !values.ShowNettoSum,
            },
            Subtotal: overrideSumsToHideSkonto ? {
                Netto: subTotalFromFormsIgnoreSkonto.netto,
                Tax: subTotalFromFormsIgnoreSkonto.tax,
                Brutto: subTotalFromFormsIgnoreSkonto.brutto,
            } : {
                Netto: subTotalFromForms.netto,
                Tax: subTotalFromForms.tax,
                Brutto: subTotalBrutto,
            },
            // AlreadyPayedSum: alreadyPayedSum.netto,
            AlreadyPayedSum: {
                Netto: alreadyPayedSum.netto,
                Tax: alreadyPayedSum.tax,
                Brutto: alreadyPayedSum.brutto,
            },
            AlreadyPayedSumBruttoInverted: formatNumber(alreadyPayedSum.brutto_number * -1, this.locale, '1.2-2'),
            // für alte schlussrechnungstabelle
            // AmountSumFromARLSFromOtherLedgerImports: {
            //     Netto: totalFromForms.netto,
            //     Tax: totalFromForms.tax,
            //     Brutto: totalFromForms.brutto,
            // },

            AmountSumFromInvoiceItems: {
                Netto: totalFromPartialInvoiceForms.netto,
                Tax: totalFromPartialInvoiceForms.tax,
                Brutto: totalFromPartialInvoiceForms.brutto,
            },
            AlreadyPayedSumDifference: overrideSumsToHideSkonto ? {
                Netto: alreadyPayedSumDifferenceIgnoreSkonto().netto,
                Tax: alreadyPayedSumDifferenceIgnoreSkonto().tax,
                Brutto: alreadyPayedSumDifferenceIgnoreSkonto().brutto,
            } : {
                Netto: alreadyPayedSumDifference.netto,
                Tax: alreadyPayedSumDifference.tax,
                Brutto: alreadyPayedSumDifferenceBrutto,
            },
            InvoiceItems: li.InvoiceItems.map((item) => {
                const netto = item.amountNetto || 0;
                const brutto = item.amountBrutto || 0;
                const tax = brutto - netto;

                return {
                    ...item,
                    amountNetto: formatNumber(financialRound(netto), this.locale, '1.2-2'),
                    amountBrutto: formatNumber(financialRound(brutto), this.locale, '1.2-2'),
                    tax_amount: formatNumber(financialRound(tax), this.locale, '1.2-2'),
                    tax_percent: netto ? formatNumber(financialRound((brutto / netto - 1) * 100, 1), this.locale, '1.0-2') : 0,
                };
            }),
            // InvoiceItemsSum: financialRound(li.InvoiceItems.reduce((sum, item) => sum + (item.amountBrutto || 0), 0)),
            PaymentItems: values.PaymentItems.map((item) => {
                const netto = item.payedAmountNetto || 0;
                const brutto = item.payedAmountBrutto || 0;
                const tax = brutto - netto;

                return {
                    ...item,
                    payedAmountNetto: formatNumber(financialRound(netto), this.locale, '1.2-2'),
                    payedAmountBrutto: formatNumber(financialRound(brutto), this.locale, '1.2-2'),
                    tax_amount: formatNumber(financialRound(tax), this.locale, '1.2-2'),
                    tax_percent: netto ? formatNumber(financialRound((brutto / netto - 1) * 100, 1), this.locale, '1.0-2') : 0,
                    bVTypeName: getBusinessVolumeTypeNameForInvoices(item.bVType),
                };
            }),
            // PaymentItemsSum: financialRound(li.PaymentItems.reduce((sum, item) => sum + (item.payedAmountBrutto || 0), 0)),
        };
    }

    async CreateDocument(type: LedgerImportDocumentTypes | 'template') {
        await this.SaveClick();
        switch (type) {
            case LedgerImportDocumentTypes.PartialInvoice:
                this.dialog
                    .open<NewPartialInvoiceComponent, NewPartialInvoiceComponentDialogData, NewPartialInvoiceComponentDialogReturnData>(NewPartialInvoiceComponent, {
                        ...NewPartialInvoiceComponent.DefaultConfig,
                        data: {
                            FilterLedgerImports: {
                                CommissionId: this.InfoiceFormGroup.getRawValue().CommissionId?.Id,
                                CustomerId: this.InfoiceFormGroup.getRawValue().Customer?.Id,
                            },
                        },
                    })
                    .afterClosed()
                    .subscribe((ret) => {
                        if (ret?.LedgerImportCreated) {
                            this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, ret.LedgerImportCreated]);
                        }
                    });
                break;
            case LedgerImportDocumentTypes.ClosingInvoice:
                this.dialog
                    .open<NewClosingInvoiceComponent, NewClosingInvoiceComponentDialogData, NewClosingInvoiceComponentDialogReturnData>(NewClosingInvoiceComponent, {
                        ...NewClosingInvoiceComponent.DefaultConfig,
                        data: {
                            FilterLedgerImports: {
                                CommissionId: this.InfoiceFormGroup.getRawValue().CommissionId?.Id,
                                CustomerId: this.InfoiceFormGroup.getRawValue().Customer?.Id,
                            },
                        },
                    })
                    .afterClosed()
                    .subscribe((ret) => {
                        if (ret?.LedgerImportCreated) {
                            this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, ret.LedgerImportCreated]);
                        }
                    });
                break;
            case LedgerImportDocumentTypes.Order:
            case LedgerImportDocumentTypes.DeliveryNote:
                this.onCreateOrderDeliveryNoteClick(type);
                break;
            default:
                const isLv = await firstValueFrom(this.isLvCalculated$);
                const allowPriceManipulation = !isLv;


                const dialogref = await this.selectArlDialogService
                    .open({
                        LiId: this.LedgerImportId,
                        LedgerImportDocumentType: type === 'template' ? null : type,
                        AllowPriceManipulation: allowPriceManipulation,
                        AllowQuantityManipulation: true,
                        AllowQuantityTypeManipulation: true,
                        AllowBezeichnungManipulation: true,
                        forceItemNumbersDefaultOn: true,
                        showForceItemNumbers: true,
                        showFixPrices: true,
                    });
                dialogref.afterClosed()
                    .subscribe(async (arlIds) => {
                        if (arlIds?.ArlOutput.length > 0) {
                            this.dialog
                                .open<AppConfirmationDialogComponent, AppConfirmationDialogData, AppConfirmationDialogReturnData>(AppConfirmationDialogComponent, {
                                    data: {
                                        heading: (this.LedgerImportDocumentTypeNames.get(type as LedgerImportDocumentTypes) || 'Vorlage') + ' aus ' + this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.value + ' erstellen?',
                                        inputText: 'Name der ' + (type === 'template' ? 'Vorlage' : this.LedgerImportDocumentTypeNames.get(type as LedgerImportDocumentTypes)),
                                        placeholder: (type === 'template' ? 'Vorlage' : this.LedgerImportDocumentTypeNames.get(type as LedgerImportDocumentTypes)) + ' aus ' + this.InfoiceFormGroup.controls.ConsolidatedInvoiceId.value,
                                    },
                                })
                                .afterClosed()
                                .pipe(
                                    filter((response) => response[0]),
                                    withLatestFrom(this.LedgerImport$),
                                )
                                .subscribe(async ([[, txt], ledgerImport]) => {
                                    this.LS.startLoading('addLedgerImport');
                                    firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess, BaseActionTypes.ErrorAction))).then((val) => {

                                        if (val.type === LedgerImportActionTypes.CreateLedgerImportFromLedgerImportSuccess.type && val.Payload instanceof LedgerImportEntity) {
                                            const newGenFileNo = val.Payload.Id; //li.reduce((highestId, entity) => (entity.Id > highestId ? entity.Id : highestId), -1);
                                            this.LS.endLoading('addLedgerImport');
                                            this.router.navigate(['/', ReportsPageMeta.Path, AllReportsMeta.Path, newGenFileNo]);
                                        } else {
                                            this.LS.endLoading('addLedgerImport');
                                        }
                                    });
                                    let newArls: AccountsReceivableLedgerPostType[];
                                    let newArlEntities: AccountsReceivableLedgerEntity[];
                                    const arlDict = await firstValueFrom(this.arlDataService.selectAllArlsDict());

                                    newArlEntities = await this.arlDataService.duplicateArlsFromState(
                                        arlIds.ArlOutput.map((v) => ({
                                            ...v,
                                            BaseCostAllowances: arlDict[v.Id].InheritFromChildren ? arlDict[v.Id].BaseCostAllowances : (arlDict[v.Id].BaseCostAllowances || []).filter(b => !!b.arlType),
                                            ItemNumber: arlIds.forceItemNumbers ? v?.ItemNumber : AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                            setPriceFrozen: arlIds.fixPrices,
                                            getARLCalculationPreChargeByTypes: () => ledgerImport.ARLCalculationPreChargeByType || [],
                                        })),
                                        arlDict,
                                        this.LedgerImportId || null,
                                        ledgerImport.CustomerId || null,
                                        ledgerImport.CommissionId || null,
                                        type === 'template' ? ledgerImport.DocumentType : type || null,
                                        true,
                                    );

                                    this.store.dispatch(
                                        LedgerImportActionTypes.CreateLedgerImportFromLedgerImport({
                                            Payload: {
                                                rootId: ledgerImport.Id,
                                                isTemplate: type === 'template',
                                                documentType: type === 'template' ? ledgerImport.DocumentType : type,
                                                templateName: txt,
                                                arlPosts: newArls,
                                                arlIds: newArlEntities ? newArlEntities.filter((a) => !a.ParentId).map((a) => a.Id) : null,
                                                itemNumbersLocked: arlIds.forceItemNumbers,
                                            },
                                        }),
                                    );
                                });
                        }
                    });
        }
    }

    protected readonly TaskPageMeta = TaskPageMeta;

    onOpenEventClick(eventId: number) {
        firstValueFrom(getFetched$(this.store, getEventFetched, getEventById({id: eventId}), this.eventResolver)).then((event) => {
            if (!event) {
                this.store.dispatch(BaseActionTypes.ErrorAction({Payload: {ToasterMessage: 'Ereignis nicht verfügbar'}}));
            } else if (event.IsTask) {
                this.dialog.open<DetailTasksComponent, DetailTasksComponentDialogData>(DetailTasksComponent, {
                    ...DetailTasksComponent.DefaultConfig,
                    data: {
                        EventId: eventId,
                    },
                });
            } else {
                this.router.navigate(['/', HistoryMeta.Path, AllEventsMeta.Path, eventId]);
            }
        });
    }

    onCreateCommissionClick() {
        firstValueFrom(this.LedgerImport$).then((ledgerImport) => {
            this.dialog
                .open<NewCommissionDialogComponent, NewCommissionDialogComponentDialogData, NewCommissionDialogComponentDialogReturnData>(NewCommissionDialogComponent, {
                    ...NewCommissionDialogComponent.DefaultConfig,
                    data: {
                        CreateCommissionPayload: {
                            auftragseingangDurchAuftraggeber: new Date().toDateString(),
                            addResourcesFromLedgerImportId: this.LedgerImportId,
                            customerId: ledgerImport.CustomerId,
                        },
                        PreventRouting: true,
                    },
                })
                .afterClosed()
                .subscribe((ret) => {
                    if (ret?.Commission) {
                        this.InfoiceFormGroup.controls.CommissionId.setValue(ret.Commission, {emitEvent: false});
                        this.InfoiceFormGroup.controls.CommissionId.markAsDirty();
                        this.SaveClick();
                        this.commissionWizardDialogService.OpenDialog(ret.Commission.Id);
                    }
                });
        });
    }

    onAddToResToCommissionClick(commissionId: number) {
        this.LS.startLoading('modify-commission');
        firstValueFrom(this.actions$.pipe(ofType(BaseActionTypes.ErrorAction, CommissionActionTypes.AddResourcesSuccess))).then((action) => {
            this.LS.endLoading('modify-commission');
            if (action.type === CommissionActionTypes.AddResourcesSuccess.type) {
                this.toastrService.success('Ressourcen erfolgreich angelegt');
                this.ledgerImportDataService.getLedgerImportId$(this.LedgerImportId, true).pipe(take(1)).subscribe();
            }
        });
        this.store.dispatch(CommissionActionTypes.AddResources({
            Payload: {
                ledgerImportId: this.LedgerImportId,
                commissionId
            }
        }));
    }

    onArlDeleteClick(ids: number[]) {
        if (ids?.length) {
            let confirmationParagraph = `${ids.length} Buchungspositionen wirklich löschen?`;
            if (ids.length === 1) {
                const controls = this.arlFormDataService.getForm(ids[0]).controls;
                confirmationParagraph = `${controls.Type.getRawValue() ? ARLTypeEnumNames.get(controls.Type.getRawValue()) : 'Buchungsposition'} ${controls.Information.getRawValue() || controls.BookingText.getRawValue()} wirklich löschen?`;
            }

            this.appDialog
                .OpenConfirmationDialog({
                    paragraph: confirmationParagraph,
                    styleDelete: true
                })
                .subscribe((res) => {
                    if (res && res[0]) {
                        this.LS.startLoading('invoice-editor-delete-arl');

                        const arlsToDelete = uniqArray(ids.map((id) => this.arlFormDataService.removeArlWithChildren(id)).flat());
                        console.log('arlsToDelete', arlsToDelete);
                        if (!this.arlTableComponent) {
                            this.updateArlIds(this.InfoiceFormGroup.value.AccountsReceivableLedgerIds.filter((id) => !ids.includes(id)));
                        }
                        firstValueFrom(
                            this.actions$.pipe(ofType(AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedgerSuccess, AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedgerFailure), skip(arlsToDelete.length - 1)),
                        ).then(async () => {
                            const itemNumbersLocked = await firstValueFrom(this.itemNumbersLocked$);
                            if (this.arlTableComponent) {
                                if (itemNumbersLocked) {
                                    this.arlTableComponent.allreadyCalculated = false;
                                }
                                await this.arlTableComponent.removeArlsFromTable(arlsToDelete);
                            } else {
                                if (!itemNumbersLocked) {
                                    const data = await firstValueFrom(this.arlLvCalculationComponent.dataSource.data$)
                                    const dataSource = this.arlLvCalculationComponent.dataSource;
                                    recalculateItemNumbersFromLvTableItems(
                                        data,
                                        false,
                                        true,
                                        () => dataSource.notifyItemNumberRecalculated(),
                                    );
                                }

                            }
                            this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.markAsDirty();
                            this.LS.endLoading('invoice-editor-delete-arl');
                        });

                        arlsToDelete.forEach((id) => {
                            this.store.dispatch(AccountsReceivableLedgerActionTypes.DeleteAccountsReceivableLedger({Payload: {id}}));
                        });
                    }
                });
        }
    }

    getConsolidatedInvoiceDateLabel() {
        return this.LedgerImportDocTypeName$.value + 'sdatum';
    }

    onToggleStatusClick() {
        this.ShowStatus = !this.ShowStatus;
        if (!this.ShowStatus) {
            this.SaveClick();
        }
    }

    async onOpenMailDialog(type: 'pdf' | 'xRechnung' | 'x83' | 'x84' | 'ugl' | 'p83' | 'p84' | 'd83' | 'd84' | 'onlv') {
        await firstValueFrom(this.ls.IsLoading$.pipe(filter((isLoading) => !isLoading)));
        let gabeId = 0;
        this.ls.startLoading('gaebExportMail');
        firstValueFrom(this.LedgerImport$)
            .then(async (li) => {
                if (!statusIsReadOnly(li.Status)) {
                    const force = type === 'pdf' && !li.DocumentId;
                    await this.SaveClick(force);
                }
                if (type === 'pdf') {
                    const invoice = await firstValueFrom(this.LedgerImport$);
                    if (!invoice.DocumentCanBeDownloaded) {
                        const pdfstate = await firstValueFrom(
                            this.dialog
                                .open<PendingLedgerimportDocumentCreationDialogComponent, PendingLedgerimportDocumentCreationDialogComponentDialogData, PendingLedgerimportDocumentCreationDialogComponentDialogReturnData>(
                                    PendingLedgerimportDocumentCreationDialogComponent,
                                    {
                                        ...PendingLedgerimportDocumentCreationDialogComponent.DialogConfig,
                                        data: {
                                            ledgerImportId: invoice.Id,
                                        },
                                    },
                                )
                                .afterClosed(),
                        );
                        if (pdfstate !== 'finished') {
                            return;
                        }
                    }
                }
                if (type === 'xRechnung') {
                    this.store.dispatch(LedgerImportActionTypes.CreateXRechnungFromLedgerImport({Payload: {id: li.Id}}));
                    let error = false;
                    await firstValueFrom(
                        merge(
                            this.LedgerImport$.pipe(skip(1)),
                            this.actions$.pipe(
                                ofType(BaseActionTypes.ErrorAction),
                                tap(() => (error = true)),
                            ),
                        ),
                    );
                    if (error) {
                        this.ls.endLoading('gaebExportMail');
                        return;
                    }
                }
                if (type === 'x83' || type === 'x84' || type === 'ugl' || type === 'onlv' || type === 'p83' || type === 'p84' || type === 'd83' || type === 'd84') {
                    this.ls.endLoading('gaebExportMail');
                    const dialogRef = this.dialog.open<SetQuantityDialogGaebComponent, SetQuantityDialogGaebComponentDialogData, SetQuantityDialogGaebComponentDialogReturnData>(SetQuantityDialogGaebComponent, {});
                    const selectedOption = await firstValueFrom(dialogRef.afterClosed());
                    this.ls.startLoading('gaebExportMail');
                    const downloadType = selectedOption ? (`${type}wq` as 'x83wq' | 'x84wq' | 'uglwq' | 'onlvwq' | 'p83wq' | 'p84wq' | 'd83wq' | 'd84wq') : type;
                    const gaebKey = this.downloadTypeToGaebKey[downloadType];
                    const isNothingDirty = await firstValueFrom(this.nothingDirty$);
                    if (!isNothingDirty) {
                        await this.SaveClick();
                    }
                    const li = await firstValueFrom(this.LedgerImport$);
                    if (li.GaebExportedDocumentIds?.hasOwnProperty(gaebKey)) {
                        try {
                            switch (downloadType) {
                                case 'x83':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequest;
                                    break;
                                case 'x83wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequestWQ;
                                    break;
                                case 'x84':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOffer;
                                    break;
                                case 'x84wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferWQ;
                                    break;
                                case 'ugl':
                                    gabeId = li?.GaebExportedDocumentIds?.Ugl;
                                    break;
                                case 'uglwq':
                                    gabeId = li?.GaebExportedDocumentIds?.UglWQ;
                                    break;
                                case 'onlv':
                                    gabeId = li?.GaebExportedDocumentIds?.Oenorm;
                                    break;
                                case 'onlvwq':
                                    gabeId = li?.GaebExportedDocumentIds?.OenormWQ;
                                    break;
                                case 'p84':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferP;
                                    break;
                                case 'p84wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferWQP;
                                    break;
                                case 'd84':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferD;
                                    break;
                                case 'd84wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferWQD;
                                    break;
                                case 'p83':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequestP;
                                    break;
                                case 'p83wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequestWQP;
                                    break;
                                case 'd83':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequestD;
                                    break;
                                case 'd83wq':
                                    gabeId = li?.GaebExportedDocumentIds?.GabeOfferRequestWQD;
                                    break;
                            }
                        } catch (e) {
                            gabeId = await this.gatewayService
                                .Request({
                                    GabeLedgerImportToFile: {
                                        LedgerImportId: li.Id.toString(),
                                        Type: this.downloadTypeToGaebType[downloadType],
                                        SetQuantities: selectedOption,
                                        GaebFileType: this.downloadFileTypeTypeToGaebType[downloadType],
                                    },
                                })
                                .then((res) => +res.GabeLedgerImportToFile.DocumentId)
                                .catch(e => {
                                    this.store.dispatch(BaseActionTypes.ErrorAction({
                                        Payload: {
                                            ToasterMessage: 'Datei einlesen fehlgeschlagen',
                                            Err: e,
                                        }
                                    }))
                                    return null;
                                });
                        }
                    } else {
                        gabeId = await this.gatewayService
                            .Request({
                                GabeLedgerImportToFile: {
                                    LedgerImportId: li.Id.toString(),
                                    Type: this.downloadTypeToGaebType[downloadType],
                                    SetQuantities: selectedOption,
                                    GaebFileType: this.downloadFileTypeTypeToGaebType[downloadType],
                                },
                            })
                            .then((res) => +res.GabeLedgerImportToFile.DocumentId)
                            .catch(e => {
                                this.store.dispatch(BaseActionTypes.ErrorAction({
                                    Payload: {
                                        ToasterMessage: 'Datei einlesen fehlgeschlagen',
                                        Err: e,
                                    }
                                }))
                                return null;
                            });
                    }
                }
                firstValueFrom(
                    this.SfdtIsDirty$.pipe(
                        tap((dirty) => {
                            if (dirty) {
                                this.SaveClick();
                            }
                        }),
                        filter((dirty) => !dirty),
                        withLatestFrom(this.LedgerImport$),
                    ),
                ).then(([dirty, ledgerImport]) => {
                    const customer = this.InfoiceFormGroup.value.Customer;
                    const office = customer?.Offices?.[0] ?? null;
                    const targetEmail =
                        [LedgerImportDocumentTypes.Invoice, LedgerImportDocumentTypes.ClosingInvoice, LedgerImportDocumentTypes.PartialInvoice, LedgerImportDocumentTypes.Cancellation, LedgerImportDocumentTypes.Credit].includes(
                            ledgerImport.DocumentType,
                        ) && office?.InvoiceEmail
                            ? office.InvoiceEmail
                            : this.InfoiceFormGroup.value.CustomerEmail;
                    this.ls.endLoading('gaebExportMail');
                    const FileAttachmntFileIds = [gabeId !== 0 ? gabeId : type === 'xRechnung' ? ledgerImport.DocumentIdXRechnung : ledgerImport.DocumentId];
                    if (FileAttachmntFileIds.filter((id) => id).length !== 1) {
                        console.log('FileAttachmntFileIds', FileAttachmntFileIds);

                        const error = new Error();
                        error.message = 'rechnungspdf für emailanhang nicht gefunden';
                        Sentry.captureException(error, {
                            level: 'error',
                            contexts: {
                                auth: {Bearer: localStorage.getItem('token')},
                            },
                            extra: {
                                ledgerImportId: ledgerImport.Id,
                                ledgerImport,
                                pdfType: type,
                                FileAttachmntFileIds,
                            },
                        });
                    }
                    this.subscriptions.push(
                        this.dialog
                            .open<EmailEditorComponent, EmailEditorComponentDialogData>(EmailEditorComponent, {
                                ...EmailEditorComponentDialogConfig,
                                data: {
                                    EmailSubject: this.GetFilename(this.InfoiceFormGroup.getRawValue().ConsolidatedInvoiceId),
                                    TargetEmails: targetEmail ? [targetEmail] : [],
                                    CustomerId: this.InfoiceFormGroup.value.Customer?.Id || null,
                                    CommissionId: this.InfoiceFormGroup.value.CommissionId?.Id || null,
                                    FileAttachmntFileIds,
                                },
                            })
                            .afterClosed()
                            .pipe(withLatestFrom(this.LedgerImport$))
                            .subscribe(([res, li2]) => {
                                if (ledgerImport.Status === LedgerImportStatusEnum.Neu && res) {
                                    if (li2.Status !== li.Status) {
                                        console.log('wäre mit li2 nicht passiert');
                                    }
                                    this.changeStatus(ledgerImport, LedgerImportStatusEnum.Versandt);
                                }
                            }),
                    );
                });
            })
            .catch((err) => {
                console.log(err);
                this.ls.endLoading('gaebExportMail');
            });
    }

    changeStatus(ledgerImport: LedgerImportEntity, status: LedgerImportStatusEnum) {
        let values: DaveMutationChangeLedgerImportArgs = getLedgerImportStatusChangeMutationPayload(ledgerImport, status);
        this.store.dispatch(
            LedgerImportActionTypes.ChangeLedgerImports({
                Payload: values,
            }),
        );
        firstValueFrom(this.actions$.pipe(ofType(LedgerImportActionTypes.UpdateMany, BaseActionTypes.ErrorAction))).then(async (action) => {
            this.LS.endLoading('invoice-editor_submit-ledger-import');
            if (action.type === LedgerImportActionTypes.UpdateMany.type) {
                this.InfoiceFormGroup.controls.Status.markAsPristine();
            }
        });
    }

    setQRCodeText() {
        const value = this.InfoiceFormGroup.controls.ShowQRCode.value;
        let text = this.InfoiceFormGroup.controls.TextBottom.getRawValue() || '';

        const qrCodeText = "Möchten Sie die Rechnung direkt begleichen, scannen Sie den QR Code.";

        text = text.replace(qrCodeText, '');
        text = text.replace('\n' + qrCodeText, '');
        text = text.replace('\n\n' + qrCodeText, '');
        if (value) {
            text += '\n\n' + qrCodeText;
        }
        if (text !== this.InfoiceFormGroup.controls.TextBottom.getRawValue()) {
            this.InfoiceFormGroup.controls.TextBottom.markAsDirty();
            this.InfoiceFormGroup.controls.TextBottom.setValue(text);
        }
    }

    async setAllTax(taxTypeId: number) {
        const separateSalaryBaseCost = await firstValueFrom(this.useArlSeparateSalaryBaseCost$);
        const partner = await firstValueFrom(this.store.select(getPartner));
        const isLuksch = partner.Id === window['env']['luksch_partner_id'];
        const isLukschDe = partner.Id === window['env']['luksch_partner_id2'];

        const taxTypes = await firstValueFrom(this.store.select(getTaxTypes));
        const taxType = await firstValueFrom(this.store.select(getTaxTypeById({id: taxTypeId})));
        if (!taxType) {
            throw new Error('TaxType not found, id: ' + taxTypeId);
        }
        const ustIdPlaceholder = '###Customer.UstId###';

        const UstId = this.InfoiceFormGroup.getRawValue().Customer?.UstId;
        let text = this.InfoiceFormGroup.controls.TextBottom.getRawValue() || '';

        const pvText = 'Nach § 12 Abs. 3 UStG wird keine Umsatzsteuer auf Photovoltaikanlagen ausgewiesen.';
        const reverseChargeText = `Nach § 13b UStG wird keine Umsatzsteuer ausgewiesen. Die Steuerschuld liegt beim Leistungsempfänger (Reverse-Charge-Verfahren).${UstId ? ` ${UstId}` : ''}`;
        const reverseChargeText2 = `Nach § 13b UStG wird keine Umsatzsteuer ausgewiesen. Die Steuerschuld liegt beim Leistungsempfänger (Reverse-Charge-Verfahren). ###Customer.UstId###`;
        const kleinunternehmerText = 'Nach § 19 UStG wird keine Umsatzsteuer ausgewiesen.';

        const lukschPvText = 'Nach § 6 Abs. 1 UStG wird keine Umsatzsteuer auf Photovoltaikanlagen ausgewiesen!';
        const lukschInnergemeinschaftlicheLieferungText = 'Innergemeinschaftliche Lieferung';
        const lukschReverseChageText = 'Reverse Charge-System Art. 196 RL 2006/112/EC!';
        const luksch19a = 'Die Lieferung bzw. Abrechnung betrifft Bauleistungen und erfolgt gemäß §19 Abs. 1a steuerfrei.\n' + '\n' + 'Die Umsatzsteuer wird vom Leistungsempfänger geschuldet. UID: ATU23240100';
        const luksch13b = 'Übergang der Steuerschuld auf den Leistungsempfänger gem §13b Abs.2iVm Abs. 1 Satz 1 Nr4 dUStG!';
        const lukschDe13bBauleistung = 'Übergang der Steuerschuld auf den Leistungsempfänger für Bauleistungen gem §13b Abs.2iVm Abs. 1 Satz 1 Nr4 dUStG!';
        const lukschDe13bReverseCharge = 'Übergang der Steuerschuld auf den Leistungsempfänger gem §13b!';

        const regex = new RegExp(`( ` + taxTypes.map(t => (t.InvoiceText || '').replace(ustIdPlaceholder, UstId || '')).filter(v => v).map(escapeRegExp).join(`| `) + `)`, 'g');

        // const regex = new RegExp(
        //     `( ` +
        //     escapeRegExp(pvText) +
        //     `| ` +
        //     escapeRegExp(reverseChargeText) +
        //     `| ` +
        //     escapeRegExp(kleinunternehmerText) +
        //     +`| ` +
        //     escapeRegExp(lukschReverseChageText) +
        //     +`| ` +
        //     escapeRegExp(luksch13b) +
        //     +`| ` +
        //     escapeRegExp(luksch19a) +
        //     +`| ` +
        //     escapeRegExp(lukschPvText) +
        //     +`| ` +
        //     escapeRegExp(lukschInnergemeinschaftlicheLieferungText) +
        //     +`| ` +
        //     escapeRegExp(lukschDe13bBauleistung) +
        //     +`| ` +
        //     escapeRegExp(lukschDe13bReverseCharge) +
        //     `)`,
        //     'g',
        // );

        text = text.replace(regex, '');

        const appendText = (existingText: string, newText: string) => {
            return existingText ? existingText + ' ' + newText : newText;
        };

        this.InfoiceFormGroup.controls.TextBottom.setValue(appendText(text, (taxType.InvoiceText || '').replace(ustIdPlaceholder, UstId || '')));


        this.enableButtonAlleUeberschreiben = false;

        if (!isNotNullOrUndefined(taxType)) {
            throw 'cant set tax';
        }
        if (!separateSalaryBaseCost) {
            const dialogRef = this.dialog.open(ChangeTaxDialogComponent);

            dialogRef.afterClosed().subscribe((result: ChangeTaxDialogReturnData) => {
                switch (result) {
                    case ChangeTaxOption.AdjustGross:
                        this.arlTableService.setAllTax(taxType.TaxPercentage, this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(), ChangeTaxOption.AdjustGross);
                        break;
                    case ChangeTaxOption.AdjustNet:
                        this.arlTableService.setAllTax(taxType.TaxPercentage, this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(), ChangeTaxOption.AdjustNet);
                        break;
                    case ChangeTaxOption.Cancel:
                    default:
                        break;
                }
            });
        } else {
            this.arlTableService.setAllTax(taxType.TaxPercentage, this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(), ChangeTaxOption.AdjustGross);
            // this.taxOptionValue = null;+
        }
    }

    protected readonly ARLTypeEnumNames = ARLTypeEnumNames;
    lohnPreCharge$ = this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.valueChanges.pipe(
        startWith(''),
        map(() => this.InfoiceFormGroup.getRawValue().ARLCalculationPreChargeByTypes),
        map((charges) => charges.find((c) => c.arlType === AccountsReceivableLedgerTypeEnum.EmployeeArl)?.percentage),
        distinctUntilChanged(),
    );
    SkontoAllowancePercent$ = this.InfoiceFormGroup.valueChanges.pipe(
        startWith(''),
        map(() => {
            const values = this.InfoiceFormGroup.getRawValue();
            return values.SkontoAvilable && values.SkontoIsAllowance ? (values.SkontoPercentage || 0) / 100 : null;
        }),
        distinctUntilChanged(),
    );

    async onSelectFileClick(format: 'X83' | 'X84' | 'UGL' | 'ONLV', beShouldUpdateARLsFromGaebImport: boolean) {
        await this.SaveClick(); // todo im hintergrund speichern
        //const li = await firstValueFrom(this.LedgerImport$.pipe(take(1)));
        let folderId = null;
        if (this.InfoiceFormGroup.value.CommissionId?.Id) {
            const folder = await firstValueFrom(this.folderDataService.getFolderFromEntity(this.InfoiceFormGroup.value.CommissionId.Id, FolderTypes.commission).pipe(take(1)));
            folderId = folder.Id;
        } else if (this.InfoiceFormGroup.value.Customer?.Id) {
            const folder = await firstValueFrom(this.folderDataService.getFolderFromEntity(this.InfoiceFormGroup.value.Customer.Id, FolderTypes.customer).pipe(take(1)));
            folderId = folder.Id;
        }
        //OpenUGL Dialog
        let supplierRes: SelectSupplierDialogReturnData = null;
        if (beShouldUpdateARLsFromGaebImport && (format === 'UGL' || format === 'X84')) {
            supplierRes = await firstValueFrom(this.dialog.open<SelectSupplierDialogComponent, SelectSupplierDialogData, SelectSupplierDialogReturnData>(SelectSupplierDialogComponent, {}).afterClosed());

            if (!supplierRes.Confirmed) {
                return;
            }
        }
        const selectFileResult = await firstValueFrom(
            this.dialog
                .open<DaveSelectFileFromDmsComponent, DaveSelectFileFromDmsComponentDialogData, DaveSelectFileFromDmsComponentReturnData>(DaveSelectFileFromDmsComponent, {
                    ...DaveSelectFileFromDmsComponent.DefaultConfig,
                    data: {
                        moveWarning: '',
                        preSelectedFiles: [],
                        maxFiles: 1,
                        folderId: folderId,
                    },
                })
                .afterClosed(),
        );

        if (!selectFileResult?.documents?.length) {
            return;
        }
        if (selectFileResult.documents?.length > 1) {
            console.error('mehr als eine datei ausgewählt');
        }

        this.ls.startLoading('invoiceEditor_gaebImportInDocument');
        //  this.form.patchValue({ file: null, documentId: res.synchronUploadedDocuments[0].Id });
        const file = await firstValueFrom(this.fileDataService.GetFileById$(selectFileResult.documents[0]));
        if (!beShouldUpdateARLsFromGaebImport) {
            await this.submitGaebFileLv(file);
        } else {
            let setQuantityResult: boolean | undefined;
            if (format === 'X84') {
                setQuantityResult = await firstValueFrom(
                    this.dialog.open<SetQuantityDialogGaebComponent, SetQuantityDialogGaebComponentDialogData, SetQuantityDialogGaebComponentDialogReturnData>(SetQuantityDialogGaebComponent, {}).afterClosed(),
                );
            }

            await this.submitGaebFile(format, file, setQuantityResult, supplierRes?.SupplierId, supplierRes?.SelectedFillEmptyValuesWithMtS);
            this.ls.endLoading('invoiceEditor_gaebImportInDocument');
        }
    }

    async onUploadFileClick(format: 'X83' | 'X84' | 'UGL' | 'ONLV', beShouldUpdateARLsFromGaebImport: boolean) {
        await this.SaveClick();
        const uploadFileResult = await firstValueFrom(
            this.dialog
                .open<SelectFolderDialogComponent, SelectFolderDialogComponentDialogData, SelectFolderDialogComponentDialogReturnData>(SelectFolderDialogComponent, {
                    ...SelectFolderDialogComponent.DefaultConfig,
                    data: {
                        ButtonText: 'HOCHLADEN',
                        matTreeNodePaddingIndent: 10,
                        uploadMode: true,
                        synchronUpload: true,
                        maxFilesUpload: 1,
                        //  acceptedFiles: [this.mimeType, this.fileExtension].join(','),
                    },
                })
                .afterClosed(),
        );
        if (!uploadFileResult?.synchronUploadedDocuments?.length) {
            return;
        }
        if (uploadFileResult.synchronUploadedDocuments?.length > 1) {
            console.error('mehr als eine datei ausgewählt');
        }
        let setQuantityResult: boolean | undefined;

        if (beShouldUpdateARLsFromGaebImport && format === 'X84') {
            setQuantityResult = await firstValueFrom(this.dialog.open<SetQuantityDialogGaebComponent>(SetQuantityDialogGaebComponent, {}).afterClosed());
        }
        let supplierRes: SelectSupplierDialogReturnData = null;
        if (beShouldUpdateARLsFromGaebImport && (format === 'UGL' || format === 'X84')) {
            supplierRes = await firstValueFrom(this.dialog.open<SelectSupplierDialogComponent, SelectSupplierDialogData, SelectSupplierDialogReturnData>(SelectSupplierDialogComponent, {}).afterClosed());

            if (!supplierRes?.Confirmed) {
                return;
            }
        }

        this.ls.startLoading('invoiceEditor_gaebImportInDocument');
        const file = await firstValueFrom(this.fileDataService.GetFileById$(uploadFileResult.synchronUploadedDocuments[0].Id));
        if (!beShouldUpdateARLsFromGaebImport) {
            await this.submitGaebFileLv(file);
        } else {
            await this.submitGaebFile(format, file, setQuantityResult, supplierRes?.SupplierId, supplierRes?.SelectedFillEmptyValuesWithMtS);
            this.ls.endLoading('invoiceEditor_gaebImportInDocument');
        }
    }

    private async submitGaebFile(format: 'X83' | 'X84' | 'UGL' | 'ONLV', file: FileEntity, setQuantityResult: boolean, supplierId: number, selectedFillEmptyValuesWithMtS: boolean) {
        const taxTypeId = this.InfoiceFormGroup.controls.TaxTypeId.getRawValue();

        let taxValue = 0;
        if (taxTypeId) {
            const taxType = await firstValueFrom(this.store.select(getTaxTypeById({id: taxTypeId})));
            if (!taxType) {
                throw new Error('TaxType not found, id: ' + taxTypeId);
            }
            taxValue = taxType.TaxPercentage / 100;
        } else {
            taxValue = (await firstValueFrom(this.store.select(getDefaultVat))) / 100;
        }

        if (format === 'X84') {
            try {
                await this.gatewayService.Request({
                    GabeLedgerImportSetFromFile: {
                        VersionId: file.GetLastVersion().Id.toString(),
                        LedgerImportId: this.LedgerImportId.toString(),
                        SetQuantities: setQuantityResult,
                        SupplierId: supplierId ? supplierId.toString() : null,
                        SetLP: this.InfoiceFormGroup.controls.UseListPriceForNewMaterials.value,
                        FillEmptyValuesWithMtS: selectedFillEmptyValuesWithMtS,
                        Tax: taxValue,
                    },
                });
            } catch (e) {
                this.store.dispatch(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: 'Angebot importieren fehlgeschlagen',
                        Err: e
                    }
                }));
            }
            // this.store.select(this.arlDataService.getArlsFromLedgerImport$(this.LedgerImportId))
            const arlUpdatedSince = new Date();
            arlUpdatedSince.setHours(arlUpdatedSince.getHours() - 2);

            await this.arlDataService.getARLsByUpdatedSince(arlUpdatedSince);
            if (!this.arlTableComponent) {
                await this.arlTableService.updatePriceValuesInFormControl(
                    this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(),
                    this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue(),
                    this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue(),
                );
            }
        } else {
            let useLv = await firstValueFrom(this.useLVCalculation$);
            if (format === 'UGL') {
                useLv = false;
            }

            if (useLv && !this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue()) {
                this.toggleLvCalculation(true);
            }
            try {
                const res = await this.gatewayService.Request({
                    GabeLedgerImportFromFile: {
                        VersionId: file.GetLastVersion().Id.toString(),
                        LedgerImportId: this.LedgerImportId.toString(),
                        SupplierId: supplierId ? supplierId.toString() : null,
                        SetLP: this.InfoiceFormGroup.controls.UseListPriceForNewMaterials.value,
                        FillEmptyValuesWithMtS: selectedFillEmptyValuesWithMtS,
                    },
                });
                console.log({res});
                if (res?.Errors && Object.keys(res.Errors).length) {
                    throw res.Errors;
                }
            } catch (e) {
                this.store.dispatch(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: 'Angebot importieren fehlgeschlagen',
                        Err: e
                    }
                }));
            }
            const arlUpdatedSince = new Date();
            arlUpdatedSince.setHours(arlUpdatedSince.getHours() - 2);

            const previous = await firstValueFrom(this.ledgerImportDataService.getLedgerImportId$(this.LedgerImportId, false));

            await this.arlDataService.getARLsByUpdatedSince(arlUpdatedSince);

            const li = await firstValueFrom(
                this.ledgerImportDataService.getLedgerImportId$(this.LedgerImportId, true).pipe(
                    skipWhile((current) => !current || JSON.stringify(current) === JSON.stringify(previous)),
                    take(1),
                ),
            );
            // ArlForms must be set Before ArlIds were set in InfoiceFormGroup
            const bookingPositions = await firstValueFrom(this.arlDictFromState$);
            li.AccountsReceivableLedgerIds.forEach(id => this.arlFormDataService.getFormByEntity(id, bookingPositions));
            if (this.arlTableComponent) {
                this.arlTableComponent.allreadyCalculated = false;
            }
            this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.setValue(li.AccountsReceivableLedgerIds);
            this.setArlForms(li.AccountsReceivableLedgerIds.map((id) => this.arlFormDataService.getFormByEntity(id, bookingPositions)));
        }
        if (this.arlTableComponent) {
            this.arlTableComponent.refresh();
        }

        this.cdr.detectChanges();
    }

    private async submitGaebFileLv(file: FileEntity) {
        const response = await this.invoicingService.getInvoiceDataFromFile(file.GetLastVersion().Id, true, true, this.LedgerImportId);
        this.ls.endLoading('invoiceEditor_gaebImportInDocument');

        if (!response) {
            return;
        }
        const selectArlsResponse = await firstValueFrom(
            this.dialog
                .open<SelectGaebArlDataComponent, SelectGaebArlDataComponentDialogData, SelectGaebArlDataComponentDialogReturnData>(SelectGaebArlDataComponent, {
                    ...SelectGaebArlDataComponent.DefaultConfig,
                    data: {
                        bookingPositions: response,
                    },
                })
                .afterClosed(),
        );
        if (selectArlsResponse?.arls.length) {
            this.arlLvCalculationComponent.dataSource.removeFormSubscriptions();
            this.arlTableService.updatePriceLV(selectArlsResponse.arls, selectArlsResponse.supplierId, this.InfoiceFormGroup.controls.Arls);
            this.arlLvCalculationComponent.dataSource.initFormControlSubscriptions();
        }
    }

    onToggleEmployeeQuantityTypeClick(toggle: MatButtonToggle) {
        // arlTableComponent.onEmployeeQuantityTypeChange($event)
        console.log(toggle.value, toggle.buttonToggleGroup.value);
    }

    onToggleEmployeeQuantityTypeChange(event: MatButtonToggleChange) {
        // arlTableComponent.onEmployeeQuantityTypeChange($event)
        const toggle = event.source;
        console.log(toggle, toggle?.value, event.value.slice());
        if (toggle && event.value.some((item) => item == toggle.value)) {
            toggle.buttonToggleGroup.value = [toggle.value];
        }
        this.InfoiceFormGroup.controls.EmployeeQuantityTypeId.setValue(toggle.buttonToggleGroup.value?.length === 1 ? toggle.buttonToggleGroup.value[0] : null);
        this.InfoiceFormGroup.controls.EmployeeQuantityTypeId.markAsDirty();
    }

    onCreateOrderDeliveryNoteClick(documentType: LedgerImportDocumentTypes.Order | LedgerImportDocumentTypes.DeliveryNote) {
        const arlIds = this.InfoiceFormGroup.getRawValue().AccountsReceivableLedgerIds;
        const arFormValues = arlIds
            .map((id) => this.arlFormDataService.getChildIds(id))
            .flat()
            .map<Pick<AccountsReceivableLedgerEntity, 'Id' | 'MaterialId' | 'Type' | 'Quantity' | 'QuantityTypeId' | 'BookingText' | 'Information' | 'CostAmount' | 'Tax' | 'SupplierId'>[]>((id) => {
                const form = this.arlFormDataService.getForm(id);
                const calcFormValues = form.getRawValue().InheritFromChildren ? form.getRawValue().childArlsCalculation : [];
                return [form.getRawValue(), ...calcFormValues.map((calc) => ({
                    Tax: form.getRawValue().Tax, ...calc,
                    Quantity: calc.Quantity * form.getRawValue().Quantity
                }))];
            })
            .flat();

        this.dialog.open<NewOrderFromLedgerimportComponent, NewOrderFromLedgerimportDialogData, NewOrderFromLedgerimportDialogReturnData>(NewOrderFromLedgerimportComponent, {
            data: {
                arls: arFormValues,
                rootLedgerImportId: this.LedgerImportId,
                commissionId: this.InfoiceFormGroup.getRawValue().CommissionId?.Id,
                documentType: documentType,
            },
        });
    }

    addArlButtons$: Observable<{
        type: addArlDragButtonType;
        label: string;
        icon: IconProp;
    }[]> = this.InfoiceFormGroup.controls.IsLvCalculated.valueChanges.pipe(
        startWith(null),
        map(() => this.InfoiceFormGroup.getRawValue().IsLvCalculated),
        distinctUntilChanged(),
        map((isLv) => {
            const btns: { type: addArlDragButtonType; label: string; icon: IconProp; }[] = [
                { type: 'group', label: 'Titel', icon: 'layer-group' },
                { type: 'text', label: 'Text', icon: 't'  },
                { type: 'arl', label: 'Leistung', icon: 'briefcase' },
                { type: 'resource-arl', label: ResourceEntity.EntityName, icon: ResourcePageMeta.Icon  },
                { type: 'material-arl', label: MaterialEntity.EntityName, icon: MaterialPageMeta.Icon  },
                { type: 'fremdleistung-arl', label: 'Fremdleistung', icon: 'truck'  },
                { type: 'salary-arl', label: 'Lohn', icon: 'user-clock'  },
                { type: 'other-arl', label: 'Sonstiges', icon: 'shapes' },
            ];

            return isLv ? btns.filter((b) => ['group', 'text', 'arl'].includes(b.type)) : btns;
        }),
    );
    protected readonly MaterialPageMeta = MaterialPageMeta;
    protected readonly LedgerImportBreakPageModeEnum = LedgerImportBreakPageModeEnum;

    private filePreviewDialog: MatLegacyDialogRef<DaveFilePreviewComponent>;

    async openLedgerImportDocument() {
        const li = await firstValueFrom(this.LedgerImport$);

        const fileId = li?.DocumentId;
        if (!li.DocumentCanBeDownloaded) {
            const pdfstate = await firstValueFrom(
                this.dialog
                    .open<PendingLedgerimportDocumentCreationDialogComponent, PendingLedgerimportDocumentCreationDialogComponentDialogData, PendingLedgerimportDocumentCreationDialogComponentDialogReturnData>(
                        PendingLedgerimportDocumentCreationDialogComponent,
                        {
                            ...PendingLedgerimportDocumentCreationDialogComponent.DialogConfig,
                            data: {
                                ledgerImportId: li.Id,
                            },
                        },
                    )
                    .afterClosed(),
            );
            if (pdfstate !== 'finished') {
                return;
            }
        }

        if (this.filePreviewDialog && this.filePreviewDialog?.getState() !== MatDialogState.CLOSED) {
            this.filePreviewDialog.close();
        }
        this.filePreviewDialog = this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
            ...DaveFilePreviewComponent.DefaultConfig,
            data: {
                fileId,
            },
        });
    }

    protected async syncPaymentClick() {
        if (this.ls.isLoading) {
            return;
        }
        this.ls.startLoading('app-invoice-editor_syncPayment');
        const li = await firstValueFrom(this.LedgerImport$);
        if (li) {
            const paymentItems = await this.ledgerImportDataService.getCurrentPaymentItems(li.Id);
            if (paymentItems) {
                const previousPaymentItems = this.InfoiceFormGroup.controls.PaymentItems.getRawValue();
                if (paymentItems.length !== previousPaymentItems.length || paymentItems.some((item, index) => !compareLedgerImportPaymentItems(item, previousPaymentItems[index]))) {
                    this.InfoiceFormGroup.controls.PaymentItems.setValue(paymentItems);
                    this.InfoiceFormGroup.controls.PaymentItems.markAsDirty();
                } else {
                    this.toastrService.info('Es gibt keine Änderungen');
                }
            }
        }
        this.ls.endLoading('app-invoice-editor_syncPayment');
    }

    protected async resetPaymentClick() {
        if (this.ls.isLoading) {
            return;
        }
        const li = await firstValueFrom(this.LedgerImport$);
        if (li) {
            this.InfoiceFormGroup.controls.PaymentItems.reset(li.PaymentItems);
        }
    }

    async toggleLvCalculation(skipDialog: boolean = false) {
        if (this.InfoiceFormGroup.getRawValue().IsLvCalculated) {
            this.changeInprogressWhileLVpending$.next(false);
            // todo readonly mode
            const res = await firstValueFrom(this.disableLVToggle$);
            if (!res) {
                this.InfoiceFormGroup.controls.IsLvCalculated.setValue(false);
                this.InfoiceFormGroup.controls.IsLvCalculated.markAsDirty();
            }
        } else {
            const res = skipDialog
                ? [true]
                : await firstValueFrom(
                    this.appDialog.OpenConfirmationDialog({
                        heading: 'LV-Kalkulation starten?',
                        paragraph: 'Sobald in der LV-Kalkulation Änderungen vorgenommen wurden kann nicht mehr zurück gewechselt werden.',
                    }),
                );
            if (res && res[0]) {
                this.InfoiceFormGroup.controls.IsLvCalculated.setValue(true);
                this.InfoiceFormGroup.controls.IsLvCalculated.markAsDirty();
                this.updatePartieStdOnArls();
                // todo anders lösen
                setTimeout(
                    () =>
                        this.InfoiceFormGroup.controls.Arls.valueChanges.pipe(takeUntil(merge(this.InfoiceFormGroup.controls.IsLvCalculated.valueChanges, this.onDestroy$)), first()).subscribe(() => {
                            if (this.InfoiceFormGroup.getRawValue().IsLvCalculated) {
                                console.log('start lv calculation');
                                this.changeInprogressWhileLVpending$.next(true);
                            }
                        }),
                    800,
                );
            }
        }
    }

    onCdkDragStarted($event: CdkDragStart) {
        // this.bodyElement.classList.add('inheritCursors');
        document.body.style.cursor = 'grabbing';
    }

    onCdkDragEnded($event: CdkDragEnd) {
        // this.bodyElement.classList.remove('inheritCursors');
        document.body.style.cursor = 'unset';
    }

    submitColumnChange(cols: Array<ArlTableComponentDisplayedColumns>) {
        const sorted = cols.slice().sort((a, b) => ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(a) - ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(b));
        const changed = !compareArrays(this.InfoiceFormGroup.controls.ArlTableDisplayedColumns.getRawValue(), sorted);
        if (changed) {
            this.InfoiceFormGroup.controls.ArlTableDisplayedColumns.setValue(sorted);
            this.InfoiceFormGroup.controls.ArlTableDisplayedColumns.markAsDirty();
        }
    }

    submitColumnChangeInDocument(cols: Array<ArlTableComponentDisplayedColumns>) {
        const sorted = cols.slice().sort((a, b) => ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(a) - ARL_TABLE_ALL_DISPLAYED_COLUMNS_SORTED.indexOf(b));
        const changed = !compareArrays(this.InfoiceFormGroup.controls.ArlTableDocumentDisplayedColumns.getRawValue(), sorted);

        if (changed) {
            this.InfoiceFormGroup.controls.ArlTableDocumentDisplayedColumns.setValue(sorted);
            this.InfoiceFormGroup.controls.ArlTableDocumentDisplayedColumns.markAsDirty();
        }
    }

    private updatePartieStdOnArls() {
        this.arlTableService.updateLvPartieHEur(
            this.InfoiceFormGroup.controls.PartieStd.getRawValue(),
            this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue(),
            this.InfoiceFormGroup.controls.IsLvCalculated.getRawValue(),
            this.InfoiceFormGroup.controls.ARLSurChargeByTypes.getRawValue(),
            this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue(),
        );
    }

    partieStdChange($event: number) {
        this.InfoiceFormGroup.controls.PartieStd.setValue($event);
        this.InfoiceFormGroup.controls.PartieStd.markAsDirty();
        this.updatePartieStdOnArls();
    }

    // triggerPositionCalculation() {
    //     this.arlTableComponent?._arlIds$.next(this.arlTableComponent._arlIds$.value) // todo in service auslagern
    //     this.arlTableComponent?.triggerPositionCalculation$.next() // todo in service auslagern
    //     // this.arlTableComponent?.refresh() // todo in service auslagern
    //     this.arlTableComponent?.positionStrings$.pipe(first()).subscribe(()=>{})
    // }

    visibleExportButtons$ = defer(() => this.LedgerImport$.pipe(map((li) => this.allExportButtons.filter((b) => li?.GabeImportedType === null || li?.GabeImportedType === b.type))));

    hiddenExportButtons$ = defer(() => this.LedgerImport$.pipe(map((li) => this.allExportButtons.filter((b) => !(li?.GabeImportedType === null || li?.GabeImportedType === b.type)))));

    async onLockClick() {
        const isReadonly = await firstValueFrom(this.disableGaebRelevantForms$);
        if (isReadonly) {
            if (this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.getRawValue()) {
                this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.setValue(false);
                this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.markAsDirty();
            } else if (!this.forceGaebEditing$.value) {
                this.forceGaebEditing$.next(true);
            } else {
                throw 'unknown situation: onLockClick in invoice-editor';
            }
        } else {
            if (this.forceGaebEditing$.value) {
                this.forceGaebEditing$.next(false);
            } else if (!this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.getRawValue()) {
                this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.setValue(true);
                this.InfoiceFormGroup.controls.ARLReadOnlyModeSetByUser.markAsDirty();
            } else {
                throw 'unknown situation: onLockClick in invoice-editor';
            }
        }
    }

    protected async onDownloadFileClick(type: 'pdf' | 'xInvoice', catchAllreadyExecuted: boolean = false) {
        await this.SaveClick();
        const invoice = await firstValueFrom(this.LedgerImport$);
        if (type === 'pdf') {
            if (invoice.DocumentStatus === DocumentStatusEnum.None && invoice.DocumentId == null) {
                await this.SaveClick(true);
            }
            if (!invoice.DocumentCanBeDownloaded) {
                const pdfstate = await firstValueFrom(
                    this.dialog
                        .open<PendingLedgerimportDocumentCreationDialogComponent, PendingLedgerimportDocumentCreationDialogComponentDialogData, PendingLedgerimportDocumentCreationDialogComponentDialogReturnData>(
                            PendingLedgerimportDocumentCreationDialogComponent,
                            {
                                ...PendingLedgerimportDocumentCreationDialogComponent.DialogConfig,
                                data: {
                                    ledgerImportId: invoice.Id,
                                },
                            },
                        )
                        .afterClosed(),
                );
                if (pdfstate !== 'finished') {
                    return;
                }
            }
        }
        try {
            if (type === 'pdf') {
                if (!invoice?.DocumentId) {
                    await this.SaveClick(true);
                    await this.onDownloadFileClick(type, true)
                    return
                }
                await this.donwloadLiDocumentId(invoice.DocumentId, invoice);
            }
            if (type === 'xInvoice') {
                if (!invoice?.DocumentIdXRechnung) {
                    this.store.dispatch(
                        LedgerImportActionTypes.CreateXRechnungFromLedgerImport({
                            Payload: {id: invoice.Id}
                        })
                    );

                    await firstValueFrom(
                        this.actions$.pipe(
                            ofType(LedgerImportActionTypes.SuccessChangeLedgerImport),
                            take(1)
                        )
                    );
                    await this.onDownloadFileClick(type, true)
                    return;
                }
                await this.donwloadLiDocumentId(invoice.DocumentIdXRechnung, invoice);
            }
        } catch (e) {
            if (!catchAllreadyExecuted && type === 'pdf') {
                await this.SaveClick(true);
                await this.onDownloadFileClick(type, true)
            }
            if (!catchAllreadyExecuted && type === 'xInvoice') {
                this.store.dispatch(
                    LedgerImportActionTypes.CreateXRechnungFromLedgerImport({
                        Payload: {id: invoice.Id}
                    })
                );

                await firstValueFrom(
                    this.actions$.pipe(
                        ofType(LedgerImportActionTypes.SuccessChangeLedgerImport),
                        take(1)
                    )
                );
                await this.onDownloadFileClick(type, true)
                return;
            }
            return;
        }
        // const btn = document.createElement('a');
        // btn.download = this.GetFilename(invoice.ConsolidatedInvoiceId);
        // btn.href = link;
        // document.body.appendChild(btn);
        // btn.click();
        // document.body.removeChild(btn);
    }

    @ViewChild('invoiceNumberInput') invoiceNumberInputTemplate!: TemplateRef<any>;
    @ViewChild('drawer') drawer!: MatDrawer;

    @ViewChild('config') config: TableConfigFormComponent<
        arlTableData<AccountsReceivableLedgerEntity>,
        'Position' | 'BookingText' | 'Information' | 'Quantity' | 'QuantityType' | 'BaseCost' | 'BaseCostGross' | 'CompleteCost' | 'CompleteCostGross' | 'BaseCost_salary' | 'BaseCost_other' | 'BaseCost_salary_cost' | 'BaseCost_other_cost' | 'BaseCost_cost' | 'BaseCostGross_cost'
    >;
    @ViewChild('configDocument') configDocument: TableConfigFormComponent<
        arlTableData<AccountsReceivableLedgerEntity>,
        'Position' | 'BookingText' | 'Information' | 'Quantity' | 'QuantityType' | 'BaseCost' | 'BaseCostGross' | 'CompleteCost' | 'CompleteCostGross' | 'BaseCost_salary' | 'BaseCost_other' | 'BaseCost_salary_cost' | 'BaseCost_other_cost' | 'BaseCost_cost' | 'BaseCostGross_cost'
    >;

    protected activeDrawerMode: 'table' | 'document' | null = null;

    openDrawer(mode: 'table' | 'document') {
        if (this.drawer.opened && this.activeDrawerMode === mode) {
            this.drawer.close();
            return;
        }

        this.activeDrawerMode = mode;
        this.drawer.open();
    }

    handleDrawerClosed() {
        if (this.activeDrawerMode === 'table') {
            this.submitColumnChange(this.config.selectedColumns);
        } else if (this.activeDrawerMode === 'document') {
            this.submitColumnChangeInDocument(this.configDocument.selectedColumns);
        }
        this.activeDrawerMode = null;
    }

    protected async onPriceCompairsonClick() {
        this.ls.startLoading("openPriceComparison")
        let arlFormValue = this.InfoiceFormGroup.controls.Arls.getRawValue()

        var l2pc = await this.ledgerImportToPriceComparisonDataService.getLedgerImportToPriceComparisonFromLiId(this.LedgerImportId.toString())
        const priceComparisons: PriceComparison[] = []

        //Todo adjust when Lis could ve more than one l2pc
        if (l2pc.length !== 0 && l2pc[0].PriceComparisonIds != null && l2pc[0].PriceComparisonIds !== "[]") {
            const ids: string[] = JSON.parse(l2pc[0].PriceComparisonIds).map(String);

            const res = await this.priceComparisonDataService.getPriceComparisonFromIds(ids)

            const map = new Map(res.map(pc => [pc.Id, pc]));
            const sorted = ids
                .map(id => map.get(id))
                .filter(pc => pc != null);
            priceComparisons.push(...sorted);
        }

        // this.dialog.open<
        //     PriceComparisonComponent,
        //     PriceComparisonComponentDialogData,
        //     PriceComparisonComponentDialogReturnData
        // >(PriceComparisonComponent, {
        //     ...PriceComparisonComponent.DefaultConfig,
        //     data: {
        //         priceComparisons: priceComparisons,
        //         arlFormValue: arlFormValue,
        //         ledgerImportId: this.LedgerImportId,
        //     }
        // })
        console.log("TEST", arlFormValue)
        this.dialog.open<
            PriceComparisonComponent<Require<arlTableDataArlForm['value'], keyof PriceComparisonBaseItem>>,
            PriceComparisonComponentDialogData<Require<arlTableDataArlForm['value'], keyof PriceComparisonBaseItem>>,
            PriceComparisonComponentDialogReturnData
        >(PriceComparisonComponent, {
            ...PriceComparisonComponent.DefaultConfig,
            data: {
                inputFormValue: arlFormValue as Require<arlTableDataArlForm['value'], keyof PriceComparisonBaseItem>[],
                getId: (a) => a.Id,
                getChildren: (a) => (a.childArls ?? []) as Require<arlTableDataArlForm['value'], keyof PriceComparisonBaseItem>[],
                getType: (a) => a.Type,
                getQuantity: (a) => a.Quantity,
                getMaterialId: (a) => a.MaterialId,
                getFileData: async (fileVersionId) => {
                    const result = await this.invoicingService.getInvoiceDataFromFile(
                        fileVersionId,
                        true,
                        true,
                        this.LedgerImportId,
                    );
                    return result?.map(d => ({
                        matchedId: d.matchedArlId?.length ? +d.matchedArlId : null,
                        price: d.Price?.length ? +d.Price / 100 : null,
                    })) ?? null;
                },
                priceComparisons: priceComparisons,
            }
        }).afterClosed()
            .subscribe(async result => {
                this.ls.startLoading("priceComparisonResult");
                if (result?.BidderData) {
                    const priceComparisonIds: number[] = [];

                    for (const bidderData of result.BidderData) {
                        if (bidderData?.priceComparisonId) {
                            priceComparisonIds.push(+bidderData.priceComparisonId);
                            if (bidderData.dirty) {
                                if (!result.SavePrices) {
                                    const payload: PriceComparisonEditRequest = {
                                        Id: bidderData.priceComparisonId,
                                        SkontoPercent: bidderData.skonto,
                                        RabattPercent: bidderData.rabatt,
                                    };
                                    this.priceComparisonDataService.changePriceComparison(payload)
                                } else {
                                    const payload: PriceComparisonEditRequest = {
                                        Id: bidderData.priceComparisonId,
                                        SkontoPercent: bidderData.skonto,
                                        RabattPercent: bidderData.rabatt,
                                        PositionData: JSON.stringify(Object.values(bidderData.positions)),
                                    };
                                    this.priceComparisonDataService.changePriceComparison(payload)
                                    const positionsArray: PositionValuePriceComparison[] = Array.isArray(bidderData.positions)
                                        ? bidderData.positions
                                        : Object.values(bidderData.positions || {});

                                    positionsArray.forEach(position => {
                                        if (!position.isGroup && position.selected) {
                                            const form = this.arlFormDataService.getForm(position.arlId)
                                            form.controls.PriceComparisonId.setValue(+bidderData.priceComparisonId)
                                            form.controls.PriceComparisonId.markAsDirty()
                                            if (this.InfoiceFormGroup.controls.IsLvCalculated.value) {
                                                form.controls.lvCalculation.controls.SoEk.setValue(position.discountPrice)
                                                form.controls.lvCalculation.controls.SoEk.markAsDirty()
                                            } else {
                                                form.controls.CostAmount.setValue(position.discountPrice)
                                                form.controls.CostAmount.markAsDirty()
                                            }
                                            form.controls.SupplierId.setValue(bidderData.customerId)
                                            form.controls.SupplierId.markAsDirty()
                                            form.controls.ChangedAfterSelectedFromPriceComparison.setValue(false)
                                            form.controls.ChangedAfterSelectedFromPriceComparison.markAsDirty()
                                        }
                                    });
                                }
                            }
                        } else {
                            const payload: PriceComparisonAddRequest = {
                                LedgerImportId: this.LedgerImportId.toString(),
                                SkontoPercent: bidderData.skonto,
                                RabattPercent: bidderData.rabatt,
                                SupplierId: bidderData?.customerId ? bidderData.customerId.toString() : null,
                                PositionData: JSON.stringify(Object.values(bidderData.positions)),
                                FileName: bidderData.fileName,
                            };
                            var res = await this.priceComparisonDataService.addPriceComparison(payload)
                            priceComparisonIds.push(res.Id)
                            const positionsArray: PositionValuePriceComparison[] = Array.isArray(bidderData.positions)
                                ? bidderData.positions
                                : Object.values(bidderData.positions || {});
                            positionsArray.forEach(position => {
                                if (!position.isGroup && position.selected) {
                                    const form = this.arlFormDataService.getForm(position.arlId)
                                    form.controls.PriceComparisonId.setValue(+res.Id)
                                    form.controls.PriceComparisonId.markAsDirty()
                                    if (this.InfoiceFormGroup.controls.IsLvCalculated.value) {
                                        form.controls.lvCalculation.controls.SoEk.setValue(position.discountPrice)
                                        form.controls.lvCalculation.controls.SoEk.markAsDirty()
                                    } else {
                                        form.controls.CostAmount.setValue(position.discountPrice)
                                        form.controls.CostAmount.markAsDirty()
                                    }

                                    form.controls.SupplierId.setValue(bidderData.customerId)
                                    form.controls.SupplierId.markAsDirty()
                                    form.controls.ChangedAfterSelectedFromPriceComparison.setValue(false)
                                    form.controls.ChangedAfterSelectedFromPriceComparison.markAsDirty()
                                }
                            });
                        }
                    }
                    for (const oldPc of priceComparisons) {
                        if (!priceComparisonIds.includes(+oldPc.Id)) {
                            const payload: PriceComparisonDeleteRequest = {
                                id: oldPc.Id
                            };
                            this.priceComparisonDataService.deletePriceComparison(payload)
                        }
                    }


                    if (l2pc.length === 0) {
                        const payload: LedgerImportToPriceComparisonAddRequest = {
                            LedgerImportId: this.LedgerImportId.toString(),
                            PriceComparisonIds: JSON.stringify(priceComparisonIds),
                        };
                        this.ledgerImportToPriceComparisonDataService.addLedgerImportToPriceComparison(payload)

                    } else {
                        //Todo adjust when Lis could ve more than one l2pc
                        const payload: LedgerImportToPriceComparisonEditRequest = {
                            Id: l2pc[0].Id,
                            PriceComparisonIds: JSON.stringify(priceComparisonIds),
                        };
                        this.ledgerImportToPriceComparisonDataService.changeLedgerImportToPriceComparison(payload)
                    }
                    this.SaveClick();
                }
                this.ls.endLoading("priceComparisonResult");
            });

    }

    protected onCheckboxChange($event: MatLegacyCheckboxChange) {
        this.updateDeliveryAddress($event.checked, true);
        // setTimeout(() => this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.setValue($event.checked), 10);
        this.InfoiceFormGroup.controls.UseDeliveryAddressFromCommission.setValue($event.checked)
    }

    private preventUseDeliveryAddressFromCommissionSubscription = false;
    /**
     * InfoiceFormGroupSetValue ist ein fix, beim ersten mal speichern wird scheinbar das FormControl kaputt gemacht oder ausgetauscht,
     * daher muss dieses observable einen neuen wert ausgeben, mit dem aktuellen form control, auf dem auch die subscriptions hören
     */
    protected vorbewertungsFormsVM$ = merge(this.isLvCalculated$, this.InfoiceFormGroupSetValue$).pipe(
        withLatestFrom(this.isLvCalculated$),
        map(([_, isLv]) => {
            console.log('### vorbewertungsFormsVM', isLv);
            if (isLv) {
                return this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.controls.filter(c => preChargeUsedInLv(c.value.arlType));
            }
            return this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.controls;
        }))

    /**
     * InfoiceFormGroupSetValue ist ein fix, beim ersten mal speichern wird scheinbar das FormControl kaputt gemacht oder ausgetauscht,
     * daher muss dieses observable einen neuen wert ausgeben, mit dem aktuellen form control, auf dem auch die subscriptions hören
     */
    protected ARLSurChargeByTypesFormsVM$ = merge(this.isLvCalculated$, this.InfoiceFormGroupSetValue$).pipe(
        withLatestFrom(this.isLvCalculated$),
        map(([_, isLv]) => {
            if (isLv) {
                return this.InfoiceFormGroup.controls.ARLSurChargeByTypes.controls.filter(c => aRLSurChargeByTypeUsedInLv(c.value.arlType));
            }
            return this.InfoiceFormGroup.controls.ARLSurChargeByTypes.controls;
        }))

    protected updateDeliveryAddress(setCommissionAddress: boolean, clear: boolean = false) {
        if (setCommissionAddress) {
            const commissionValue = this.InfoiceFormGroup.controls.CommissionId.value;
            this.InfoiceFormGroup.patchValue({
                DeliveryName: commissionValue.CustomerName,
                DeliveryStreet: commissionValue.Street,
                DeliveryPostalCode: commissionValue.PostalCode,
                DeliveryCity: commissionValue.City
            });
        } else if (clear) {
            this.InfoiceFormGroup.patchValue({
                DeliveryName: "",
                DeliveryStreet: "",
                DeliveryPostalCode: "",
                DeliveryCity: ""
            }, {emitEvent: false});
        }

    }

    async openRequirementTable() {
        const loadArls = async () => {
            return (await firstValueFrom(this.arlFormDataService.getChildren$(this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.value))).filter((arl) => arl.value.Type !== AccountsReceivableLedgerTypeEnum.Group && arl.value.Type !== AccountsReceivableLedgerTypeEnum.Text);
        };

        var arls = await loadArls();
        this.dialog.open<RequirementTableDialogComponent, RequirementTableDialogComponentDialogData>(RequirementTableDialogComponent, {
            ...RequirementTableDialogComponent.DefaultConfig,
            data: {
                arls: arls,
                refreshArls: loadArls
            }
        });
    }

    protected async lvARLGlobalSurchargesByTypesChange($event: LedgerImportARLSurchargesByType) {
        const control = this.InfoiceFormGroup.controls.ARLSurChargeByTypes.controls.find(c => c.value.arlType === $event.arlType)?.controls.percentage;
        if (control.value !== $event.percentage) {
            control.setValue($event.percentage);
            control.markAsDirty();
        }
        const rootForms = this.InfoiceFormGroup.controls.AccountsReceivableLedgerIds.getRawValue().map((id) => this.arlFormDataService.getForm(id))
        // zuschläge erste ebene setzen
        await this.arlTableService.overrideAllSurcharge(
            rootForms,
            {arlType: $event.arlType},
            $event.percentage,
            // this.InfoiceFormGroup.controls.ARLCalculationPreChargeByTypes.getRawValue(),
            this.InfoiceFormGroup.controls.ARLCalculationGlobalPreCharge.getRawValue(),
        )
        if (this.arlTableComponent) {
            await this.arlTableComponent.recalculateAllSurcharge();
        }
        // Zuschläge in Kalkulation setzen
        this.arlTableComponent.setAllCalculationZuschlInPercent($event.arlType, $event.percentage);
        // this.arlTableComponent.detailRows.forEach(row => {
        //     row.arlCalculationViewComponent.setZuschlInPercent($event.arlType, $event.percentage);
        // })
    }

    protected readonly getInvoicenumerErrorMessage = (form: FormControl<string>) => {
        if (form.hasError('consolidatedInvoiceIdNotAvailable')) {
            return this.LedgerImportDocTypeName$.value + 'snummer/ -bezeichnung' + ' ist bereits vorhanden.';
        } else {
            return getErrorMessage(form);
        }
    };

    public LvFilterSettings$: Observable<FilterOption[]> = of([
        {
            Name: FilterTypes.Gaps,
            Type: FILTER_TYPE_BOOLEAN,
            Label: "Alle Positionen mit Lücken",
        },
        {
            Name: FilterTypes.UnfilledGaps,
            Type: FILTER_TYPE_BOOLEAN,
            Label: "Positionen mit nicht gefüllten Lücken",
        },
        {
            Name: FilterTypes.FilledGaps,
            Type: FILTER_TYPE_BOOLEAN,
            Label: "Positionen gefüllten Lücken",
        },
        {
            Name: FilterTypes.WithoutPrices,
            Type: FILTER_TYPE_BOOLEAN,
            Label: "Positionen ohne Preise",
        },
    ]);

    onFilterValuesChange(values: {
        [FilterTypes.Gaps]: boolean;
        [FilterTypes.UnfilledGaps]: boolean;
        [FilterTypes.FilledGaps]: boolean;
        [FilterTypes.WithoutPrices]: boolean;
    }) {
        const prev = this.LvFilterValues$.getValue();
        const updated = {...values};

        const changedKey = Object.keys(values).find(
            key => values[key] !== prev[key]
        ) as FilterTypes;

        if (changedKey && updated[changedKey]) {
            Object.keys(updated).forEach(key => {
                if (key !== changedKey) {
                    updated[key] = false;
                }
            });
        }

        this.LvFilterValues$.next(updated);
    }

    protected async ReSortArls() {
        this.dialog
            .open<AppConfirmationDialogComponent, AppConfirmationDialogData>(
                AppConfirmationDialogComponent,
                {
                    data: {
                        paragraph: 'Sollen die Positionsnummern wirklich neu sortiert werden?',
                    },
                },
            )
            .afterClosed()
            .pipe(
                filter(([response]) => response === true),
                tap(async () => {
                    if (this.arlTableComponent) {
                        this.arlTableComponent.triggerPositionCalculation(true);
                    } else {
                        const data = await firstValueFrom(
                            this.arlLvCalculationComponent.dataSource.data$
                        );

                        const dataSource = this.arlLvCalculationComponent.dataSource;

                        recalculateItemNumbersFromLvTableItems(
                            data,
                            false,
                            true,
                            () => dataSource.notifyItemNumberRecalculated(),
                        );
                    }
                }),
            ).subscribe();

    }
    insertTemplate(form: FormControl<string>,
                   textarea?: HTMLTextAreaElement | null,) {
        addTemplate(this.dialog, form, textarea);
    }

    protected toggleArlMultiselect() {
        this.arlMultiselectActive = !this.arlMultiselectActive;
    }

    protected readonly invoiceEditorAutoScrollSpeed = invoiceEditorAutoScrollSpeed;
    setReciplientCustomer(customer: CustomerEntity) {
        const office = customer?.Offices?.[0] ?? null;
        this.InfoiceFormGroup.controls.CustomerName.setValue(customer.Name + (customer.Description ? '\n' + customer.Description : ''));
        this.InfoiceFormGroup.controls.CustomerStreet.setValue(office?.Street ? office.Street : null);
        this.InfoiceFormGroup.controls.CustomerPostalCode.setValue(office?.PostalCode ? office.PostalCode : null);
        this.InfoiceFormGroup.controls.CustomerCity.setValue(office?.City ? office.City : null);
        this.InfoiceFormGroup.controls.CustomerNumber.setValue(customer.CustomerNo);
        this.InfoiceFormGroup.controls.CustomerUstId.setValue(customer.UstId);
    }
    recipientPanelOpened() {
        this.initCustomerSearchForReciplintData();
    }
    private customerSearchForReciplintDataInited = false;
    private initCustomerSearchForReciplintData() {
        if (!this.customerSearchForReciplintDataInited) {
            this.customerSearchForReciplintDataInited = true;
            this.customerSearchForReciplintData.fetchFirstPage();
        }
    }
}

function onScroll(scrollContainer: HTMLElement, event: Event) {
    const fixWrapper = document.getElementById('arlTableFixWrapper');
    // Get Distance from arlTable for Top & Bottom
    const arlTableHeader = document.getElementById('arlTableHeader');
    const arlTableContent = document.getElementById('arlTableContent');
    const arlTableHeaderPlaceholder = document.getElementById('arlTableHeaderPlaceholder');
    const arlTableHeaderWrapper = document.getElementById('arlTableHeaderWrapper'); //only in lv kalkulation

    // lv kalkulation
    const arlTableHeaderWrapperPos = document.getElementById('arlTableHeaderWrapperPos');
    const isLv = !!arlTableHeaderWrapperPos;

    const distanceToPage = scrollContainer.getBoundingClientRect();
    const distanceFromTableContent = arlTableContent.getBoundingClientRect();


    // Make arlTable sticky when arlTable in Focus
    if (distanceFromTableContent.bottom - distanceToPage.top > arlTableHeader.offsetHeight) {
        arlTableHeader.style.position = 'sticky';
        if (isLv) {
            const arlTableHeaderWrapperPosBound = arlTableHeaderWrapperPos.getBoundingClientRect();
            const fixWrapperBound = fixWrapper.getBoundingClientRect();
            if (distanceToPage.top + arlTableHeader.offsetHeight > arlTableHeaderWrapperPosBound.top + 1) {
                arlTableHeaderWrapper.style.top = distanceToPage.top + arlTableHeader.offsetHeight - fixWrapperBound.top + 'px';
                arlTableHeaderWrapper.style.position = 'absolute';
                arlTableHeaderPlaceholder.style.display = 'block';
            } else {
                arlTableHeaderWrapper.style.position = 'static';
                arlTableHeaderPlaceholder.style.display = 'none';
            }
        }
    }
    // Unsticky arlTable when arlTable not in Focus
    else {
        arlTableHeader.style.position = 'relative';
        if (arlTableHeaderWrapper) {
            arlTableHeaderWrapper.style.position = 'static';
        }
        arlTableHeaderPlaceholder.style.display = 'none';
    }
}

function scrollTo(selector: string) {
    const target = document.querySelector(selector);
    const container = document.getElementById('editBillScreen');
    if (!target) {
        console.error('target not found: ' + selector);
        return;
    }
    if (target.getBoundingClientRect().top - container.getBoundingClientRect().top < 0) {
        target.scrollIntoView(true);
    }
}

